(function() {
  'use strict';

  // Config injected by the section's Liquid bootstrap (window.PROLITE_EST_CFG).
  var _cfg = (window.PROLITE_EST_CFG || {});
  var MEMORIAL_FLOW_VERSION = _cfg.memorialFlowVersion || 'legacy';
  var MEMORIAL_OWN_ROD_PATH = (_cfg.memorialOwnRodPath === true);
  var FLY_FLOW_VERSION = _cfg.flyFlowVersion || 'legacy';
  var MEMORIAL_FEE_CENTS = (typeof _cfg.memorialFeeCents === 'number' ? _cfg.memorialFeeCents : 19900);
  var MEMORIAL_FEE_DOLLARS = Math.round(MEMORIAL_FEE_CENTS / 100);
  var SECTION_DEFAULT_FISHERY = _cfg.defaultFisheryId || 'general';

  var fisheryAttribution = { fishery_id: '', region: '' };

  try {
    var storedRegion = sessionStorage.getItem('prolite_fishery_context');
    if (storedRegion) {
      var parsedRegion = JSON.parse(storedRegion);
      fisheryAttribution.region = parsedRegion.region || '';
    }
  } catch(e) {}

  if (SECTION_DEFAULT_FISHERY === 'memorial') {
    fisheryAttribution.fishery_id = 'memorial';
  } else if (SECTION_DEFAULT_FISHERY === 'inherit') {
    try {
      var storedFishery = sessionStorage.getItem('prolite_fishery_context');
      if (storedFishery) {
        var parsedFishery = JSON.parse(storedFishery);
        fisheryAttribution.fishery_id = parsedFishery.fishery_id || '';
      }
    } catch(e) {}
  }

  var estParams = new URLSearchParams(window.location.search);
  if (estParams.get('fishery_id')) fisheryAttribution.fishery_id = estParams.get('fishery_id');
  if (estParams.get('region'))     fisheryAttribution.region     = estParams.get('region');

  var urlTargetSpecies = estParams.get('target_species') || '';
  var urlFisheryName   = estParams.get('fishery_name')   || '';


  window.dataLayer = window.dataLayer || [];
  function pushEvent(name, data) {
    var payload = { event: name, page_path: window.location.pathname };
    payload.fishery = fisheryAttribution.fishery_id;
    payload.region = fisheryAttribution.region;
    if (data) { for (var k in data) { if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k]; } }
    window.dataLayer.push(payload);
    var ga4Data = { fishery: fisheryAttribution.fishery_id, region: fisheryAttribution.region };
    if (data) { for (var k in data) { if (Object.prototype.hasOwnProperty.call(data, k)) ga4Data[k] = data[k]; } }
    if (typeof gtag === 'function') { gtag('event', name, ga4Data); }
  }

  function getRodSpecParams() {
    var v = state.values;
    var params = {
      target_species: v.target_species || '',
      technique: v.technique || '',
      rod_length: v.rod_length || '',
      power: v.power || '',
      action_feel: v.action_feel || '',
      grip_material: v.grip_material || '',
      guide_material: v.guide_material || '',
      reel_seat_type: v.reel_seat_type || '',
      rod_format: v.rod_format || '',
      customization_level: isMemorial ? 'Full Custom Art (Memorial)' : (v.customization_level || '')
    };
    if (isMemorial) {
      params.memorial_honoree = v.memorial_honoree || '';
      params.memorial_water = v.memorial_water || '';
      params.memorial_features = Array.isArray(v.memorial_features) ? v.memorial_features.join(', ') : '';
      params.memorial_rod_source = v.memorial_rod_source || 'new_build';
      params.memorial_own_rod_details = v.memorial_own_rod_details || '';
      params.build_type = (v.memorial_rod_source === 'own_rod') ? 'memorial_own_rod' : 'memorial';
    }
    if (isFlyV2) {
      params.fly_rod_class = v.fly_rod_class || '';
      params.line_weight = v.line_weight || '';
      params.grip_shape = v.grip_shape || '';
      params.fighting_butt = v.fighting_butt || '';
      params.build_type = 'fly';
    }
    return params;
  }

  function pushConversion(eventName, data, conversionValue, userData) {
    var payload = { event: eventName, page_path: window.location.pathname };
    payload.fishery = fisheryAttribution.fishery_id;
    payload.region = fisheryAttribution.region;
    if (data) { for (var k in data) { if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k]; } }
    payload.conversion_value = conversionValue;
    payload.currency = 'USD';
    window.dataLayer.push(payload);

    if (userData && typeof gtag === 'function') {
      var ud = {};
      if (userData.email) ud.email = userData.email.trim().toLowerCase();
      if (userData.phone) ud.phone_number = userData.phone.trim();
      if (userData.first_name || userData.last_name) {
        ud.address = {};
        if (userData.first_name) ud.address.first_name = userData.first_name.trim().toLowerCase();
        if (userData.last_name) ud.address.last_name = userData.last_name.trim().toLowerCase();
      }
      window.dataLayer.push({ user_data: ud });
    }

    if (typeof gtag === 'function') {
      var ga4Data = { fishery: fisheryAttribution.fishery_id, region: fisheryAttribution.region };
      if (data) { for (var k in data) { if (Object.prototype.hasOwnProperty.call(data, k)) ga4Data[k] = data[k]; } }
      ga4Data.value = conversionValue;
      ga4Data.currency = 'USD';
      gtag('event', eventName, ga4Data);
    }

  }

  var flyRodLengthRanges = {
    'Single-Hand': [
      { label: "Short (6'6\" – 7'9\")", value: 'fly_short', lengths: ["6'6\"","7'0\"","7'6\"","7'9\""] },
      { label: "8'0\" – 8'6\"",          value: 'fly_8',     lengths: ["8'0\"","8'6\""] },
      { label: "9'0\" (standard)",         value: 'fly_9',     lengths: ["9'0\""] },
      { label: "10'0\" Nymphing",          value: 'fly_10',    lengths: ["10'0\"","10'6\"","11'0\""] }
    ],
    'Switch': [
      { label: "10'6\" – 11'0\"", value: 'switch_all', lengths: ["10'6\"","11'0\""] }
    ],
    'Spey': [
      { label: "Compact Spey (11'6\" – 12'6\")", value: 'spey_short', lengths: ["11'6\"","12'0\"","12'6\""] },
      { label: "Standard Spey (13'0\" – 13'6\")", value: 'spey_std',   lengths: ["13'0\"","13'3\"","13'6\""] },
      { label: "Long Spey (14'0\")",                       value: 'spey_long',  lengths: ["14'0\""] }
    ]
  };

  var FLY_BLANK_MATRIX = {
    '2wt':  ["6'6\""],
    '3wt':  ["6'6\"","7'0\"","7'9\"","8'6\"","9'0\"","10'6\"","11'0\""],
    '4wt':  ["7'0\"","7'6\"","7'9\"","8'0\"","8'6\"","9'0\"","10'6\"","11'0\""],
    '5wt':  ["8'0\"","8'6\"","9'0\"","10'0\""],
    '6wt':  ["9'0\"","10'0\""],
    '7wt':  ["9'0\"","10'0\""],
    '8wt':  ["9'0\"","10'0\""],
    '9wt':  ["9'0\"","10'0\""],
    '10wt': ["9'0\""],
    '12wt': ["9'0\""]
  };

  var isMemorial = fisheryAttribution.fishery_id === 'memorial';
  var isFly = fisheryAttribution.fishery_id === 'fly';
  var isFlyV2 = isFly && FLY_FLOW_VERSION === 'v2';

  // True once a memorial customer has chosen to add the memorial to a rod they
  // already own (vs. commissioning a new build). The rod exists, so this path
  // skips every build-spec step and routes straight to the builder handoff with
  // no build-price estimate. Gated behind the memorial_own_rod_path setting.
  function isOwnRodPath() {
    return isMemorial && MEMORIAL_OWN_ROD_PATH && state.values.memorial_rod_source === 'own_rod';
  }

  function getRegionalSpecies(region) {
    if (!region) return null;
    var map = {
      'Pacific Northwest': ['Salmon','Steelhead','Trout','Halibut','Sturgeon','Bass','Multi-species','Other'],
      'West Coast':        ['Halibut','Yellowtail','White Seabass','Calico Bass','Striped Bass','Yellowfin Tuna','Bluefin Tuna','Bass','Trout','Multi-species','Other'],
      'Mountain West':     ['Trout','Bass','Walleye','Pike','Multi-species','Other'],
      'Midwest':           ['Bass','Walleye','Musky','Pike','Trout','Multi-species','Other'],
      'Great Lakes':       ['Salmon','Steelhead','Walleye','Musky','Pike','Bass','Trout','Multi-species','Other'],
      'Northeast':         ['Striped Bass','Bluefin Tuna','Yellowfin Tuna','Mahi / Dorado','Trout','Bass','Flounder','Multi-species','Other'],
      'Southeast':         ['Redfish','Snook','Tarpon','Speckled Trout','Flounder','Permit','Bonefish','Bass','Multi-species','Other'],
      'Gulf Coast':        ['Redfish','Snook','Tarpon','Speckled Trout','Flounder','Yellowfin Tuna','Mahi / Dorado','Multi-species','Other']
    };
    return map[region] || null;
  }

  var TECHNIQUE_MATRIX = {
    'Pacific Northwest': {
      'Salmon':        ['Mooching','Trolling','Downrigger','Casting','Float fishing'],
      'Steelhead':     ['Centerpin','Float fishing','Twitching','Fly','Spinning'],
      'Halibut':       ['Bottom Fishing','Jigging','Downrigger'],
      'Trout':         ['Fly','Spinning','Casting','Wade Fishing'],
      'Sturgeon':      ['Bottom Fishing','Live Bait'],
      'Bass':          ['Casting','Spinning','Dock / Structure']
    },
    'West Coast': {
      'Halibut':       ['Bottom Fishing','Live Bait','Jigging'],
      'Yellowtail':    ['Live Bait','Jigging','Trolling','Long-Range Offshore'],
      'White Seabass': ['Live Bait','Trolling','Long-Range Offshore'],
      'Calico Bass':   ['Casting','Live Bait','Jigging','Dock / Structure'],
      'Striped Bass':  ['Trolling','Live Bait','Jigging','Casting'],
      'Yellowfin Tuna':['Live Bait','Long-Range Offshore','Trolling','Jigging'],
      'Bluefin Tuna':  ['Long-Range Offshore','Live Bait','Jigging','Trolling'],
      'Bass':          ['Casting','Spinning','Dock / Structure'],
      'Trout':         ['Fly','Spinning','Casting']
    },
    'Mountain West': {
      'Trout':         ['Fly','Wade Fishing','Spinning','Casting'],
      'Bass':          ['Casting','Spinning','Dock / Structure','Fly'],
      'Walleye':       ['Trolling','Jigging','Live Bait','Casting'],
      'Pike':          ['Casting','Trolling','Live Bait','Fly']
    },
    'Midwest': {
      'Bass':          ['Casting','Spinning','Dock / Structure','Fly'],
      'Walleye':       ['Trolling','Jigging','Live Bait','Casting'],
      'Musky':         ['Casting','Trolling','Live Bait'],
      'Pike':          ['Casting','Trolling','Live Bait','Fly'],
      'Trout':         ['Fly','Wade Fishing','Spinning']
    },
    'Great Lakes': {
      'Salmon':        ['Trolling','Downrigger','Casting','Float fishing'],
      'Steelhead':     ['Float fishing','Centerpin','Fly','Spinning','Casting'],
      'Walleye':       ['Trolling','Jigging','Live Bait','Casting'],
      'Musky':         ['Casting','Trolling','Live Bait'],
      'Pike':          ['Casting','Trolling','Live Bait','Fly'],
      'Bass':          ['Casting','Spinning','Dock / Structure','Fly'],
      'Trout':         ['Fly','Spinning','Wade Fishing','Casting']
    },
    'Northeast': {
      'Striped Bass':  ['Surf','Casting','Live Bait','Trolling','Jigging'],
      'Bluefin Tuna':  ['Live Bait','Long-Range Offshore','Jigging','Trolling'],
      'Yellowfin Tuna':['Live Bait','Long-Range Offshore','Trolling','Jigging'],
      'Mahi / Dorado': ['Live Bait','Trolling','Casting'],
      'Trout':         ['Fly','Wade Fishing','Spinning'],
      'Bass':          ['Casting','Spinning','Dock / Structure','Fly'],
      'Flounder':      ['Bottom Fishing','Live Bait','Jigging']
    },
    'Southeast': {
      'Redfish':       ['Sight-Casting','Flats Fishing','Casting','Live Bait','Wade Fishing'],
      'Snook':         ['Sight-Casting','Casting','Live Bait','Dock / Structure','Flats Fishing'],
      'Tarpon':        ['Sight-Casting','Flats Fishing','Live Bait','Fly'],
      'Speckled Trout':['Casting','Wade Fishing','Live Bait','Flats Fishing'],
      'Flounder':      ['Bottom Fishing','Live Bait','Jigging'],
      'Permit':        ['Sight-Casting','Flats Fishing','Fly'],
      'Bonefish':      ['Sight-Casting','Flats Fishing','Fly','Wade Fishing'],
      'Bass':          ['Casting','Spinning','Dock / Structure','Flats Fishing']
    },
    'Gulf Coast': {
      'Redfish':       ['Sight-Casting','Flats Fishing','Casting','Live Bait','Wade Fishing'],
      'Snook':         ['Sight-Casting','Casting','Live Bait','Dock / Structure','Flats Fishing'],
      'Tarpon':        ['Sight-Casting','Flats Fishing','Live Bait','Fly'],
      'Speckled Trout':['Casting','Wade Fishing','Live Bait','Flats Fishing'],
      'Flounder':      ['Bottom Fishing','Live Bait','Jigging'],
      'Yellowfin Tuna':['Live Bait','Long-Range Offshore','Trolling','Jigging'],
      'Mahi / Dorado': ['Live Bait','Trolling','Casting']
    }
  };

  function getTechniquesForRegionSpecies(region, species) {
    if (!region || !species) return null;
    var matrix = TECHNIQUE_MATRIX[region];
    if (!matrix) return null;
    return matrix[species] || null;
  }

  var FLY_TECHNIQUE_BY_REGION = {
    'Pacific Northwest': ['Dry Fly','Nymphing','Indicator Nymphing','Streamer','Swing / Wet Fly','Spey / Two-Hand','Big-Water Streamer','Stillwater','Other'],
    'West Coast':        ['Dry Fly','Nymphing','Indicator Nymphing','Euro / Tight-Line Nymph','Streamer','Saltwater Surf','Saltwater Flats / Sight-Cast','Stillwater','Carp / Pike / Musky on the Fly','Other'],
    'Gulf Coast':        ['Saltwater Flats / Sight-Cast','Saltwater Surf','Streamer','Big-Water Streamer','Other'],
    'Southeast':         ['Dry Fly','Nymphing','Indicator Nymphing','Euro / Tight-Line Nymph','Streamer','Saltwater Flats / Sight-Cast','Saltwater Surf','Stillwater','Carp / Pike / Musky on the Fly','Other'],
    'Northeast':         ['Dry Fly','Nymphing','Indicator Nymphing','Euro / Tight-Line Nymph','Streamer','Swing / Wet Fly','Spey / Two-Hand','Saltwater Flats / Sight-Cast','Saltwater Surf','Stillwater','Carp / Pike / Musky on the Fly','Other'],
    'Great Lakes':       ['Dry Fly','Nymphing','Indicator Nymphing','Euro / Tight-Line Nymph','Streamer','Swing / Wet Fly','Spey / Two-Hand','Big-Water Streamer','Stillwater','Carp / Pike / Musky on the Fly','Other'],
    'Midwest':           ['Dry Fly','Nymphing','Indicator Nymphing','Euro / Tight-Line Nymph','Streamer','Big-Water Streamer','Stillwater','Carp / Pike / Musky on the Fly','Other'],
    'Mountain West':     ['Dry Fly','Nymphing','Indicator Nymphing','Euro / Tight-Line Nymph','Streamer','Swing / Wet Fly','Spey / Two-Hand','Big-Water Streamer','Stillwater','Carp / Pike / Musky on the Fly','Other']
  };

  function getFlyTechniquesForRegion(region) {
    if (!region) return null;
    return FLY_TECHNIQUE_BY_REGION[region] || null;
  }

  var buildPresets = {
    memorial_builder_guided: {
      target_species:      'Trout',
      technique:           'Spinning',
      rod_length:          "6'6\"",
      power:               'Light',
      action_feel:         'Moderate',
      grip_material:       'Cork',
      guide_material:      'Black Stainless Steel',
      reel_seat_type:      'Graphite',
      wrap_level:          1,
      customization_level: 'Clean Build',
      priorities:          ['Honoring the memory faithfully']
    }
  };

  var steps = [
    {
      id: 'region',
      phase: 'Getting Started',
      category: 'Your Region',
      question: 'Where are you fishing?',
      options: [
        'Pacific Northwest',
        'West Coast',
        'Gulf Coast',
        'Southeast',
        'Northeast',
        'Great Lakes',
        'Midwest',
        'Mountain West',
        'Other'
      ],
      cols: 2,
      motivation: 'Helps us match you with a builder who knows your water.',
      conditional: function() {
        return !isMemorial && !fisheryAttribution.region;
      }
    },
    {
      id: 'memorial_rod_source',
      type: 'path_picker',
      phase: 'Memorial Rod',
      category: 'Choose Your Path',
      question: 'How would you like to honor them?',
      options: [
        {
          value: 'new_build',
          label: 'Build a memorial rod',
          desc: 'We design and handcraft a new rod around who they were and how they fished.',
          duration: 'New custom rod'
        },
        {
          value: 'own_rod',
          label: 'Add a memorial to a rod I own',
          desc: "Send us a rod you already have — your builder confirms what's possible and works the memorial into it.",
          duration: 'Your existing rod'
        }
      ],
      motivation: '',
      conditional: function() { return isMemorial && MEMORIAL_OWN_ROD_PATH; }
    },
    {
      id: 'memorial_path',
      type: 'path_picker',
      phase: 'Memorial Build',
      category: 'Choose Your Path',
      question: 'A rod that honors them — built your way.',
      options: [
        {
          value: 'full',
          label: 'Tell me your story',
          desc: "Seven short steps. We'll shape the rod around who they were and how they fished.",
          duration: '~4 minutes'
        },
        {
          value: 'guided',
          label: 'Let our builder craft it',
          desc: "Share who it honors and their water. We'll take it from there.",
          duration: '~90 seconds'
        }
      ],
      motivation: '',
      conditional: function() { return isMemorial && MEMORIAL_FLOW_VERSION === 'v2' && !isOwnRodPath(); }
    },
    {
      id: 'memorial_honoree',
      phase: 'The Story',
      category: 'The Person',
      question: 'Who is this rod honoring?',
      type: 'text_input',
      placeholder: 'My father, John — he taught me to fish the Puget Sound...',
      optional: false,
      motivation: "Take your time. This is the most important part.",
      conditional: function() { return isMemorial; }
    },
    {
      id: 'memorial_water',
      phase: 'The Story',
      category: 'Their Water',
      question: 'What water did they love?',
      type: 'text_input',
      placeholder: 'A specific river, lake, bay, or just the type of water...',
      optional: true,
      motivation: "Helps us match the rod to the fishery they loved.",
      conditional: function() { return isMemorial; }
    },
    {
      id: 'memorial_features',
      phase: 'The Story',
      category: 'Personalization',
      question: 'What should this rod carry?',
      type: 'multi_select',
      maxSelect: 5,
      options: [
        { value: 'Custom engraving', label: 'Custom Engraving', desc: 'Name, date, or message on the rod' },
        { value: 'Handwritten inscription', label: 'Handwritten Note', desc: "Their actual handwriting — a signature, a line, or a short note — transferred under the clearcoat" },
        { value: 'Personalized wrap colors', label: 'Personalized Wraps', desc: 'Thread colors with personal meaning' },
        { value: 'Mini urn integration', label: 'Ash Inlay', desc: 'Ashes cast into the epoxy coat on the rod itself' },
        { value: 'GPS coordinates', label: 'GPS Coordinates', desc: 'Their favorite water engraved on the butt cap or reel seat ring' },
        { value: 'Embedded keepsake', label: 'Embedded Keepsake', desc: 'A meaningful object — piece of a favorite lure, a fly they tied, a feather — cast into the rod' },
        { value: 'Fingerprint', label: 'Fingerprint', desc: 'Their fingerprint engraved or cast into the reel seat or epoxy' },
        { value: 'Photo or image reference', label: 'Photo / Image', desc: 'Reference image for custom art' },
        { value: 'Tell me what is possible', label: "Help Me Decide", desc: "I'd like guidance on what's possible" }
      ],
      cols: 1,
      motivation: 'Select everything that matters. Your builder will help refine.',
      conditional: function() { return isMemorial; }
    },
    {
      id: 'memorial_own_rod_details',
      phase: 'Your Rod',
      category: 'The Rod',
      question: 'Tell us about the rod you\'d like us to work on',
      type: 'text_input',
      placeholder: 'Make, model, length — and anything we should know about its condition.',
      optional: true,
      motivation: "Your builder will confirm what's possible for your rod on the consult.",
      conditional: function() { return isOwnRodPath(); }
    },
    {
      id: 'target_species',
      phase: isFlyV2 ? 'Your Fly Fishery' : 'The Build',
      category: 'The Fishery',
      question: isMemorial ? 'What will you fish for with this rod?' : (isFlyV2 ? 'What fly species are you targeting?' : 'What species are you targeting?'),
      options: isMemorial
        ? ['Salmon','Steelhead','Trout','Halibut','Sturgeon','Bass','Redfish','Snook','Tarpon','Multi-species',"Builder's choice",'Other']
        : isFlyV2
          ? ['Trout','Steelhead','Salmon','Bass','Pike','Musky','Carp','Bonefish','Permit','Tarpon','Redfish','Snook','Striped Bass','Multi-species','Other']
          : ['Salmon','Steelhead','Trout','Halibut','Sturgeon','Bass','Redfish','Snook','Tarpon','Speckled Trout','Flounder','Yellowtail','Bluefin Tuna','Yellowfin Tuna','Mahi / Dorado','White Seabass','Calico Bass','Striped Bass','Permit','Bonefish','Walleye','Musky','Pike','Multi-species','Other'],
      cols: 2,
      motivation: isMemorial ? "What species will this rod be used for?" : "Let's start with the basics.",
      conditional: function() { return (isMemorial || !state.values.target_species) && !isOwnRodPath(); }
    },
    {
      id: 'fly_rod_class',
      phase: 'Your Fly Fishery',
      category: 'Rod Class',
      question: 'What kind of fly rod is this?',
      options: [
        { value: 'Single-Hand', label: 'Single-Hand', desc: 'Traditional one-hand cast — trout, bass, saltwater' },
        { value: 'Switch',      label: 'Switch',      desc: "10'6\" – 11'6\", two-hand or single-hand spey casts" },
        { value: 'Spey',        label: 'Spey',        desc: "11'6\" – 14', two-hand for steelhead and salmon swinging" }
      ],
      cols: 1,
      motivation: 'This drives length, line weight, and grip options.',
      conditional: function() { return isFlyV2; }
    },
    {
      id: 'technique',
      phase: isMemorial ? 'The Build' : (isFlyV2 ? 'Your Fly Fishery' : 'Your Fishery'),
      category: isMemorial ? 'The Fishery' : 'Your Fishing Style',
      question: isMemorial ? 'What technique will you use?' : (isFlyV2 ? 'How will you primarily fish it?' : 'What technique do you primarily use?'),
      options: isMemorial
        ? ['Casting','Spinning','Trolling','Jigging','Fly','Float fishing','Surf',"Builder's choice",'Other']
        : isFlyV2
          ? ['Dry Fly','Nymphing','Indicator Nymphing','Euro / Tight-Line Nymph','Streamer','Swing / Wet Fly','Spey / Two-Hand','Saltwater Flats / Sight-Cast','Saltwater Surf','Big-Water Streamer','Stillwater','Carp / Pike / Musky on the Fly','Other']
          : ['Mooching','Trolling','Downrigger','Casting','Spinning','Float fishing','Jigging','Twitching','Centerpin','Surf','Fly','Wade Fishing','Sight-Casting','Flats Fishing','Kayak Fishing','Long-Range Offshore','Bottom Fishing','Live Bait','Dock / Structure','Other'],
      cols: 2,
      motivation: isMemorial ? 'This helps us spec the right blank and guides.' : 'Good. Now tell us how you fish.',
      conditional: function() { return !isOwnRodPath(); }
    },
    {
      id: 'water_location',
      phase: 'Your Fishery',
      category: 'Your Water',
      question: 'Where do you fish most?',
      type: 'text_input',
      placeholder: 'Baffin Bay, Mosquito Lagoon, San Diego, Puget Sound, local rivers...',
      optional: true,
      motivation: 'Optional. Helps us build for your specific water.',
      conditional: function() { return !isMemorial; }
    },
    {
      id: 'rod_length',
      phase: isMemorial ? 'The Build' : 'Rod Specs',
      category: 'Rod Specifications',
      question: 'What rod length are you thinking?',
      type: 'rod_length',
      cols: 2,
      motivation: 'Pick a common length, enter a specific length, or let Prolite recommend the right one based on how you fish.',
      conditional: function() {
        if (isOwnRodPath()) return false;
        if (!isFlyV2) return true;
        if (state.values.fly_rod_class !== 'Single-Hand') return true;
        if (state.values._rod_length_overridden) return true;
        if (state.values.rod_length === "9'0\"") return false;
        return true;
      }
    },
    {
      id: 'power',
      phase: isMemorial ? 'The Build' : 'Rod Specs',
      category: 'Rod Specifications',
      question: isMemorial ? 'What power do you need?' : 'What power do you need?',
      options: isMemorial
        ? ['Light','Medium Light','Medium','Medium Heavy','Heavy',"Builder's choice"]
        : ['Light','Medium Light','Medium','Medium Heavy','Heavy','Extra Heavy',
           { value: '__recommend__', label: 'Recommend the best fit for me', desc: 'Prolite matches the power to your species, technique, and water.' }],
      cols: 2,
      motivation: isMemorial ? "If you're not sure, Builder's choice works great." : 'Power affects blank selection and pricing.',
      conditional: function() { return !isFlyV2 && !isOwnRodPath(); }
    },
    {
      id: 'line_weight',
      phase: 'Rod Specs',
      category: 'Rod Specifications',
      question: 'What line weight will you cast?',
      options: [],
      cols: 3,
      motivation: 'Line weight drives blank selection and pricing.',
      conditional: function() { return isFlyV2; }
    },
    {
      id: 'action_feel',
      phase: 'Rod Specs',
      category: 'Rod Specifications',
      question: 'What action do you want?',
      options: isFlyV2
        ? [
            { value: 'Medium-Fast',    label: 'Medium-Fast',    desc: 'Versatile, all-around presentation' },
            { value: 'Fast',           label: 'Fast',           desc: 'Crisp tip, distance and wind' },
            { value: 'Xtra-Fast',      label: 'Xtra-Fast',      desc: 'Premium tracking, saltwater / big water' },
            { value: '__recommend__',  label: 'Recommend the best fit for me', desc: 'Prolite picks the action that suits how you fish.' }
          ]
        : [
            { value: 'Moderate', label: 'Moderate', desc: 'Slow, full bend' },
            { value: 'Moderate Fast', label: 'Moderate Fast', desc: 'Versatile, mid-bend' },
            { value: 'Fast', label: 'Fast', desc: 'Tip-driven, quick response' },
            { value: 'Extra Fast', label: 'Extra Fast', desc: 'Tip only, maximum sensitivity' },
            { value: '__recommend__', label: 'Recommend the best fit for me', desc: 'Prolite picks the action that suits how you fish.' }
          ],
      cols: 2,
      motivation: 'How do you want the rod to respond?',
      conditional: function() { return !isMemorial; }
    },
    {
      id: 'rod_format',
      phase: 'Rod Specs',
      category: 'Rod Specifications',
      question: isFlyV2 ? 'How many pieces?' : 'How will you transport this rod?',
      options: isFlyV2
        ? [
            { value: '2-Piece',        label: '2-Piece',        desc: 'Traditional, smoothest flex' },
            { value: '4-Piece',        label: '4-Piece',        desc: 'Industry standard — travel-friendly' }
          ]
        : [
            { value: 'One Piece', label: 'One Piece', desc: 'Standard single-piece build' },
            { value: '2-Piece', label: '2-Piece', desc: 'Two-piece for easier transport' },
            { value: 'Travel Multi-Piece', label: 'Travel Multi-Piece', desc: 'Multi-piece for travel and storage' }
          ],
      cols: 1,
      motivation: 'Format affects build complexity and pricing.',
      conditional: function() { return !isMemorial; }
    },
    {
      id: 'grip_material',
      phase: 'Components',
      category: 'Components',
      question: isMemorial ? 'What grip material do you prefer?' : 'What grip material do you prefer?',
      options: isMemorial
        ? [
            { value: 'Cork', label: 'Cork', desc: 'Classic feel, natural, warm in hand' },
            { value: 'EVA', label: 'EVA', desc: 'Lightweight, durable, easy to clean' },
            { value: 'Carbon', label: 'Carbon', desc: 'Lightweight, premium look and feel' },
            { value: "Builder's choice", label: "Builder's Choice", desc: 'Let your builder pick the best fit' }
          ]
        : isFlyV2
          ? [
              { value: 'Flor Grade Cork',       label: 'Flor Grade Cork',       desc: 'Top tier, tight grain \u2014 flagship feel and longest life.' },
              { value: 'Super Grade Cork',      label: 'Super Grade Cork',      desc: 'Premium clean cork \u2014 Prolite standard, excellent value.' },
              { value: "'A' Grade Cork",        label: "'A' Grade Cork",        desc: 'Classic warmth and clean appearance at a workhorse price.' },
              { value: 'Composite Cork',        label: 'Composite Cork',        desc: 'Durable, low-maintenance, consistent grain \u2014 great for travel.' },
              { value: 'EVA',                   label: 'EVA (Saltwater)',       desc: 'Saltwater-tough, easy to clean, no maintenance.' },
              { value: '__recommend__',         label: 'Let Prolite pick the grip', desc: 'Builder chooses the grade that fits your water and budget.' }
            ]
          : [
              { value: 'EVA', label: 'EVA', desc: 'Lightweight, durable, easy to clean \u2014 all-weather workhorse.' },
              { value: 'EVA + Shrink Wrap', label: 'EVA + Shrink Wrap', desc: 'EVA with heat-shrink overlay for extra bite when wet.' },
              { value: 'Cork', label: 'Cork', desc: 'Classic feel, warm in hand, traditional look \u2014 needs more care.' },
              { value: 'BattleOn EPDM', label: 'BattleOn EPDM', desc: 'Rugged rubber, weather-resistant, firm no-slip grip.' },
              { value: 'Carbon', label: 'Carbon', desc: 'Lightest stiff option, premium modern look \u2014 stays clean.' },
              { value: 'Texalium', label: 'Texalium', desc: 'Woven carbon-aluminum, high-end finish, statement piece.' },
              { value: 'Foam Core', label: 'Foam Core', desc: 'Ultra-light and sensitive \u2014 soft touch for finesse work.' },
              { value: 'Winn', label: 'Winn', desc: 'Tacky polymer, all-weather grip, no slip even soaking wet.' },
              { value: '__recommend__', label: 'Let Prolite pick the grip', desc: 'Builder picks a grip that fits how and where you fish.' }
            ],
      cols: isMemorial ? 1 : 2,
      motivation: isMemorial ? "Almost done \u2014 just a couple more." : "We're getting into the build details now.",
      conditional: function() { return !isMemorial; }
    },
    {
      id: 'grip_shape',
      phase: 'Components',
      category: 'Components',
      question: 'What grip shape?',
      options: [
        { value: 'Full-Wells',         label: 'Full-Wells',         desc: 'Best 6\u201312wt \u2014 distance casting, big flies, saltwater' },
        { value: 'Half-Wells',         label: 'Half-Wells',         desc: 'Best 2\u20136wt \u2014 versatile, all-around' },
        { value: 'Reverse Half-Wells', label: 'Reverse Half-Wells', desc: 'Spey / two-hand top grip' },
        { value: 'Spey Two-Hand',      label: 'Spey Two-Hand',      desc: 'Dedicated two-hand fore grip' },
        { value: '__recommend__',      label: 'Recommend the best fit for me', desc: 'Prolite matches the grip shape to your line weight and casting style.' }
      ],
      cols: 2,
      motivation: "Our rule of thumb: Half-Wells for 2\u20136wt, Full-Wells for 6\u201312wt.",
      conditional: function() {
        if (!isFlyV2) return false;
        if (state.values.fly_rod_class === 'Single-Hand' && !state.values._grip_shape_overridden) return false;
        return true;
      }
    },
    {
      id: 'guide_material',
      phase: 'Components',
      category: 'Components',
      question: 'What guide quality fits this build?',
      options: isFlyV2
        ? [
            { value: 'Standard',          label: 'Standard',          desc: 'Hard-chrome snake guides + aluminum-oxide stripper. Durable, slick under heavy use, great everyday value.' },
            { value: 'Premium',           label: 'Premium',           desc: 'Hard-chrome snake guides + zirconia stripper. Smoother shoot, premium feel, longer life on braid.' },
            { value: 'Saltwater Premium', label: 'Saltwater Premium', desc: 'Ti Chrome snake guides + zirconia stripper. Corrosion-resistant for salt and heavy lines.' },
            { value: '__recommend__',     label: 'Let Prolite pick guides', desc: 'Builder selects frame and inserts that match the rod’s water, weight, and use.' }
          ]
        : [
            { value: 'Black Stainless Steel',    label: 'Black Stainless Steel',    desc: 'Matte black frames with hard inserts. Strong, corrosion-resistant, understated look.' },
            { value: 'Polished Stainless Steel', label: 'Polished Stainless Steel', desc: 'Classic chrome frames with aluminum-oxide inserts. Bright, durable, time-tested.' },
            { value: 'Titanium',                 label: 'Titanium',                 desc: 'Lightest frames Batson offers, paired with premium inserts. Maximum sensitivity, saltwater-grade.' },
            { value: '__recommend__',            label: 'Let Prolite pick guides',  desc: 'Builder selects frame and inserts that match the rod’s water, weight, and use.' }
          ],
      cols: 1,
      motivation: 'Almost there \u2014 just a few more details.',
      conditional: function() { return !isMemorial; }
    },
    {
      id: 'reel_seat_type',
      phase: 'Components',
      category: 'Components',
      question: 'What reel seat do you want?',
      options: isFlyV2
        ? [
            { value: 'Locking',                  label: 'Locking (standard)',         desc: 'ALPS RA-series \u2014 classic down-lock for light line, dual-lock 5wt+.' },
            { value: 'Slide-Band',               label: 'Slide-Band',                 desc: 'Light and traditional \u2014 best for ultra-light line and small reels.' },
            { value: 'Skeleton with Wood Insert',label: 'Skeleton with Wood Insert',  desc: 'Premium freshwater \u2014 Birdseye Maple, Rosewood, or Teak insert.' },
            { value: 'All-Aluminum Saltwater',   label: 'All-Aluminum (Saltwater)',   desc: 'Anodized aluminum, fully sealed for salt and heavy reels.' },
            { value: '__recommend__',            label: 'Let Prolite pick the seat',  desc: 'Builder matches the seat to your line weight and water.' }
          ]
        : [
            { value: 'Graphite', label: 'Graphite', desc: 'Lightest option \u2014 sensitive, great for finesse and trout builds.' },
            { value: 'Graphite + Aluminum Nut', label: 'Graphite + Aluminum Hood', desc: 'Light body with a secure aluminum locking hood \u2014 best balance.' },
            { value: 'Aluminum', label: 'Full Aluminum', desc: 'Maximum lock-down and durability for heavy-duty and saltwater use.' },
            { value: '__recommend__', label: 'Let Prolite pick the seat', desc: 'Builder picks the seat that matches your reel size and water.' }
          ],
      cols: 1,
      motivation: 'The reel seat affects weight, sensitivity, and how securely your reel locks in.',
      conditional: function() { return !isMemorial; }
    },
    {
      id: 'wrap_level',
      phase: 'Customization',
      category: 'Customization',
      question: 'How much wrap detail do you want?',
      options: [
        { value: 1, label: 'Solid',              desc: 'One solid wrap color — clean and timeless.' },
        { value: 2, label: 'Solid + trim bands', desc: 'One color plus trim bands at the ferrule and decal.' },
        { value: 3, label: 'Detailed',           desc: 'Accent bands, dual-color sections, basic patterns.' },
        { value: 4, label: 'Advanced',           desc: 'Multi-color wraps with deeper detailing.' },
        { value: 5, label: 'Custom',             desc: 'Show-quality intricate wraps — full custom artistry.' },
        { value: '__recommend__', label: 'Let Prolite keep it clean', desc: 'Builder picks a tasteful default that fits the rod.' }
      ],
      cols: 1,
      motivation: 'Last section \u2014 this is the fun one.',
      conditional: function() { return !isMemorial; }
    },
    {
      id: 'priorities',
      phase: isMemorial ? 'The Build' : 'Customization',
      category: isMemorial ? 'What Matters Most' : 'Customization',
      question: isMemorial ? 'What matters most for this build?' : 'What matters most to you?',
      type: 'multi_select',
      maxSelect: isMemorial ? 2 : 1,
      autoAdvance: !isMemorial,
      options: isMemorial
        ? [
            'Honoring the memory faithfully',
            'A rod I will actually fish',
            'Heirloom quality to pass down',
            'A gift that will move someone',
            'Best overall value',
            'I need guidance'
          ]
        : isFlyV2
          ? [
              'Casting accuracy at distance',
              'Delicate presentation',
              'Wind cutting / saltwater power',
              'Light tippet protection',
              'Premium custom look',
              'Best overall value',
              'Need help choosing'
            ]
          : [
              'Best performance for my fishery',
              'Lightest feel possible',
              'Strongest and toughest setup',
              'Premium custom look',
              'Best overall value',
              'Need help choosing'
            ],
      cols: 2,
      motivation: isMemorial ? 'Pick up to 2. This shapes how we approach the build.' : 'Tap the one that matters most.',
      conditional: function() { return !isOwnRodPath(); }
    }
  ];


  var state = {
    currentStep: 0,
    values: {
      fighting_butt: 'No'
    },
    estimateResult: null,
    selectedRange: null,
    intents: {} // per-question intent: specific | recommend | custom | skip
  };

  if (urlTargetSpecies) state.values.target_species = urlTargetSpecies;
  if (urlFisheryName)   state.values._fishery_name  = urlFisheryName;

  var overlay = document.getElementById('plrt-est-overlay');
  var dialog = document.getElementById('plrt-est-dialog');
  var rightPanel = document.getElementById('plrt-est-right');
  var progressFill = document.getElementById('plrt-est-progress');
  var stepCount = document.getElementById('plrt-est-step-count');
  var motivation = document.getElementById('plrt-est-motivation');
  var heroEl = document.getElementById('plrt-est-hero');
  var resultsEl = null; // Results now inside modal panels
  var openBtn = document.getElementById('plrt-est-open-btn');
  var closeBtn = document.getElementById('plrt-est-close-btn');
  var redoBtn = document.getElementById('plrt-est-redo-btn');

  function generateEstimateId() {
    var now = new Date();
    var year = now.getFullYear();
    var month = String(now.getMonth() + 1).padStart(2, '0');
    var day = String(now.getDate()).padStart(2, '0');
    var hours = String(now.getHours()).padStart(2, '0');
    var mins = String(now.getMinutes()).padStart(2, '0');
    var random = Math.floor(1000 + Math.random() * 9000);
    return 'EST-' + year + month + day + '-' + hours + mins + '-' + random;
  }

  function getStoredEstimateId() {
    var key = 'prolite_quote_estimate_id_v2';
    var stored = sessionStorage.getItem(key);
    if (stored) return stored;
    var created = generateEstimateId();
    sessionStorage.setItem(key, created);
    return created;
  }

  function parseRodLengthInches(lengthText) {
    if (!lengthText) return 0;
    var match = String(lengthText).match(/(\d+)'(\d+)/);
    if (!match) return 0;
    return (parseInt(match[1], 10) * 12) + parseInt(match[2], 10);
  }

  function roundToNearestFive(num) {
    return Math.round(num / 5) * 5;
  }

  function formatMoney(num) {
    return '$' + Number(num).toLocaleString();
  }

  function getBlankRange(lengthText, power) {
    var inches = parseRodLengthInches(lengthText);
    var low = 70;
    var high = 110;

    if (inches <= 72) {
      low = 65; high = 95;
    } else if (inches <= 84) {
      low = 75; high = 110;
    } else if (inches <= 96) {
      low = 90; high = 130;
    } else if (inches <= 108) {
      low = 105; high = 145;
    } else if (inches <= 120) {
      low = 120; high = 165;
    } else {
      low = 135; high = 185;
    }

    if (power === 'Medium Light') {
      low += 4; high += 8;
    } else if (power === 'Medium Heavy') {
      low += 8; high += 14;
    } else if (power === 'Heavy') {
      low += 16; high += 24;
    } else if (power === 'Extra Heavy') {
      low += 28; high += 40;
    } else if (power === 'Light') {
      low -= 5; high -= 8;
    }

    return { low: low, high: high };
  }

  function getGripRange(material) {
    var ranges = {
      'EVA': { low: 18, high: 28 },
      'EVA + Shrink Wrap': { low: 30, high: 46 },
      'Cork': { low: 28, high: 48 },
      'BattleOn EPDM': { low: 22, high: 34 },
      'Carbon': { low: 45, high: 70 },
      'Texalium': { low: 55, high: 85 },
      'Foam Core': { low: 26, high: 42 },
      'Winn': { low: 30, high: 48 }
    };

    var result = ranges[material] || { low: 20, high: 35 };

    return result;
  }

  function getGuideRange(material, lengthText) {
    var inches = parseRodLengthInches(lengthText);
    var longRod = inches >= 114;

    if (material === 'Titanium') {
      return longRod ? { low: 95, high: 135 } : { low: 85, high: 120 };
    }
    if (material === 'Polished Stainless Steel') {
      return longRod ? { low: 42, high: 60 } : { low: 35, high: 52 };
    }
    return longRod ? { low: 42, high: 60 } : { low: 35, high: 52 };
  }

  function getReelSeatRange(type) {
    var ranges = {
      'Graphite': { low: 16, high: 24 },
      'Graphite + Aluminum Nut': { low: 24, high: 34 },
      'Aluminum': { low: 38, high: 55 }
    };
    return ranges[type] || { low: 18, high: 28 };
  }

  function getCustomizationRange(level) {
    var ranges = {
      'Clean Build': { low: 0, high: 20 },
      'Custom Wraps': { low: 30, high: 75 },
      'Full Custom Art': { low: 90, high: 210 }
    };
    return ranges[level] || { low: 0, high: 20 };
  }

  function wrapLevelToCustomizationLegacy(wrapLevel) {
    if (wrapLevel === '__recommend__' || wrapLevel === '' || wrapLevel == null) return "Builder's choice";
    var n = parseInt(wrapLevel, 10);
    if (n === 1) return 'Clean Build';
    if (n === 2 || n === 3) return 'Custom Wraps';
    if (n === 4 || n === 5) return 'Full Custom Art';
    return 'Clean Build';
  }

  function numericWrapLevel(wrapLevel) {
    if (wrapLevel === '__recommend__' || wrapLevel === '' || wrapLevel == null) return null;
    var n = parseInt(wrapLevel, 10);
    if (n >= 1 && n <= 5) return n;
    return null;
  }

  function wrapLevelLabel(wrapLevel) {
    if (wrapLevel === '__recommend__') return 'Builder picks';
    var n = parseInt(wrapLevel, 10);
    if (n === 1) return 'Solid';
    if (n === 2) return 'Solid + trim bands';
    if (n === 3) return 'Detailed';
    if (n === 4) return 'Advanced';
    if (n === 5) return 'Custom';
    return '';
  }

  function getTechniqueAdjustment(technique) {
    var ranges = {
      'Mooching': { low: 15, high: 28 },
      'Trolling': { low: 10, high: 18 },
      'Downrigger': { low: 10, high: 18 },
      'Casting': { low: 0, high: 10 },
      'Spinning': { low: 0, high: 10 },
      'Float fishing': { low: 18, high: 35 },
      'Jigging': { low: 8, high: 16 },
      'Twitching': { low: 6, high: 14 },
      'Centerpin': { low: 25, high: 42 },
      'Surf': { low: 25, high: 42 },
      'Fly': { low: 20, high: 38 },
      'Wade Fishing': { low: 5, high: 14 },
      'Sight-Casting': { low: 8, high: 18 },
      'Flats Fishing': { low: 8, high: 18 },
      'Kayak Fishing': { low: 5, high: 14 },
      'Long-Range Offshore': { low: 20, high: 38 },
      'Bottom Fishing': { low: 8, high: 16 },
      'Live Bait': { low: 6, high: 14 },
      'Dock / Structure': { low: 5, high: 14 },
      'Other': { low: 0, high: 15 }
    };
    return ranges[technique] || { low: 0, high: 10 };
  }

  function getActionAdjustment(action) {
    var ranges = {
      'Moderate': { low: 0, high: 0 },
      'Moderate Fast': { low: 6, high: 10 },
      'Fast': { low: 10, high: 18 },
      'Extra Fast': { low: 14, high: 24 }
    };
    return ranges[action] || { low: 0, high: 0 };
  }

  function getFormatAdjustment(format) {
    var ranges = {
      'One Piece': { low: 0, high: 0 },
      '2-Piece': { low: 25, high: 40 },
      'Travel Multi-Piece': { low: 40, high: 65 }
    };
    return ranges[format] || { low: 0, high: 0 };
  }

  function calculateEstimate() {
    var v = state.values;

    if (isMemorial) {
      return calculateMemorialEstimate();
    }

    if (isFlyV2) {
      return calculateFlyEstimate();
    }

    var rodLength = v.rod_length || '';
    var power = v.power || '';
    var gripMaterial = v.grip_material || '';
    var guideMaterial = v.guide_material || '';
    var reelSeatType = v.reel_seat_type || '';
    var customizationLevel = v.customization_level || '';
    var technique = v.technique || '';
    var actionFeel = v.action_feel || '';
    var rodFormat = v.rod_format || '';

    var inches = parseRodLengthInches(rodLength);
    var laborLow = inches * 1.97;
    var laborHigh = (inches * 1.97) + 18;

    var blankRange = getBlankRange(rodLength, power);
    var gripRange = getGripRange(gripMaterial);
    var guideRange = getGuideRange(guideMaterial, rodLength);
    var reelSeatRange = getReelSeatRange(reelSeatType);
    var customizationRange = getCustomizationRange(customizationLevel);
    var techniqueRange = getTechniqueAdjustment(technique);
    var actionRange = getActionAdjustment(actionFeel);
    var formatRange = getFormatAdjustment(rodFormat);

    var low = laborLow + blankRange.low + gripRange.low + guideRange.low + reelSeatRange.low + customizationRange.low + techniqueRange.low + actionRange.low + formatRange.low;
    var high = laborHigh + blankRange.high + gripRange.high + guideRange.high + reelSeatRange.high + customizationRange.high + techniqueRange.high + actionRange.high + formatRange.high;

    high += 15;

    low = low * 0.85;
    high = high * 0.85;

    low = roundToNearestFive(low);
    high = roundToNearestFive(high);

    if (high < low + 20) high = low + 20;

    var pills = [v.target_species, v.technique, v.rod_length, v.power, v.action_feel, v.rod_format, v.grip_material, v.guide_material, v.customization_level].filter(Boolean);
    if (Array.isArray(v.priorities) && v.priorities.length > 0) {
      v.priorities.forEach(function(p) { pills.push(p); });
    }

    var result = {
      low: low,
      high: high,
      rangeText: formatMoney(low) + ' to ' + formatMoney(high),
      summary: 'Estimate built from rod length, labor, blank range, handle materials, guides, reel seat, action, format, and customization level. Final pricing is confirmed after build review.',
      pills: pills,
      lengthPending: !v.rod_length
    };
    if (result.lengthPending) {
      result.low = '';
      result.high = '';
      result.rangeText = 'Builder review needed — length pending';
      result.summary = 'Length not specified — price pending the builder’s length recommendation. ' + result.summary;
    }
    return result;
  }

  function buildMemorialPills(v) {
    var pills = [];
    var features = v.memorial_features || [];
    if (v.memorial_honoree) pills.push('In memory of ' + v.memorial_honoree.split(/\s*[-\u2014,]|\.\.\./)[0].trim());
    if (features.length) features.forEach(function(f) { pills.push(f); });
    if (v.target_species && v.target_species !== "Builder's choice") pills.push(v.target_species);
    if (v.technique && v.technique !== "Builder's choice") pills.push(v.technique);
    if (v.rod_length) pills.push(v.rod_length);
    if (v.power && v.power !== "Builder's choice") pills.push(v.power);
    if (Array.isArray(v.priorities) && v.priorities.length > 0) {
      v.priorities.forEach(function(p) { pills.push(p); });
    }
    return pills;
  }

  function calculateMemorialEstimate() {
    var v = state.values;
    var rodLength = v.rod_length || '';
    var power = v.power || '';
    var technique = v.technique || '';

    var inches = parseRodLengthInches(rodLength);

    if (MEMORIAL_FLOW_VERSION !== 'v2') {
      var laborLow = inches * 1.97;
      var laborHigh = (inches * 1.97) + 18;
      var blankRange = getBlankRange(rodLength, power === "Builder's choice" ? 'Medium' : power);
      var gripRange = { low: 28, high: 48 };
      var guideRange = { low: 42, high: 60 };
      var reelSeatRange = { low: 24, high: 34 };
      var customizationRange = { low: 90, high: 210 };

      var memorialExtras = { low: 45, high: 80 };
      var features = v.memorial_features || [];
      if (features.indexOf('Mini urn integration') > -1) {
        memorialExtras.low += 35;
        memorialExtras.high += 55;
      }
      if (features.indexOf('Photo or image reference') > -1) {
        memorialExtras.low += 20;
        memorialExtras.high += 40;
      }

      var techniqueRange = getTechniqueAdjustment(technique === "Builder's choice" ? 'Casting' : technique);

      var low = laborLow + blankRange.low + gripRange.low + guideRange.low + reelSeatRange.low + customizationRange.low + memorialExtras.low + techniqueRange.low;
      var high = laborHigh + blankRange.high + gripRange.high + guideRange.high + reelSeatRange.high + customizationRange.high + memorialExtras.high + techniqueRange.high;

      low = low * 0.85;
      high = high * 0.85;

      low = roundToNearestFive(low);
      high = roundToNearestFive(high);

      if (low < 500) low = 500;
      if (high < low + 50) high = low + 50;

      return {
        low: low,
        high: high,
        rangeText: formatMoney(low) + ' to ' + formatMoney(high),
        summary: 'Memorial build estimate includes custom engraving, personalized wraps, ALPS guides, hardcase, and full custom art. Your builder will finalize all details after your initial conversation.',
        pills: buildMemorialPills(v)
      };
    }

    var customizationLevel = v.customization_level || 'Full Custom Art';

    var laborLow2 = inches * 1.97;
    var laborHigh2 = (inches * 1.97) + 18;
    var blankRange2 = getBlankRange(rodLength, power === "Builder's choice" ? 'Medium' : power);

    var gripRange2     = v.grip_material    ? getGripRange(v.grip_material)              : { low: 28, high: 48 };
    var guideRange2    = v.guide_material   ? getGuideRange(v.guide_material, rodLength) : { low: 42, high: 60 };
    var reelSeatRange2 = v.reel_seat_type   ? getReelSeatRange(v.reel_seat_type)         : { low: 24, high: 34 };

    var customizationRange2;
    if (customizationLevel === 'Clean Build') {
      customizationRange2 = { low: 25, high: 55 };     // simple tribute: engraving + basic wraps
    } else if (customizationLevel === 'Custom Wraps') {
      customizationRange2 = { low: 55, high: 110 };    // personalized wraps + engraving
    } else {
      customizationRange2 = { low: 90, high: 210 };    // Full Custom Art — painted art + full design
    }

    var techniqueRange2 = getTechniqueAdjustment(technique === "Builder's choice" ? 'Casting' : technique);
    var actionRange2 = v.action_feel ? getActionAdjustment(v.action_feel) : { low: 0, high: 0 };

    var rodLow = laborLow2 + blankRange2.low + gripRange2.low + guideRange2.low + reelSeatRange2.low + customizationRange2.low + techniqueRange2.low + actionRange2.low;
    var rodHigh = laborHigh2 + blankRange2.high + gripRange2.high + guideRange2.high + reelSeatRange2.high + customizationRange2.high + techniqueRange2.high + actionRange2.high;

    var featuresV2 = v.memorial_features || [];
    if (featuresV2.indexOf('Mini urn integration') > -1) {   // Ash Inlay
      rodLow += 35;
      rodHigh += 55;
    }
    if (featuresV2.indexOf('Handwritten inscription') > -1) {
      rodLow += 20;
      rodHigh += 40;
    }
    if (featuresV2.indexOf('GPS coordinates') > -1) {
      rodLow += 15;
      rodHigh += 30;
    }
    if (featuresV2.indexOf('Embedded keepsake') > -1) {
      rodLow += 25;
      rodHigh += 55;
    }
    if (featuresV2.indexOf('Fingerprint') > -1) {
      rodLow += 25;
      rodHigh += 50;
    }

    rodLow = rodLow * 0.85;
    rodHigh = rodHigh * 0.85;

    rodLow = roundToNearestFive(rodLow);
    rodHigh = roundToNearestFive(rodHigh);


    if (rodHigh < rodLow + 50) rodHigh = rodLow + 50;

    var fee = MEMORIAL_FEE_DOLLARS;

    return {
      buildLow: rodLow,
      buildHigh: rodHigh,
      feeLow: fee,
      feeHigh: fee,
      low: rodLow + fee,
      high: rodHigh + fee,
      rangeText: formatMoney(rodLow + fee) + ' to ' + formatMoney(rodHigh + fee),
      breakdown: [
        { label: 'Rod build estimate',  value: formatMoney(rodLow) + ' – ' + formatMoney(rodHigh) },
        { label: 'Memorial Package',    value: formatMoney(fee), note: 'Includes custom mini urn, builder consult, and design work' }
      ],
      summary: "The Memorial Package (" + formatMoney(fee) + ") covers your builder consult, design work, and a custom mini urn shipped to you for returning ashes if you choose ash inlay. Rod build pricing above reflects your tribute level and any selected personalizations. Your builder will finalize every detail on the consultation call.",
      pills: buildMemorialPills(v)
    };
  }

  var FLY_SUPPLIER_SKU_MAP = {
    action: {
      'Medium-Fast': 'Mod-Fast (Batson)',
      'Fast': 'Fast (Batson)',
      'Xtra-Fast': 'Xtra-Fast (Batson)'
    },
    grip_material: {
      'Flor Grade Cork':  'Flor Grade Cork (Batson)',
      'Super Grade Cork': 'Super Grade Cork (Batson)',
      "'A' Grade Cork":   "'A' Grade Cork (Batson)",
      'Composite Cork':   'HDCC Cork/Composite (Batson)',
      'EVA':              'EVA / Forecast (Batson)'
    },
    guide_material: {
      'Standard':          'Hard Chrome Snake + L Ring Aluminum Oxide (Batson ALPS XN family)',
      'Premium':           'Hard Chrome Snake + Z Ring Zirconia (Batson ALPS XN family)',
      'Saltwater Premium': 'Ti Chrome Snake + Z Ring Zirconia (Batson ALPS XSN + XN family)'
    }
  };

  function flySupplierLabel(field, value) {
    var map = FLY_SUPPLIER_SKU_MAP[field];
    if (!map) return '';
    return map[value] || '';
  }

  function getFlyBlankRange(lengthText, lineWeight, flyRodClass) {
    var lw = parseInt((lineWeight || '').replace('wt',''), 10) || 5;
    var low, high;
    if (lw <= 4)      { low = 70;  high = 110; }
    else if (lw <= 6) { low = 85;  high = 130; }
    else if (lw <= 8) { low = 110; high = 160; }
    else if (lw <= 10){ low = 140; high = 200; }
    else              { low = 175; high = 240; }
    if (flyRodClass === 'Switch') { low += 20; high += 40; }
    else if (flyRodClass === 'Spey') { low += 30; high += 55; }
    return { low: low, high: high };
  }

  function getFlyGripRange(material, shape) {
    var matRanges = {
      'Flor Grade Cork':  { low: 55, high: 95 },
      'Super Grade Cork': { low: 38, high: 62 },
      "'A' Grade Cork":   { low: 24, high: 42 },
      'Composite Cork':   { low: 32, high: 52 },
      'EVA':              { low: 22, high: 36 }
    };
    var base = matRanges[material] || { low: 28, high: 48 };
    var shapeAdder = 0, shapeAdderHigh = 0;
    if (shape === 'Full-Wells') { shapeAdder = 8; shapeAdderHigh = 15; }
    else if (shape === 'Reverse Half-Wells') { shapeAdder = 6; shapeAdderHigh = 12; }
    else if (shape === 'Spey Two-Hand') { shapeAdder = 12; shapeAdderHigh = 22; }
    return { low: base.low + shapeAdder, high: base.high + shapeAdderHigh };
  }

  function getFlyGuideRange(material, lengthText, flyRodClass) {
    var inches = parseRodLengthInches(lengthText);
    var twoHand = flyRodClass === 'Switch' || flyRodClass === 'Spey';
    var longRod = inches >= 120 || twoHand;
    var matRanges = longRod
      ? {
          'Standard':          { low: 65,  high: 95 },
          'Premium':           { low: 78,  high: 115 },
          'Saltwater Premium': { low: 125, high: 175 }
        }
      : {
          'Standard':          { low: 38,  high: 60 },
          'Premium':           { low: 48,  high: 75 },
          'Saltwater Premium': { low: 82,  high: 125 }
        };
    return matRanges[material] || (longRod ? { low: 60, high: 90 } : { low: 40, high: 65 });
  }

  function getFlyReelSeatRange(type) {
    var ranges = {
      'Slide-Band':                  { low: 18, high: 30 },
      'Locking':                     { low: 32, high: 52 },
      'Skeleton with Wood Insert':   { low: 70, high: 125 },
      'All-Aluminum Saltwater':      { low: 52, high: 82 }
    };
    return ranges[type] || { low: 30, high: 50 };
  }

  function getFightingButtRange(choice) {
    if (choice === 'Yes') return { low: 18, high: 32 };
    return { low: 0, high: 0 };
  }

  function getFlyActionAdjustment(action) {
    var ranges = {
      'Medium-Fast': { low: 0,  high: 8 },
      'Fast':        { low: 12, high: 20 },
      'Xtra-Fast':   { low: 18, high: 30 }
    };
    return ranges[action] || { low: 0, high: 0 };
  }

  function getFlyFormatAdjustment(format) {
    var ranges = {
      '2-Piece': { low: 0,  high: 0 },
      '4-Piece': { low: 10, high: 20 }
    };
    return ranges[format] || { low: 10, high: 20 };
  }

  function getFlyTechniqueAdjustment(technique) {
    var ranges = {
      'Dry Fly':                       { low: 0,  high: 10 },
      'Nymphing':                      { low: 0,  high: 10 },
      'Indicator Nymphing':            { low: 5,  high: 15 },
      'Euro / Tight-Line Nymph':       { low: 5,  high: 15 },
      'Streamer':                      { low: 0,  high: 10 },
      'Swing / Wet Fly':               { low: 0,  high: 12 },
      'Spey / Two-Hand':               { low: 15, high: 30 },
      'Saltwater Flats / Sight-Cast':  { low: 18, high: 35 },
      'Saltwater Surf':                { low: 18, high: 35 },
      'Big-Water Streamer':            { low: 12, high: 25 },
      'Stillwater':                    { low: 0,  high: 10 },
      'Carp / Pike / Musky on the Fly':{ low: 12, high: 25 },
      'Other':                         { low: 0,  high: 15 }
    };
    return ranges[technique] || { low: 0, high: 10 };
  }

  function calculateFlyEstimate() {
    var v = state.values;
    var rodLength    = v.rod_length    || '';
    var lineWeight   = v.line_weight   || '';
    var flyRodClass  = v.fly_rod_class || 'Single-Hand';
    var actionFeel   = v.action_feel   || '';
    var rodFormat    = v.rod_format    || '';
    var gripMaterial = v.grip_material || '';
    var gripShape    = v.grip_shape    || '';
    var guideMaterial= v.guide_material|| '';
    var reelSeatType = v.reel_seat_type|| '';
    var fightingButt = v.fighting_butt || 'No';
    var customizationLevel = v.customization_level || '';
    var technique    = v.technique     || '';

    var inches = parseRodLengthInches(rodLength);
    var laborLow  = inches * 1.97;
    var laborHigh = (inches * 1.97) + 18;

    var blankRange        = getFlyBlankRange(rodLength, lineWeight, flyRodClass);
    var gripRange         = getFlyGripRange(gripMaterial, gripShape);
    var guideRange        = getFlyGuideRange(guideMaterial, rodLength, flyRodClass);
    var reelSeatRange     = getFlyReelSeatRange(reelSeatType);
    var fightingButtRange = getFightingButtRange(fightingButt);
    var customizationRange= getCustomizationRange(customizationLevel);
    var actionRange       = getFlyActionAdjustment(actionFeel);
    var formatRange       = getFlyFormatAdjustment(rodFormat);
    var techniqueRange    = getFlyTechniqueAdjustment(technique);

    var low  = laborLow  + blankRange.low  + gripRange.low  + guideRange.low  + reelSeatRange.low  + fightingButtRange.low  + customizationRange.low  + actionRange.low  + formatRange.low  + techniqueRange.low;
    var high = laborHigh + blankRange.high + gripRange.high + guideRange.high + reelSeatRange.high + fightingButtRange.high + customizationRange.high + actionRange.high + formatRange.high + techniqueRange.high;

    high += 15;
    low  = low  * 0.85;
    high = high * 0.85;
    low  = roundToNearestFive(low);
    high = roundToNearestFive(high);
    if (high < low + 20) high = low + 20;

    var pills = [
      v.target_species, v.fly_rod_class, v.line_weight, v.technique,
      v.rod_length, v.action_feel, v.rod_format,
      v.grip_material, v.grip_shape, v.guide_material, v.reel_seat_type,
      (v.fighting_butt === 'Yes') ? 'Fighting Butt' : null,
      v.customization_level
    ].filter(Boolean);
    if (Array.isArray(v.priorities) && v.priorities.length > 0) {
      v.priorities.forEach(function(p) { pills.push(p); });
    }

    var result = {
      low: low,
      high: high,
      rangeText: formatMoney(low) + ' to ' + formatMoney(high),
      summary: 'Fly rod estimate built from blank (length × line weight × class), labor, cork grade and shape, ALPS snake-guide package, reel seat, action, format, and customization. Final pricing confirmed after build review.',
      pills: pills,
      lengthPending: !v.rod_length,
      lineWeightPending: !v.line_weight && !!v.rod_length
    };
    if (result.lengthPending) {
      result.low = '';
      result.high = '';
      result.rangeText = 'Builder review needed — length pending';
      result.summary = 'Length not specified — price pending the builder’s length recommendation. ' + result.summary;
    }
    return result;
  }

  function getActiveSteps() {
    return steps.filter(function(s) {
      if (s.conditional) return s.conditional(state.values);
      return true;
    });
  }

  var previousFocus = null;

  // Lightweight debug tracing for the step / advance / panel flow. Enable with
  // ?plrtdebug=1 in the URL (or localStorage.plrtDebug='1'). Off by default so
  // production consoles stay clean — lets us PROVE which path runs in edit mode
  // instead of guessing.
  var PLRT_DEBUG = false;
  try {
    PLRT_DEBUG = /[?&]plrtdebug=1/.test(window.location.search) ||
      (window.localStorage && window.localStorage.getItem('plrtDebug') === '1');
  } catch (e) {}
  function plrtDbg() {
    if (!PLRT_DEBUG || !window.console || !window.console.log) return;
    try { console.log.apply(console, ['[plrt-estimator]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  function openModal() {
    previousFocus = document.activeElement;
    overlay.classList.add('is-open');
    dialog.focus();
    document.body.style.overflow = 'hidden';
    // Resume where the customer left off. Clicking the backdrop / Esc minimizes
    // (preserves state) rather than resetting, so re-opening returns them to
    // their estimate or in-conversation step — including a pending SMS-code or
    // name step. Only when no panel was active do we (re)render the questions.
    if (state.activePanel && document.getElementById(state.activePanel)) {
      showLeftSummary();
      showModalPanel(state.activePanel);
    } else {
      renderStep();
    }
    pushEvent('estimator_modal_open', {});
    if (isMemorial) {
      pushEvent('memorial_estimator_start', { entry_source: document.referrer || 'direct' });
    }
  }

  function closeModal() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (previousFocus) previousFocus.focus();
    var active = getActiveSteps();
    pushEvent('estimator_modal_close', { last_step_completed: state.currentStep });
  }

  function showModalPanel(panelId) {
    // Track the active panel so minimizing (backdrop click / Esc) + re-opening
    // can resume exactly here instead of resetting to the first question.
    state.activePanel = panelId || null;
    plrtDbg('showModalPanel:', panelId || '(none → questions)');
    var panels = ['plrt-est-results-panel', 'plrt-est-handoff-panel', 'plrt-est-messenger-panel', 'plrt-est-success-panel', 'plrt-est-decision-panel'];
    panels.forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.style.display = 'none';
    });
    rightPanel.style.display = 'none';
    var target = document.getElementById(panelId);
    if (target) target.style.display = 'block';
  }

  // Multi-build decision prompt. Set to the lead-submit closure when the server
  // returns decisionRequired; the decision-panel buttons replay it with the
  // customer's choice ('update' | 'new').
  var pendingLeadResubmit = null;

  function showDecisionPrompt(existingLocked) {
    showModalPanel('plrt-est-decision-panel');
    var updateBtn = document.getElementById('plrt-est-decision-update');
    var lockedNote = document.getElementById('plrt-est-decision-locked-note');
    // Locked existing build (approved / paid / in production) → "update" isn't
    // safe; hide it and steer the customer to start another build.
    if (updateBtn) updateBtn.style.display = existingLocked ? 'none' : '';
    if (lockedNote) lockedNote.style.display = existingLocked ? 'block' : 'none';
  }

  function showLeftSummary() {
    var v = state.values;
    var r = state.estimateResult;

    var progressWrap = document.querySelector('.plrt-est-progress-wrap');
    var phaseLabel = document.getElementById('plrt-est-phase-label');
    var motivationEl = document.getElementById('plrt-est-motivation');
    var livePriceEl = document.getElementById('plrt-est-live-price');
    if (progressWrap) progressWrap.style.display = 'none';
    if (phaseLabel) phaseLabel.style.display = 'none';
    if (motivationEl) motivationEl.style.display = 'none';
    if (livePriceEl) livePriceEl.style.display = 'none';

    var summaryEl = document.getElementById('plrt-est-left-summary');
    if (summaryEl) summaryEl.style.display = 'block';

    var itemsEl = document.getElementById('plrt-est-left-summary-items');
    if (itemsEl) {
      var items = [];
      if (isMemorial) {
        if (v.memorial_honoree) items.push('<div><strong>In memory of ' + escHtml(v.memorial_honoree) + '</strong></div>');
        if (v.memorial_water) items.push('<div>' + escHtml(v.memorial_water) + '</div>');
        if (Array.isArray(v.memorial_features) && v.memorial_features.length) items.push('<div>' + v.memorial_features.map(escHtml).join(' &middot; ') + '</div>');
        if (isOwnRodPath()) {
          items.push('<div>On a rod you own</div>');
          if (v.memorial_own_rod_details) items.push('<div>' + escHtml(v.memorial_own_rod_details) + '</div>');
        } else {
          if (v.target_species) items.push('<div>' + escHtml(v.target_species) + '</div>');
          if (v.rod_length) items.push('<div>' + escHtml(v.rod_length) + (v.power ? ' &middot; ' + escHtml(v.power) : '') + '</div>');
          items.push('<div>Full Custom Art</div>');
        }
      } else {
        if (v.target_species) items.push('<div><strong>' + escHtml(v.target_species) + '</strong></div>');
        if (v.fly_rod_class) items.push('<div>' + escHtml(v.fly_rod_class) + (v.line_weight ? ' &middot; ' + escHtml(v.line_weight) : '') + '</div>');
        if (v.technique) items.push('<div>' + escHtml(v.technique) + '</div>');
        if (v.rod_length) items.push('<div>' + escHtml(v.rod_length) + (isFlyV2 ? '' : (' &middot; ' + escHtml(v.power || ''))) + '</div>');
        if (v.action_feel) items.push('<div>' + escHtml(v.action_feel) + ' &middot; ' + escHtml(v.rod_format || '') + '</div>');
        if (v.grip_material) items.push('<div>' + escHtml(v.grip_material) + (v.grip_shape ? ' &middot; ' + escHtml(v.grip_shape) : '') + '</div>');
        if (v.guide_material) items.push('<div>' + escHtml(v.guide_material) + '</div>');
        if (v.reel_seat_type) items.push('<div>' + escHtml(v.reel_seat_type) + (v.fighting_butt === 'Yes' ? ' &middot; Fighting Butt' : '') + '</div>');
        if (v.customization_level) items.push('<div>' + escHtml(v.customization_level) + '</div>');
      }
      itemsEl.innerHTML = items.join('');
    }

    var priceEl = document.getElementById('plrt-est-left-summary-price');
    if (priceEl) priceEl.textContent = (r && !isOwnRodPath()) ? r.rangeText : '';

    var idEl = document.getElementById('plrt-est-left-summary-id');
    if (idEl) idEl.textContent = 'EST #' + getStoredEstimateId();
  }

  function finishEstimate() {
    state.estimateResult = calculateEstimate();
    state.estimateCompleted = true; // estimate is now shown — later component changes are fast one-click edits
    plrtDbg('finishEstimate: estimate shown → estimateCompleted=true');
    var estimateId = getStoredEstimateId();

    showLeftSummary();

    showModalPanel('plrt-est-results-panel');

    var priceEl = document.getElementById('plrt-est-results-price');
    var idEl = document.getElementById('plrt-est-results-id');
    var pillsEl = document.getElementById('plrt-est-pills');

    if (priceEl) priceEl.textContent = state.estimateResult.rangeText;
    if (idEl) idEl.textContent = 'Estimate #' + estimateId;

    if (isMemorial) {
      var eyebrowEl = document.getElementById('plrt-est-results-eyebrow');
      var reassuranceEl = document.getElementById('plrt-est-results-reassurance');
      if (isOwnRodPath()) {
        // Own-rod path: there is no rod to build, so we never show a build-price
        // estimate. The builder confirms what's possible on the customer's rod
        // case-by-case, then quotes the treatment separately.
        if (eyebrowEl) eyebrowEl.textContent = 'Memorial On Your Rod';
        if (reassuranceEl) reassuranceEl.textContent = "Most memorial details can be worked into a rod you already own — your builder confirms what's possible for yours on the consult call. No payment until you approve.";
        if (priceEl) priceEl.style.display = 'none';
        if (idEl) idEl.style.display = 'none';
      } else {
        if (eyebrowEl) eyebrowEl.textContent = 'Memorial Build Estimate';
        if (reassuranceEl) reassuranceEl.textContent = 'Memorial builds include engraving, personalized wraps, and a hardcase. Final pricing confirmed when we review together — no payment until you approve.';
      }
    } else {
      var eyebrowEl2 = document.getElementById('plrt-est-results-eyebrow');
      var reassuranceEl2 = document.getElementById('plrt-est-results-reassurance');
      if (state.estimateResult.lengthPending) {
        if (eyebrowEl2) eyebrowEl2.textContent = 'Ready for builder review';
        if (priceEl) priceEl.style.display = 'none';
        if (idEl) idEl.style.display = 'none';
        if (reassuranceEl2) reassuranceEl2.innerHTML = 'Rod length affects the blank, build labor, and final price. We’ll recommend the right length based on how you fish before giving you a reliable estimate. <button type="button" id="plrt-est-add-length-btn" style="background:none;border:none;color:#79be37;font:inherit;font-weight:700;cursor:pointer;text-decoration:underline;text-underline-offset:3px;padding:0;">Add a length</button>';
      } else {
        if (priceEl) priceEl.style.display = '';
        if (idEl) idEl.style.display = '';
        if (state.estimateResult.lineWeightPending && reassuranceEl2) {
          reassuranceEl2.textContent = 'Starting estimate — we’ll finalize your line weight together. A builder will help you dial in the rest.';
        }
      }
    }


    pushEvent('estimator_decision_view', {});

    var breakdownEl = document.getElementById('plrt-est-results-breakdown');
    if (breakdownEl) {
      if (MEMORIAL_FLOW_VERSION === 'v2' && isMemorial && !isOwnRodPath() && state.estimateResult.breakdown) {
        var bd = state.estimateResult.breakdown;
        var bhtml = '';
        for (var bi = 0; bi < bd.length; bi++) {
          var row = bd[bi];
          bhtml += '<div class="plrt-est-breakdown-row">' +
                   '<span class="plrt-est-breakdown-label">' + escHtml(row.label) + '</span>' +
                   '<span class="plrt-est-breakdown-value">' + escHtml(row.value) + '</span>';
          if (row.note) {
            bhtml += '<span class="plrt-est-breakdown-note">' + escHtml(row.note) + '</span>';
          }
          bhtml += '</div>';
        }
        bhtml += '<hr class="plrt-est-breakdown-divider">';
        bhtml += '<div class="plrt-est-breakdown-row plrt-est-breakdown-total">' +
                 '<span class="plrt-est-breakdown-label">Your total</span>' +
                 '<span class="plrt-est-breakdown-value">' + escHtml(state.estimateResult.rangeText) + '</span>' +
                 '</div>';
        bhtml += '<p class="plrt-est-breakdown-included">Every Memorial Package includes your builder consultation, design work, and a custom mini urn shipped to you for returning ashes if you choose ash inlay. Ash inlay, engraving, personalized wraps, and your chosen tribute level are finalized with your builder during the design consult.</p>';
        breakdownEl.innerHTML = bhtml;
        breakdownEl.style.display = 'block';
        if (priceEl) priceEl.style.display = 'none';
      } else {
        breakdownEl.style.display = 'none';
        if (priceEl && !state.estimateResult.lengthPending) priceEl.style.display = '';
      }
    }

    if (pillsEl) {
      pillsEl.innerHTML = '';
      state.estimateResult.pills.forEach(function(text) {
        var pill = document.createElement('span');
        pill.className = 'plrt-est-pill';
        pill.textContent = text;
        pillsEl.appendChild(pill);
      });
    }

    (function() {
      var r = state.estimateResult;
      var ownRod = isOwnRodPath();
      var midpoint = (r.lengthPending || ownRod) ? null : Math.round(((r.low + r.high) / 2) * 100) / 100;
      var specs = getRodSpecParams();
      specs.estimate_low = ownRod ? '' : r.low;
      specs.estimate_high = ownRod ? '' : r.high;
      specs.estimate_pending = ownRod ? 'own_rod' : (r.lengthPending ? 'length' : '');
      pushConversion('estimator_complete', specs, midpoint, null);
    })();

    if (!isMemorial && state.estimateResult.lengthPending) {
      var addLenBtn = document.getElementById('plrt-est-add-length-btn');
      if (addLenBtn) addLenBtn.addEventListener('click', reopenLengthFromResults);
    }

    if (MEMORIAL_FLOW_VERSION === 'v2' && isMemorial && state.values.memorial_path === 'guided') {
      setTimeout(function() {
        var startBtn = document.getElementById('plrt-est-send-to-builder-btn');
        if (startBtn) startBtn.focus();
      }, 100);
    }
  }

  function reopenLengthFromResults() {
    ['plrt-est-results-panel','plrt-est-handoff-panel','plrt-est-messenger-panel','plrt-est-success-panel'].forEach(function(id) {
      var e = document.getElementById(id); if (e) e.style.display = 'none';
    });
    if (rightPanel) rightPanel.style.display = '';
    var summaryEl = document.getElementById('plrt-est-left-summary'); if (summaryEl) summaryEl.style.display = 'none';
    var progressWrap = document.querySelector('.plrt-est-progress-wrap'); if (progressWrap) progressWrap.style.display = '';
    var phaseLabel = document.getElementById('plrt-est-phase-label'); if (phaseLabel) phaseLabel.style.display = '';
    var motivationEl = document.getElementById('plrt-est-motivation'); if (motivationEl) motivationEl.style.display = '';
    state.values.rod_length = '';
    state.intents.rod_length = '';
    state.values._rod_length_overridden = true;
    state.selectedRange = null;
    var active = getActiveSteps();
    var rlIdx = -1;
    for (var i = 0; i < active.length; i++) { if (active[i].id === 'rod_length') { rlIdx = i; break; } }
    if (rlIdx >= 0) { state.currentStep = rlIdx; renderStep(); }
  }

  function populateHiddenFields() {
    var estimateId = getStoredEstimateId();
    var r = state.estimateResult;
    var v = state.values;

    setHidden('plrt_estimate_id', estimateId);
    setHidden('plrt_estimate_low', r.low);
    setHidden('plrt_estimate_high', r.high);
    setHidden('plrt_estimate_range', r.rangeText);
    setHidden('plrt_estimate_summary', r.summary);
    setHidden('plrt_target_species', v.target_species || '');
    setHidden('plrt_technique', v.technique || '');
    setHidden('plrt_rod_length', v.rod_length || '');
    setHidden('plrt_power', v.power || '');
    setHidden('plrt_grip_material', v.grip_material || '');
    setHidden('plrt_shrink_add_on', v.shrink_add_on || 'No');
    setHidden('plrt_guide_material', v.guide_material || '');
    setHidden('plrt_reel_seat_type', v.reel_seat_type || '');
    setHidden('plrt_customization_level', v.customization_level || '');
    setHidden('plrt_fly_rod_class', v.fly_rod_class || '');
    setHidden('plrt_line_weight', v.line_weight || '');
    setHidden('plrt_grip_shape', v.grip_shape || '');
    setHidden('plrt_fighting_butt', v.fighting_butt || '');
  }

  function setHidden(id, val) {
    var el = document.getElementById(id);
    if (el) el.value = val;
  }

  function buildStartBuildUrl() {
    var v = state.values;
    var r = state.estimateResult;
    var params = new URLSearchParams();
    params.set('quote_imported', 'yes');
    params.set('quote_source', isMemorial ? 'memorial-estimator' : (isFlyV2 ? 'fly-estimator' : 'rod-builder'));
    params.set('quote_estimate_id', getStoredEstimateId());
    params.set('quote_species', v.target_species || '');
    params.set('quote_technique', v.technique || '');
    params.set('quote_water', isMemorial ? (v.memorial_water || '') : (v.water_location || ''));
    params.set('quote_length', v.rod_length || '');
    params.set('quote_power', v.power || '');
    params.set('quote_action', v.action_feel || '');
    params.set('quote_format', v.rod_format || '');
    params.set('quote_grip_material', v.grip_material || '');
    params.set('quote_guide_material', v.guide_material || '');
    params.set('quote_reel_seat_type', v.reel_seat_type || '');
    params.set('quote_customization_level', isMemorial ? 'Full Custom Art (Memorial)' : (v.customization_level || ''));
    params.set('quote_priorities', Array.isArray(v.priorities) ? v.priorities.join(',') : '');
    params.set('quote_fly_rod_class', v.fly_rod_class || '');
    params.set('quote_line_weight', v.line_weight || '');
    params.set('quote_grip_shape', v.grip_shape || '');
    params.set('quote_fighting_butt', v.fighting_butt || '');
    var notesEl = document.getElementById('plrt-est-build-notes');
    params.set('quote_notes', notesEl ? notesEl.value.trim() : '');
    params.set('quote_estimate_low', (r && !isOwnRodPath()) ? r.low : '');
    params.set('quote_estimate_high', (r && !isOwnRodPath()) ? r.high : '');
    params.set('quote_estimate_range', (r && !isOwnRodPath()) ? r.rangeText : '');
    if (isMemorial) {
      params.set('from', 'memorial-estimator');
      params.set('quote_memorial_honoree', v.memorial_honoree || '');
      params.set('quote_memorial_water', v.memorial_water || '');
      params.set('quote_memorial_features', Array.isArray(v.memorial_features) ? v.memorial_features.join(',') : '');
      params.set('quote_memorial_rod_source', v.memorial_rod_source || 'new_build');
      if (isOwnRodPath()) params.set('quote_memorial_own_rod_details', v.memorial_own_rod_details || '');
    }
    return '/pages/start-your-custom-rod-build?' + params.toString();
  }

  function updateContextBar() {
    var bar = document.getElementById('plrt-est-context-bar');
    if (!bar) return;
    if (isMemorial) { bar.hidden = true; bar.innerHTML = ''; return; }

    var region = fisheryAttribution.region || '';
    var fisheryLabel = state.values._fishery_name || '';
    if (!fisheryLabel && state.values.target_species) {
      fisheryLabel = state.values.target_species;
    }

    var gripShapePill = '';
    if (isFlyV2 && state.values.fly_rod_class === 'Single-Hand' && state.values.grip_shape && !state.values._grip_shape_overridden) {
      gripShapePill = state.values.grip_shape;
    }
    var rodLengthPill = '';
    if (isFlyV2 && state.values.fly_rod_class === 'Single-Hand' && state.values.rod_length === "9'0\"" && !state.values._rod_length_overridden) {
      rodLengthPill = state.values.rod_length;
    }

    if (!region && !fisheryLabel && !gripShapePill && !rodLengthPill) { bar.hidden = true; bar.innerHTML = ''; return; }

    var parts = [];
    if (region) {
      parts.push('<span class="plrt-ctx-region">' + escHtml(region) + '</span>');
    }
    if (fisheryLabel) {
      parts.push(
        '<span class="plrt-ctx-species" role="button" tabindex="0" ' +
        'aria-label="Change species — currently ' + escAttr(fisheryLabel) + '" ' +
        'data-action="clear-species">' +
        escHtml(fisheryLabel) +
        '</span>'
      );
    }
    if (rodLengthPill) {
      parts.push(
        '<span class="plrt-ctx-species" role="button" tabindex="0" ' +
        'aria-label="Change rod length — currently ' + escAttr(rodLengthPill) + '" ' +
        'data-action="reopen-rod-length">' +
        escHtml(rodLengthPill) +
        '</span>'
      );
    }
    if (gripShapePill) {
      parts.push(
        '<span class="plrt-ctx-species" role="button" tabindex="0" ' +
        'aria-label="Change grip shape — currently ' + escAttr(gripShapePill) + '" ' +
        'data-action="reopen-grip-shape">' +
        escHtml(gripShapePill) +
        '</span>'
      );
    }
    bar.innerHTML = parts.join('<span class="plrt-ctx-sep">·</span>');
    bar.hidden = false;

    var speciesSpan = bar.querySelector('[data-action="clear-species"]');
    if (speciesSpan) {
      var clearAndReask = function(e) {
        e.preventDefault();
        state.values.target_species = '';
        state.values._fishery_name = '';
        var newActive = getActiveSteps();
        var speciesIdx = newActive.findIndex(function(s) { return s.id === 'target_species'; });
        if (speciesIdx >= 0) state.currentStep = speciesIdx;
        renderStep();
      };
      speciesSpan.addEventListener('click', clearAndReask);
      speciesSpan.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') clearAndReask(e);
      });
    }
    var gripShapeSpan = bar.querySelector('[data-action="reopen-grip-shape"]');
    if (gripShapeSpan) {
      var reopenGripShape = function(e) {
        e.preventDefault();
        state.values._grip_shape_overridden = true;
        var newActive = getActiveSteps();
        var gsIdx = newActive.findIndex(function(s) { return s.id === 'grip_shape'; });
        if (gsIdx >= 0) state.currentStep = gsIdx;
        renderStep();
      };
      gripShapeSpan.addEventListener('click', reopenGripShape);
      gripShapeSpan.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') reopenGripShape(e);
      });
    }
    var rodLengthSpan = bar.querySelector('[data-action="reopen-rod-length"]');
    if (rodLengthSpan) {
      var reopenRodLength = function(e) {
        e.preventDefault();
        state.values._rod_length_overridden = true;
        state.values.rod_length = '';
        state.selectedRange = null;
        var newActive = getActiveSteps();
        var rlIdx = newActive.findIndex(function(s) { return s.id === 'rod_length'; });
        if (rlIdx >= 0) state.currentStep = rlIdx;
        renderStep();
      };
      rodLengthSpan.addEventListener('click', reopenRodLength);
      rodLengthSpan.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') reopenRodLength(e);
      });
    }
  }

  function renderLiveBuild() {
    var container = document.getElementById('plrt-est-live-build');
    var inner = document.getElementById('plrt-est-live-build-items');
    if (!container || !inner) return;
    if (!isFlyV2 || isMemorial) { container.hidden = true; return; }

    var v = state.values;
    var rows = [];
    if (v.target_species) rows.push({ key: 'target_species', label: 'Species', value: v.target_species });
    if (v.fly_rod_class)  rows.push({ key: 'fly_rod_class',  label: 'Class',   value: v.fly_rod_class });
    if (v.technique)      rows.push({ key: 'technique',      label: 'Technique', value: v.technique });
    if (v.line_weight)    rows.push({ key: 'line_weight',    label: 'Line wt',   value: v.line_weight });
    if (v.rod_length)     rows.push({ key: 'rod_length',     label: 'Length',    value: v.rod_length });
    if (v.action_feel)    rows.push({ key: 'action_feel',    label: 'Action',    value: v.action_feel });
    if (v.rod_format)     rows.push({ key: 'rod_format',     label: 'Format',    value: v.rod_format });
    if (v.grip_material) {
      var gripVal = v.grip_material + (v.grip_shape ? ' · ' + v.grip_shape : '');
      rows.push({ key: 'grip_material', label: 'Grip', value: gripVal });
    }
    if (v.guide_material) rows.push({ key: 'guide_material', label: 'Guides',    value: v.guide_material });
    if (v.reel_seat_type) {
      var rsVal = v.reel_seat_type + (v.fighting_butt === 'Yes' ? ' + fighting butt' : '');
      rows.push({ key: 'reel_seat_type', label: 'Reel seat', value: rsVal });
    }
    if (v.wrap_level || v.wrap_level === 0) {
      var wrapLbl = wrapLevelLabel(v.wrap_level);
      if (wrapLbl) rows.push({ key: 'wrap_level', label: 'Wraps', value: wrapLbl });
    }

    if (rows.length === 0) { container.hidden = true; return; }
    container.hidden = false;

    inner.innerHTML = rows.map(function(r) {
      return '<button type="button" class="plrt-est-live-build-row" data-jump="' + escAttr(r.key) + '" aria-label="Edit ' + escAttr(r.label) + ' (currently ' + escAttr(r.value) + ')">' +
        '<span class="plrt-est-live-build-label">' + escHtml(r.label) + '</span>' +
        '<span class="plrt-est-live-build-value">' + escHtml(r.value) + '</span>' +
        '</button>';
    }).join('');

    inner.querySelectorAll('[data-jump]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = this.getAttribute('data-jump');
        if (target === 'rod_length' && state.values.fly_rod_class === 'Single-Hand') {
          state.values._rod_length_overridden = true;
          state.values.rod_length = '';
          state.selectedRange = null;
        }
        if (target === 'grip_shape' && state.values.fly_rod_class === 'Single-Hand') {
          state.values._grip_shape_overridden = true;
        }
        var newActive = getActiveSteps();
        var idx = newActive.findIndex(function(s) { return s.id === target; });
        if (idx >= 0) {
          state.currentStep = idx;
          pushEvent('estimator_live_build_jump', { target: target });
          renderStep();
        }
      });
    });
  }

  function animatePriceUpdate(el, newText) {
    if (!el || el.textContent === newText) return;
    el.style.transition = 'opacity 150ms ease';
    el.style.opacity = '0';
    setTimeout(function() {
      el.textContent = newText;
      el.style.opacity = '1';
    }, 150);
  }

  function getStepCopy(step) {
    var v = state.values;
    var def = { question: step.question, motivation: step.motivation || '' };
    if (!isFlyV2) {
      return def;
    }

    if (step.id === 'target_species') {
      var region = fisheryAttribution.region;
      if (region) {
        return {
          question: 'Got it — fly fishing in ' + region + '. What species drives this build?',
          motivation: ''
        };
      }
      return def;
    }
    if (step.id === 'fly_rod_class') {
      var species = v.target_species;
      if (species) {
        return {
          question: species + ' — got it. Single-hand is the standard fly setup. Switch and Spey are two-handed, for swinging steelhead and salmon. Which fits your fishing?',
          motivation: 'This drives length, line weight, and grip options.'
        };
      }
      return def;
    }
    if (step.id === 'technique') {
      var cls = v.fly_rod_class;
      if (cls) {
        return {
          question: cls + ' setup. How will you most often fish?',
          motivation: fisheryAttribution.region && getFlyTechniquesForRegion(fisheryAttribution.region)
            ? 'Common techniques on ' + fisheryAttribution.region + '. Pick "Other" if yours isn\'t listed.'
            : 'Pick the technique you fish most. Your builder uses this to spec the right action.'
        };
      }
      return def;
    }
    if (step.id === 'water_location') {
      return {
        question: 'Anywhere specific you fish most?',
        motivation: 'Optional — helps us nail the taper to your water.'
      };
    }
    if (step.id === 'line_weight') {
      var tech = v.technique || '';
      var techPhrase = (tech && tech !== 'Other') ? 'For ' + tech.toLowerCase() + ', ' : '';
      return {
        question: techPhrase + 'what line weight will you cast?',
        motivation: '5wt is the workhorse for trout. Heavier for bass / saltwater; lighter for small streams.'
      };
    }
    if (step.id === 'rod_length') {
      var lwForLen = v.line_weight || '';
      if (v.fly_rod_class === 'Spey') {
        return {
          question: 'What length spey rod?',
          motivation: 'Spey blanks past 11’0" are sourced by your builder — final length and pricing confirmed at consult.'
        };
      }
      if (lwForLen) {
        return {
          question: 'What length ' + lwForLen + ' rod?',
          motivation: '9’0" is the workhorse across most line weights. Shorter for small streams; longer for nymphing.'
        };
      }
      return def;
    }
    if (step.id === 'action_feel') {
      var wt = v.line_weight || '';
      var len = v.rod_length || '';
      var prefix = (len && wt) ? len + ' ' + wt + ' — ' : '';
      return {
        question: prefix + 'how do you want it to load?',
        motivation: 'Medium-Fast is smooth and forgiving. Fast and Xtra-Fast give crisp distance and wind-cutting.'
      };
    }
    if (step.id === 'rod_format') {
      return {
        question: 'How will you transport it?',
        motivation: 'Most fly rods are 4-piece. 2-piece flexes smoother, but travels less.'
      };
    }
    if (step.id === 'grip_material') {
      return {
        question: 'What cork feel do you want?',
        motivation: 'Cork is traditional. Super Grade is what we build most.'
      };
    }
    if (step.id === 'grip_shape') {
      var gsCls = v.fly_rod_class;
      if (gsCls === 'Spey') {
        return {
          question: 'Which two-hand grip shape?',
          motivation: 'Spey and Switch builders often pick the dedicated Spey Two-Hand for the front grip.'
        };
      }
      return {
        question: 'Which grip shape feels best in hand?',
        motivation: ''
      };
    }
    if (step.id === 'guide_material') {
      var tech2 = v.technique || '';
      var saltwater = /^Saltwater/i.test(tech2);
      return {
        question: 'Which guide package?',
        motivation: saltwater
          ? 'Saltwater means corrosion-proof guides — go premium or saltwater premium.'
          : 'Standard works for freshwater. Premium upgrades the stripper insert.'
      };
    }
    if (step.id === 'reel_seat_type') {
      var wt2 = v.line_weight || '';
      return {
        question: 'Last component: the reel seat.',
        motivation: wt2
          ? 'For ' + wt2 + ', locking is standard. Slide-band for light line; aluminum for saltwater.'
          : 'Locking is standard; slide-band for light line; aluminum for saltwater.'
      };
    }
    if (step.id === 'wrap_level') {
      return {
        question: 'How much wrap detail do you want?',
        motivation: 'Solid is timeless. Trim bands or detailed accents add personality. Advanced and Custom are show-quality.'
      };
    }
    if (step.id === 'priorities') {
      return {
        question: 'Anything that matters most? Your builder uses this to choose between trade-offs.',
        motivation: 'Tap the one that matters most.'
      };
    }
    return def;
  }

  var FLY_PHASE_BRIDGES = {
    'Your Fly Fishery': { intro: 'Got it.', body: "Let’s talk about the water." },
    'Rod Specs':         { intro: 'Nice.',   body: "Now we’ll spec the rod." },
    'Components':        { intro: 'Ready.',  body: "Now the build details." },
    'Customization':     { intro: '',        body: "Almost done — the fun part." }
  };

  function renderPhaseBridgeBanner(step) {
    if (!isFlyV2) return '';
    if (!step.phase) return '';
    if (state._lastPhase === step.phase) return '';
    var bridge = FLY_PHASE_BRIDGES[step.phase];
    if (!bridge) return '';
    var intro = bridge.intro ? '<strong>' + escHtml(bridge.intro) + '</strong> ' : '';
    return '<div class="plrt-est-phase-bridge" role="status">' +
      intro + escHtml(bridge.body) +
      '</div>';
  }

  function renderAutoDefaultBanner(step) {
    if (!isFlyV2) return '';
    var v = state.values;
    if (step.id === 'action_feel'
        && v.fly_rod_class === 'Single-Hand'
        && v.rod_length === "9'0\""
        && !v._rod_length_overridden
        && !v._9ft_default_dismissed) {
      var wtLabel = v.line_weight ? ' for ' + v.line_weight : '';
      return '<button type="button" class="plrt-est-default-banner" data-default-banner="rod_length" data-reopen="rod_length">' +
        '<span class="plrt-est-default-check" aria-hidden="true">✓</span>' +
        '<span class="plrt-est-default-text">We picked <strong>9’0"</strong> &mdash; the workhorse Batson fly length' + escHtml(wtLabel) + '. <em>Tap to change.</em></span>' +
        '</button>';
    }
    if (step.id === 'guide_material'
        && v.fly_rod_class === 'Single-Hand'
        && v.grip_shape === 'Full-Wells'
        && !v._grip_shape_overridden
        && !v._fw_default_dismissed) {
      return '<button type="button" class="plrt-est-default-banner" data-default-banner="grip_shape" data-reopen="grip_shape">' +
        '<span class="plrt-est-default-check" aria-hidden="true">✓</span>' +
        '<span class="plrt-est-default-text">We picked <strong>Full-Wells</strong> &mdash; the standard single-hand fly grip. <em>Tap to change.</em></span>' +
        '</button>';
    }
    return '';
  }

  function renderStep() {
    state.activePanel = null; // a question is showing — no modal panel is active
    var active = getActiveSteps();
    var idx = state.currentStep;
    plrtDbg('renderStep: idx', idx, '/', active.length, idx < active.length ? ('(' + active[idx].id + ')') : '(→calc)');
    if (idx >= active.length) {
      showCalculating();
      return;
    }

    var step = active[idx];
    var total = active.length;
    var pct = ((idx + 1) / total) * 100;

    var copy = getStepCopy(step);

    if (progressFill) progressFill.style.width = pct + '%';
    if (stepCount) stepCount.textContent = 'Question ' + (idx + 1) + ' of ' + total;
    if (motivation) motivation.textContent = copy.motivation || '';

    var phaseLabel = document.getElementById('plrt-est-phase-label');
    if (phaseLabel && step.phase) phaseLabel.textContent = step.phase;

    updateContextBar();

    var livePrice = document.getElementById('plrt-est-live-price');
    var livePriceValue = document.getElementById('plrt-est-live-price-value');
    var livePriceLabel = livePrice ? livePrice.querySelector('.plrt-est-live-price-label') : null;
    if (livePrice && livePriceValue) {
      if (!isMemorial && state.intents.rod_length === 'recommend') {
        if (livePriceLabel) livePriceLabel.textContent = 'Estimate';
        livePriceValue.textContent = 'Pending length recommendation';
        livePriceValue.style.fontSize = '15px';
        livePriceValue.style.fontWeight = '600';
        livePriceValue.style.color = '#777';
        livePrice.style.display = 'block';
      } else {
        var gateOpen = !!state.values.rod_length
          && (isFlyV2 || !!state.values.power || state.intents.power === 'recommend');
        if (gateOpen) {
          livePriceValue.style.fontSize = '';
          livePriceValue.style.fontWeight = '';
          livePriceValue.style.color = '';
          if (livePriceLabel) livePriceLabel.textContent = 'Estimated Range';
          var preview = calculateEstimate();
          animatePriceUpdate(livePriceValue, preview.rangeText);
          livePrice.style.display = 'block';
        }
      }
    }

    renderLiveBuild();

    var html = '';
    html += '<div class="plrt-est-step">';
    if (idx > 0) {
      html += '<button type="button" class="plrt-est-back" id="plrt-est-back-btn">\u2190 Back</button>';
    }
    html += renderPhaseBridgeBanner(step);
    html += renderAutoDefaultBanner(step);
    html += '<div class="plrt-est-step-category">' + escHtml(step.category) + '</div>';
    html += '<div class="plrt-est-step-question">' + escHtml(copy.question) + '</div>';
    if (copy.motivation) {
      html += '<div class="plrt-est-step-motivation-mobile">' + escHtml(copy.motivation) + '</div>';
    }

    if (step.type === 'path_picker') {
      html += '<div class="plrt-est-path-picker" role="radiogroup" aria-label="Choose your path">';
      for (var p = 0; p < step.options.length; p++) {
        var popt = step.options[p];
        var pselected = state.values[step.id] === popt.value;
        html += '<button type="button" class="plrt-est-path-card' + (pselected ? ' is-selected' : '') + '"' +
                ' role="radio" aria-checked="' + (pselected ? 'true' : 'false') + '"' +
                ' data-step="' + step.id + '" data-value="' + escAttr(popt.value) + '"' +
                ' tabindex="' + (p === 0 || pselected ? '0' : '-1') + '">';
        html += '<div class="plrt-est-path-card-label">' + escHtml(popt.label) + '</div>';
        html += '<div class="plrt-est-path-card-desc">' + escHtml(popt.desc) + '</div>';
        html += '<div class="plrt-est-path-card-duration">' + escHtml(popt.duration) + '</div>';
        html += '</button>';
      }
      html += '</div>';
    } else if (step.type === 'rod_length') {
      html += renderRodLengthStep(step);
    } else if (step.type === 'text_input') {
      var currentVal = state.values[step.id] || '';
      html += '<div class="plrt-est-text-input-wrap">';
      html += '<input type="text" class="plrt-est-text-field" id="plrt-est-text-field" placeholder="' + escAttr(step.placeholder || '') + '" value="' + escAttr(currentVal) + '" autocomplete="off">';
      html += '<div class="plrt-est-text-btns">';
      if (step.optional) {
        html += '<button type="button" class="plrt-est-skip-btn" id="plrt-est-skip-btn">Skip</button>';
      }
      html += '<button type="button" class="plrt-est-next-btn" id="plrt-est-next-btn">Next</button>';
      html += '</div>';
      html += '</div>';
    } else if (step.type === 'multi_select') {
      var colClass = step.cols === 1 ? 'plrt-est-cards--1col' : 'plrt-est-cards--2col';
      var currentSelections = state.values[step.id] || [];
      html += '<div class="plrt-est-cards ' + colClass + '">';
      for (var i = 0; i < step.options.length; i++) {
        var opt = step.options[i];
        var value = typeof opt === 'string' ? opt : opt.value;
        var label = typeof opt === 'string' ? opt : opt.label;
        var isSelected = currentSelections.indexOf(value) > -1 ? ' is-selected' : '';
        html += '<button type="button" class="plrt-est-card plrt-est-card--multi' + isSelected + '" data-step="' + step.id + '" data-value="' + escAttr(value) + '">';
        html += '<div class="plrt-est-card-label">' + escHtml(label) + '</div>';
        html += '</button>';
      }
      html += '</div>';
      if (!step.autoAdvance) {
        html += '<div class="plrt-est-multi-hint">Select up to ' + (step.maxSelect || 2) + '</div>';
        html += '<button type="button" class="plrt-est-next-btn" id="plrt-est-next-btn"' + (currentSelections.length === 0 ? ' disabled' : '') + '>Next</button>';
      }
    } else {
      var colClass = step.cols === 1 ? 'plrt-est-cards--1col' : 'plrt-est-cards--2col';
      html += '<div class="plrt-est-cards ' + colClass + '">';
      var options = step.options;
      if (step.id === 'target_species' && !isMemorial && fisheryAttribution.region) {
        var regional = getRegionalSpecies(fisheryAttribution.region);
        if (regional) options = regional;
      }
      if (step.id === 'technique' && !isMemorial && !isFlyV2 && fisheryAttribution.region && state.values.target_species) {
        var regionalTechs = getTechniquesForRegionSpecies(fisheryAttribution.region, state.values.target_species);
        if (regionalTechs) options = regionalTechs;
      }
      if (step.id === 'technique' && isFlyV2) {
        var regionList = getFlyTechniquesForRegion(fisheryAttribution.region);
        var classList = null;
        var cls = state.values.fly_rod_class;
        if (cls === 'Spey') {
          classList = ['Swing / Wet Fly','Spey / Two-Hand','Streamer','Big-Water Streamer','Other'];
        } else if (cls === 'Switch') {
          classList = ['Swing / Wet Fly','Spey / Two-Hand','Indicator Nymphing','Streamer','Big-Water Streamer','Other'];
        }
        if (regionList && classList) {
          var rSet = {};
          for (var ri = 0; ri < regionList.length; ri++) rSet[regionList[ri]] = true;
          var intersect = [];
          for (var ci = 0; ci < classList.length; ci++) {
            if (rSet[classList[ci]]) intersect.push(classList[ci]);
          }
          var meaningful = 0;
          for (var mi = 0; mi < intersect.length; mi++) {
            if (intersect[mi] !== 'Other') meaningful++;
          }
          options = meaningful ? intersect : classList;
        } else if (regionList) {
          options = regionList;
        } else if (classList) {
          options = classList;
        }
      }
      if (step.id === 'line_weight' && isFlyV2) {
        var lwCls = state.values.fly_rod_class;
        if (lwCls === 'Spey') {
          options = ['6wt','7wt','8wt','9wt','10wt'];
        } else if (lwCls === 'Switch') {
          options = ['5wt','6wt','7wt','8wt'];
        } else {
          options = ['3wt','4wt','5wt','6wt','7wt','8wt','9wt','10wt','11wt','12wt'];
        }
        options = options.concat([{ value: '__recommend__', label: 'Recommend the best fit for me' }]);
      }
      if (step.id === 'grip_shape' && isFlyV2) {
        var gsCls = state.values.fly_rod_class;
        options = step.options.filter(function(o) {
          if (o.value === 'Reverse Half-Wells') return gsCls === 'Spey';
          if (o.value === 'Spey Two-Hand') return gsCls === 'Spey' || gsCls === 'Switch';
          return true;
        });
      }
      if (step.id === 'reel_seat_type' && isFlyV2) {
        var rsLw = parseInt((state.values.line_weight || '').replace('wt',''), 10);
        var rsTech = state.values.technique || '';
        var rsSalt = /^Saltwater/.test(rsTech);
        options = step.options.filter(function(o) {
          if (o.value === 'Slide-Band') return !rsLw || rsLw <= 6;
          if (o.value === 'Skeleton with Wood Insert') return !rsLw || rsLw <= 7;
          if (o.value === 'All-Aluminum Saltwater') return rsSalt || (rsLw && rsLw >= 7);
          return true;
        });
      }
      for (var i = 0; i < options.length; i++) {
        var opt = options[i];
        var value = typeof opt === 'string' ? opt : opt.value;
        var label = typeof opt === 'string' ? opt : opt.label;
        var desc = typeof opt === 'object' ? opt.desc : null;
        var selected = state.values[step.id] === value ? ' is-selected' : '';
        var recommendedTag = '';
        if (isFlyV2) {
          if (step.id === 'grip_material' && value === 'Super Grade Cork') {
            recommendedTag = '<span class="plrt-est-card-tag">Prolite standard</span>';
          } else if (step.id === 'guide_material' && value === 'Premium') {
            recommendedTag = '<span class="plrt-est-card-tag">Most chosen</span>';
          } else if (step.id === 'rod_format' && value === '4-Piece') {
            recommendedTag = '<span class="plrt-est-card-tag">Most chosen</span>';
          }
        }
        html += '<button type="button" class="plrt-est-card' + selected + '" data-step="' + step.id + '" data-value="' + escAttr(value) + '">';
        if (typeof opt === 'object' && opt.image) {
          html += '<img class="plrt-est-card-image" src="' + escAttr(opt.image) + '" alt="" loading="lazy">';
        }
        html += '<div class="plrt-est-card-label">' + escHtml(label) + recommendedTag + '</div>';
        if (desc) html += '<div class="plrt-est-card-desc">' + escHtml(desc) + '</div>';
        html += '</button>';
      }
      html += '</div>';
      if (step.id === 'reel_seat_type' && isFlyV2) {
        var fbLw = parseInt((state.values.line_weight || '').replace('wt',''), 10);
        var fbCls = state.values.fly_rod_class;
        var showFightingButt = fbLw >= 8 || fbCls === 'Spey' || fbCls === 'Switch';
        if (showFightingButt) {
          var fbChecked = state.values.fighting_butt === 'Yes' ? ' checked' : '';
          html += '<label class="plrt-est-addon" style="display:flex;align-items:flex-start;gap:10px;margin-top:18px;padding:14px;border:1px solid rgba(0,0,0,0.08);border-radius:8px;cursor:pointer;font-size:14px;line-height:1.45;">';
          html += '<input type="checkbox" id="plrt-est-fighting-butt" data-addon="fighting_butt"' + fbChecked + ' style="margin-top:3px;flex-shrink:0;">';
          html += '<span><strong>Add a fighting butt</strong><br><span style="color:#777;">Extra leverage on big fish — saltwater / steelhead.</span></span>';
          html += '</label>';
        }
      }
    }

    html += '</div>';

    rightPanel.innerHTML = html;
    bindStepEvents(step);
    state._lastPhase = step.phase || state._lastPhase;
  }
  var CONVENTIONAL_QUICK_PICK_LENGTHS = ["6'6\"","7'0\"","7'6\"","7'10\"","8'6\"","9'0\"","10'6\""];
  function getQuickPickLengths() {
    if (isFlyV2) {
      var cls = state && state.values && state.values.fly_rod_class;
      var lw  = state && state.values && state.values.line_weight;
      if (cls === 'Single-Hand' && lw && FLY_BLANK_MATRIX[lw] && FLY_BLANK_MATRIX[lw].length) {
        return FLY_BLANK_MATRIX[lw].slice();
      }
      if (cls && flyRodLengthRanges[cls]) {
        var buckets = flyRodLengthRanges[cls];
        var seen = {};
        var flat = [];
        for (var bi = 0; bi < buckets.length; bi++) {
          var bl = buckets[bi].lengths;
          for (var bj = 0; bj < bl.length; bj++) {
            if (!seen[bl[bj]]) { seen[bl[bj]] = 1; flat.push(bl[bj]); }
          }
        }
        return flat;
      }
    }
    return CONVENTIONAL_QUICK_PICK_LENGTHS.slice();
  }

  function normalizeCustomLength(s) {
    if (!s) return '';
    var out = String(s).trim()
      .replace(/[‘’ʼ′]/g, "'")
      .replace(/[“”″]/g, '"');
    return out;
  }

  function renderRodLengthStep(step) {
    var html = '';
    var colClass = 'plrt-est-cards--2col';
    var lengths = getQuickPickLengths();
    var customExisting = state.values._rod_length_custom || '';

    html += '<div class="plrt-est-cards ' + colClass + '" id="plrt-est-length-cards">';
    for (var i = 0; i < lengths.length; i++) {
      var len = lengths[i];
      var selected = (state.values.rod_length === len && state.intents.rod_length !== 'recommend' && state.intents.rod_length !== 'custom') ? ' is-selected' : '';
      html += '<button type="button" class="plrt-est-card' + selected + '" data-step="rod_length" data-value="' + escAttr(len) + '">';
      html += '<div class="plrt-est-card-label">' + escHtml(len) + '</div>';
      html += '</button>';
    }
    var recSelected = state.intents.rod_length === 'recommend' ? ' is-selected' : '';
    html += '<button type="button" class="plrt-est-card' + recSelected + '" data-step="rod_length" data-value="__recommend__">';
    html += '<div class="plrt-est-card-label">Let Prolite recommend</div>';
    html += '<div class="plrt-est-card-desc">Builder picks based on how you fish.</div>';
    html += '</button>';
    html += '</div>';

    html += '<div class="plrt-est-length-custom" style="margin-top:14px;">';
    html += '<label for="plrt-est-length-custom-input" style="display:block;font-size:14px;color:#333;margin-bottom:6px;">Have a specific length in mind?</label>';
    html += '<div style="display:flex;gap:8px;">';
    html += '<input type="text" id="plrt-est-length-custom-input" autocomplete="off" placeholder="Example: 8&#39;2&quot;, 9&#39;6&quot;, 10&#39;6&quot;" value="' + escAttr(customExisting) + '" style="flex:1;padding:10px 12px;border:1px solid rgba(0,0,0,0.12);border-radius:8px;font-size:15px;">';
    html += '<button type="button" id="plrt-est-length-custom-next" class="plrt-est-next-btn" style="flex:0 0 auto;">Use this length</button>';
    html += '</div>';
    html += '</div>';

    return html;
  }

  function bindStepEvents(step) {
    if (step.type === 'path_picker') {
      var pathCards = rightPanel.querySelectorAll('.plrt-est-path-card');
      function selectPathCard(card) {
        var value = card.getAttribute('data-value');
        pathCards.forEach(function(c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-checked', 'false');
          c.setAttribute('tabindex', '-1');
        });
        card.classList.add('is-selected');
        card.setAttribute('aria-checked', 'true');
        card.setAttribute('tabindex', '0');
        card.focus();
        state.values[step.id] = value;
        state.intents[step.id] = 'specific';
        pushEvent('estimator_step_complete', { step_name: step.id, step_value: value, step_number: state.currentStep + 1 });
        if (step.id === 'memorial_rod_source') {
          pushEvent('memorial_rod_source_selected', { source: value });
        } else {
          pushEvent('memorial_path_selected', { path: value });
        }
        setTimeout(function() { advanceStep(); }, 260);
      }
      pathCards.forEach(function(card, idx) {
        card.addEventListener('click', function() { selectPathCard(this); });
        card.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectPathCard(this);
          } else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            var next = pathCards[(idx + 1) % pathCards.length];
            next.setAttribute('tabindex', '0');
            this.setAttribute('tabindex', '-1');
            next.focus();
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            var prev = pathCards[(idx - 1 + pathCards.length) % pathCards.length];
            prev.setAttribute('tabindex', '0');
            this.setAttribute('tabindex', '-1');
            prev.focus();
          }
        });
      });
      if (pathCards.length) pathCards[0].focus();
    } else if (step.type === 'rod_length') {
      var lengthCards = rightPanel.querySelectorAll('[data-step="rod_length"][data-value]');
      lengthCards.forEach(function(card) {
        card.addEventListener('click', function() {
          var raw = this.getAttribute('data-value');
          lengthCards.forEach(function(c) { c.classList.remove('is-selected'); });
          this.classList.add('is-selected');
          if (raw === '__recommend__') {
            state.values.rod_length = '';
            state.values._rod_length_custom = '';
            state.intents.rod_length = 'recommend';
            pushEvent('estimator_step_complete', { step_name: 'rod_length', step_value: 'recommend', step_number: state.currentStep + 1 });
          } else {
            state.values.rod_length = raw;
            state.values._rod_length_custom = '';
            state.intents.rod_length = 'specific';
            if (isFlyV2 && state.values.fly_rod_class === 'Single-Hand' && state.values.line_weight) {
              state.selectedRange = 'fly_wt_filtered';
            }
            pushEvent('estimator_step_complete', { step_name: 'rod_length', step_value: raw, step_number: state.currentStep + 1 });
          }
          setTimeout(function() { advanceStep(); }, 180);
        });
      });

      var customInput = document.getElementById('plrt-est-length-custom-input');
      var customBtn = document.getElementById('plrt-est-length-custom-next');
      function submitCustomLength() {
        if (!customInput) return;
        var typed = normalizeCustomLength(customInput.value);
        if (!typed) { customInput.focus(); return; }
        state.values.rod_length = typed;
        state.values._rod_length_custom = typed;
        state.intents.rod_length = 'custom';
        pushEvent('estimator_step_complete', { step_name: 'rod_length', step_value: 'custom:' + typed, step_number: state.currentStep + 1 });
        advanceStep();
      }
      if (customBtn) customBtn.addEventListener('click', submitCustomLength);
      if (customInput) {
        customInput.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') { e.preventDefault(); submitCustomLength(); }
        });
      }
    } else if (step.type === 'text_input') {
      var textField = document.getElementById('plrt-est-text-field');
      var nextBtn = document.getElementById('plrt-est-next-btn');
      var skipBtn = document.getElementById('plrt-est-skip-btn');

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          var trimmed = textField ? textField.value.trim() : '';
          state.values[step.id] = trimmed;
          state.intents[step.id] = trimmed ? 'specific' : 'skip';
          pushEvent('estimator_step_complete', { step_name: step.id, step_value: state.values[step.id] || '(skipped)', step_number: state.currentStep + 1 });
          advanceStep();
        });
      }
      if (skipBtn) {
        skipBtn.addEventListener('click', function() {
          state.values[step.id] = '';
          state.intents[step.id] = 'skip';
          pushEvent('estimator_step_complete', { step_name: step.id, step_value: '(skipped)', step_number: state.currentStep + 1 });
          advanceStep();
        });
      }
      if (textField) {
        textField.focus();
        textField.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') { e.preventDefault(); if (nextBtn) nextBtn.click(); }
        });
      }
    } else if (step.type === 'multi_select') {
      var maxSel = step.maxSelect || 2;
      if (!Array.isArray(state.values[step.id])) state.values[step.id] = [];
      var multiCards = rightPanel.querySelectorAll('.plrt-est-card--multi');

      if (step.autoAdvance) {
        multiCards.forEach(function(card) {
          card.addEventListener('click', function() {
            var value = this.getAttribute('data-value');
            multiCards.forEach(function(c) { c.classList.remove('is-selected'); });
            this.classList.add('is-selected');
            state.values[step.id] = [value];
            state.intents[step.id] = 'specific';
            pushEvent('estimator_step_complete', { step_name: step.id, step_value: value, step_number: state.currentStep + 1 });
            setTimeout(function() { advanceStep(); }, 180);
          });
        });
      } else {
        var multiNext = document.getElementById('plrt-est-next-btn');
        multiCards.forEach(function(card) {
          card.addEventListener('click', function() {
            var value = this.getAttribute('data-value');
            var arr = state.values[step.id];
            var idx = arr.indexOf(value);
            if (idx > -1) {
              arr.splice(idx, 1);
              this.classList.remove('is-selected');
            } else if (arr.length < maxSel) {
              arr.push(value);
              this.classList.add('is-selected');
            }
            if (multiNext) multiNext.disabled = arr.length === 0;
          });
        });
        if (multiNext) {
          multiNext.addEventListener('click', function() {
            state.intents[step.id] = state.values[step.id].length ? 'specific' : 'skip';
            pushEvent('estimator_step_complete', { step_name: step.id, step_value: state.values[step.id].join(', '), step_number: state.currentStep + 1 });
            advanceStep();
          });
        }
      }
    } else {
      var cards = rightPanel.querySelectorAll('[data-step]');
      cards.forEach(function(card) {
        card.addEventListener('click', function() {
          var stepId = this.getAttribute('data-step');
          var value = this.getAttribute('data-value');

          cards.forEach(function(c) { c.classList.remove('is-selected'); });
          this.classList.add('is-selected');

          if (stepId === 'fly_rod_class' && state.values.fly_rod_class && state.values.fly_rod_class !== value) {
            state.values.line_weight = '';
            state.values.rod_length = '';
            state.values._rod_length_overridden = false;
            state.values.grip_shape = '';
            state.values._grip_shape_overridden = false;
            state.selectedRange = null;
          }

          if (stepId === 'line_weight' && state.values.line_weight && state.values.line_weight !== value) {
            state.values.rod_length = '';
            state.values._rod_length_overridden = false;
            state.selectedRange = null;
          }

          if (value === '__recommend__') {
            state.values[stepId] = '';
            state.intents[stepId] = 'recommend';
          } else {
            state.values[stepId] = value;
            state.intents[stepId] = 'specific';
          }

          if (stepId === 'wrap_level') {
            state.values.customization_level = wrapLevelToCustomizationLegacy(value);
          }

          if (stepId === 'fly_rod_class' && isFlyV2 && value === 'Single-Hand' && !state.values.grip_shape) {
            state.values.grip_shape = 'Full-Wells';
            state.values._grip_shape_overridden = false;
          }

          if (stepId === 'line_weight' && isFlyV2 && state.values.fly_rod_class === 'Single-Hand'
              && FLY_BLANK_MATRIX[value] && FLY_BLANK_MATRIX[value].indexOf("9'0\"") > -1
              && !state.values.rod_length) {
            state.values.rod_length = "9'0\"";
            state.values._rod_length_overridden = false;
            state.selectedRange = 'fly_wt_filtered';
          }

          if (stepId === 'line_weight' && isFlyV2 && state.values.fly_rod_class === 'Single-Hand'
              && !state.values._grip_shape_overridden) {
            var lwNum = parseInt(value, 10);
            if (!isNaN(lwNum)) {
              state.values.grip_shape = (lwNum <= 6) ? 'Half-Wells' : 'Full-Wells';
            }
          }

          pushEvent('estimator_step_complete', { step_name: stepId, step_value: value, step_number: state.currentStep + 1 });
          plrtDbg('card click:', stepId, '=', value, '| editMode', !!state.estimateCompleted);

          setTimeout(function() { advanceStep(); }, 180);
        });
      });

      var fbCheckbox = rightPanel.querySelector('[data-addon="fighting_butt"]');
      if (fbCheckbox) {
        fbCheckbox.addEventListener('change', function() {
          state.values.fighting_butt = this.checked ? 'Yes' : 'No';
          pushEvent('estimator_addon_toggle', { addon: 'fighting_butt', value: state.values.fighting_butt });
        });
      }
    }

    var defaultBanner = rightPanel.querySelector('[data-default-banner]');
    if (defaultBanner) {
      defaultBanner.addEventListener('click', function() {
        var which = this.getAttribute('data-reopen');
        if (which === 'rod_length') {
          state.values._9ft_default_dismissed = true;
          state.values._rod_length_overridden = true;
          state.values.rod_length = '';
          state.selectedRange = null;
          var newActive = getActiveSteps();
          var rlIdx = newActive.findIndex(function(s) { return s.id === 'rod_length'; });
          if (rlIdx >= 0) state.currentStep = rlIdx;
        } else if (which === 'grip_shape') {
          state.values._fw_default_dismissed = true;
          state.values._grip_shape_overridden = true;
          var newActive2 = getActiveSteps();
          var gsIdx = newActive2.findIndex(function(s) { return s.id === 'grip_shape'; });
          if (gsIdx >= 0) state.currentStep = gsIdx;
        }
        pushEvent('estimator_default_banner_tap', { default: which });
        renderStep();
      });
    }

    var backBtn = document.getElementById('plrt-est-back-btn');
    if (backBtn) {
      backBtn.addEventListener('click', function() {
        if (state.currentStep > 0) {
          if (step.id === 'rod_length') state.selectedRange = null;
          state.currentStep--;
          renderStep();
        }
      });
    }
  }

  function advanceStep() {
    try {
      var prevActive = getActiveSteps();
      var justCompletedStep = prevActive[state.currentStep];
      var justCompletedId = justCompletedStep ? justCompletedStep.id : '';
      plrtDbg('advanceStep: completed', justCompletedId, '| currentStep', state.currentStep, '| estimateCompleted', !!state.estimateCompleted);

      if (justCompletedId === 'region' && state.values.region) {
        fisheryAttribution.region = state.values.region;
        try {
          var ctx = {};
          var storedCtx = sessionStorage.getItem('prolite_fishery_context');
          if (storedCtx) ctx = JSON.parse(storedCtx) || {};
          ctx.region = state.values.region;
          sessionStorage.setItem('prolite_fishery_context', JSON.stringify(ctx));
        } catch(e) {}
      }

      // EDIT MODE: the customer already saw an estimate and just changed one
      // component. Apply it, recalculate, and return them to the updated
      // estimate — do NOT walk them back through every remaining question.
      // First pass (estimateCompleted=false) keeps the normal step-by-step
      // auto-advance completely intact.
      if (state.estimateCompleted) {
        plrtDbg('advanceStep: EDIT MODE → recalc + return to results');
        showCalculating();
        return;
      }

      state.currentStep++;
      state.selectedRange = null;
      var active = getActiveSteps();

      if (isMemorial && justCompletedId === 'memorial_features') {
        pushEvent('memorial_story_submitted', {
          memorial_honoree: state.values.memorial_honoree || '',
          memorial_water: state.values.memorial_water || '',
          memorial_features: Array.isArray(state.values.memorial_features) ? state.values.memorial_features.join(', ') : ''
        });

        if (MEMORIAL_FLOW_VERSION === 'v2' && state.values.memorial_path === 'guided') {
          applyGuidedPresetAndJumpToCalculating();
          return;
        }
      }

      if (state.currentStep >= active.length) {
        plrtDbg('advanceStep: first pass complete → calculating');
        showCalculating();
      } else {
        plrtDbg('advanceStep: → step', state.currentStep, active[state.currentStep] && active[state.currentStep].id);
        renderStep();
      }
    } catch (err) {
      if (window.console && window.console.error) console.error('[plrt-estimator] advanceStep failed:', err);
      // Never leave a "selected but stuck" screen — make the click do something
      // visible by recalculating to the estimate.
      try { showCalculating(); } catch (e2) {}
    }
  }

  function applyGuidedPresetAndJumpToCalculating() {
    var preset = buildPresets.memorial_builder_guided;
    if (!preset) return;
    for (var key in preset) {
      if (Object.prototype.hasOwnProperty.call(preset, key)) {
        state.values[key] = preset[key];
      }
    }
    pushEvent('estimator_fast_path', {
      preset: 'memorial_builder_guided',
      fishery: fisheryAttribution.fishery_id || 'memorial',
      region: fisheryAttribution.region || ''
    });
    var active = getActiveSteps();
    state.currentStep = active.length;
    showCalculating();
  }

  function showCalculating() {
    var active = getActiveSteps();
    if (progressFill) progressFill.style.width = '100%';
    if (stepCount) stepCount.textContent = 'Calculating...';
    if (motivation) motivation.textContent = '';

    var calcText = 'Building your estimate...';
    var isGuidedFastPath = (MEMORIAL_FLOW_VERSION === 'v2' && isMemorial && state.values.memorial_path === 'guided');
    if (isGuidedFastPath) {
      calcText = 'Your builder is preparing a balanced memorial build...';
    }

    rightPanel.innerHTML =
      '<div class="plrt-est-calculating" role="status">' +
        '<div class="plrt-est-calculating-text">' + escHtml(calcText) + '</div>' +
        '<div class="plrt-est-spinner"></div>' +
      '</div>';

    setTimeout(function() { finishEstimate(); }, 800);
  }

  function trapFocus(e) {
    if (!overlay.classList.contains('is-open')) return;
    var focusable = dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (focusable.length === 0) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function escHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function escAttr(str) {
    return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function createShopifyCustomer(name, email, phone) {
    var formData = new FormData();
    formData.append('form_type', 'create_customer');
    formData.append('utf8', '\u2713');
    formData.append('customer[first_name]', name || '');
    formData.append('customer[email]', email);
    if (phone) formData.append('customer[phone]', phone);
    formData.append('customer[tags]', 'estimator-lead');

    fetch('/account', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    }).catch(function() {
    });
  }

  function sendEstimatorLead(opts) {
    opts = opts || {};
    var v = state.values || {};
    var r = state.estimateResult;
    var estimateId = getStoredEstimateId();

    var leadForm = document.getElementById('plrt-est-lead-form');
    if (!leadForm) {
      return Promise.resolve({ shopifyOk: false, rbpOk: false, rbpResult: null });
    }
    var formData = new FormData(leadForm);
    if (opts.email) formData.append('contact[email]', opts.email);
    if (opts.name)  formData.append('contact[name]',  opts.name);
    if (opts.phone) formData.append('contact[phone]', opts.phone);
    formData.append('contact[source]', opts.source || 'Estimator');
    formData.append('contact[form_name]', opts.formName || 'prolite_estimator_lead');
    formData.append('contact[page_type]', opts.pageType || 'quote_estimator');
    var tagSuffix = opts.tagSuffix || 'estimator-lead';
    formData.append('contact[tags]', isMemorial ? ('new-lead:' + tagSuffix + ':' + (isOwnRodPath() ? 'memorial:own-rod' : 'memorial')) : (isFlyV2 ? ('new-lead:' + tagSuffix + ':fly') : ('new-lead:' + tagSuffix)));
    formData.append('contact[fishery_id]', fisheryAttribution.fishery_id);
    formData.append('contact[region]', fisheryAttribution.region);
    formData.append('contact[estimate_id]', estimateId);
    formData.append('contact[estimate_range]', r ? r.rangeText : '');
    if (isMemorial) {
      formData.append('contact[memorial_honoree]', v.memorial_honoree || '');
      formData.append('contact[memorial_water]', v.memorial_water || '');
      formData.append('contact[memorial_features]', Array.isArray(v.memorial_features) ? v.memorial_features.join(', ') : '');
      formData.append('contact[memorial_rod_source]', v.memorial_rod_source || 'new_build');
      formData.append('contact[memorial_own_rod_details]', v.memorial_own_rod_details || '');
    }
    formData.append('contact[target_species]', v.target_species || '');
    formData.append('contact[technique]', v.technique || '');
    formData.append('contact[water_location]', isMemorial ? (v.memorial_water || '') : (v.water_location || ''));
    formData.append('contact[rod_length]', v.rod_length || '');
    formData.append('contact[power]', v.power || '');
    formData.append('contact[action_feel]', v.action_feel || '');
    formData.append('contact[rod_format]', v.rod_format || '');
    formData.append('contact[grip_material]', v.grip_material || '');
    formData.append('contact[guide_material]', v.guide_material || '');
    formData.append('contact[guide_tier]', v.guide_material || '');
    formData.append('contact[reel_seat_type]', v.reel_seat_type || '');
    formData.append('contact[customization_level]', v.customization_level || '');
    var wlNum = numericWrapLevel(v.wrap_level);
    formData.append('contact[wrap_level]', wlNum == null ? '' : String(wlNum));
    if (Array.isArray(v.priorities)) formData.append('contact[priorities]', v.priorities.join(', '));
    formData.append('contact[fly_rod_class]', v.fly_rod_class || '');
    formData.append('contact[line_weight]', v.line_weight || '');
    formData.append('contact[grip_shape]', v.grip_shape || '');
    formData.append('contact[fighting_butt]', v.fighting_butt || '');

    var shopifyPromise = fetch('/contact', {
      method: 'POST',
      body: formData,
      redirect: 'manual',
      credentials: 'same-origin'
    }).then(function(res) {
      var ok = res.type === 'opaqueredirect' || (res.status >= 300 && res.status < 400);
      return { shopifyOk: ok, status: res.status, type: res.type };
    }).catch(function() {
      return { shopifyOk: false, status: 0, type: 'error' };
    });

    var rbpPromise;
    if (opts.rbpSource && opts.email) {
      var leadData = {
        source: opts.rbpSource,
        customer: {
          name:  opts.name  || '',
          email: opts.email,
          phone: opts.phone || ''
        },
        specs: {
          species:       v.target_species     || '',
          technique:     v.technique          || '',
          rodLength:     v.rod_length         || '',
          power:         v.power              || '',
          action:        v.action_feel        || '',
          format:        v.rod_format         || '',
          level:         v.customization_level|| '',
          wrapLevel:     numericWrapLevel(v.wrap_level),
          grip:          v.grip_material      || '',
          guideMaterial: v.guide_material     || '',
          guideTier:     v.guide_material     || '',
          reelSeat:      v.reel_seat_type     || '',
          waterLocation: isMemorial ? (v.memorial_water || '') : (v.water_location || ''),
          priorities:    Array.isArray(v.priorities) ? v.priorities.join(', ') : '',
          budgetRange:   isOwnRodPath() ? '' : (r ? r.rangeText : ''),
          notes:         isOwnRodPath() ? ('Customer-owned rod — ' + (v.memorial_own_rod_details || 'details to confirm with builder')) : '',
          flyRodClass:   v.fly_rod_class      || '',
          lineWeight:    v.line_weight        || '',
          gripShape:     v.grip_shape         || '',
          fightingButt:  v.fighting_butt      || ''
        },
        metadata: {
          estimateId:       estimateId,
          fisheryId:        fisheryAttribution.fishery_id,
          region:           fisheryAttribution.region,
          isMemorial:       !!isMemorial,
          memorialHonoree:  v.memorial_honoree || null,
          memorialWater:    v.memorial_water   || null,
          memorialFeatures: Array.isArray(v.memorial_features) ? v.memorial_features : null,
          memorialRodSource:     isMemorial ? (v.memorial_rod_source || 'new_build') : null,
          memorialOwnRodDetails: isOwnRodPath() ? (v.memorial_own_rod_details || '') : null,
          isFly:            !!isFlyV2,
          flyRodClass:      v.fly_rod_class    || null,
          commitmentLevel: opts.commitmentLevel || 'low',
          intents: state.intents || {},
          rodLengthCustom: state.values._rod_length_custom || null
        },
        tags: isMemorial ? (isOwnRodPath() ? ['memorial', 'memorial-own-rod'] : ['memorial']) : (isFlyV2 ? ['fly'] : [])
      };
      var attribution = (window.PLAttribution && window.PLAttribution.collect) ? window.PLAttribution.collect() : {};
      if (Object.keys(attribution).length > 0) leadData.attribution = attribution;

      if (leadData.customer.email) leadData.emailNotificationConsent = true;
      if (leadData.customer.phone) leadData.smsNotificationConsent = true;
      leadData.notificationConsentVersion = 'v5-2026-06-sms-first-legacy';
      leadData.notificationConsentSource = window.location.href;

      rbpPromise = fetch('/apps/proxy/api/leads/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(leadData)
      }).then(function(res) {
        if (!res.ok) return { rbpOk: false, rbpResult: null };
        return res.json().then(function(j) {
          return { rbpOk: !!j.ok, rbpResult: j };
        }).catch(function() {
          return { rbpOk: false, rbpResult: null };
        });
      }).catch(function() {
        return { rbpOk: false, rbpResult: null };
      });
    } else {
      rbpPromise = Promise.resolve({ rbpOk: false, rbpResult: null });
    }

    return Promise.all([shopifyPromise, rbpPromise]).then(function(parts) {
      return {
        shopifyOk: parts[0].shopifyOk,
        shopifyStatus: parts[0].status,
        shopifyType: parts[0].type,
        rbpOk: parts[1].rbpOk,
        rbpResult: parts[1].rbpResult
      };
    });
  }

  function initFormHandlers() {
  }


  function populateBuildHiddenFields() {
    var v = state.values;
    var r = state.estimateResult;
    var setVal = function(id, val) { var el = document.getElementById(id); if (el) el.value = val || ''; };
    var ownRod = isOwnRodPath();
    setVal('plrt-build-estimate-id', getStoredEstimateId());
    setVal('plrt-build-estimate-range', (r && !ownRod) ? r.rangeText : '');
    setVal('plrt-build-species', v.target_species);
    setVal('plrt-build-technique', v.technique);
    setVal('plrt-build-water', isMemorial ? (v.memorial_water || '') : v.water_location);
    setVal('plrt-build-length', v.rod_length);
    setVal('plrt-build-power', v.power);
    setVal('plrt-build-action', v.action_feel);
    setVal('plrt-build-format', v.rod_format);
    setVal('plrt-build-grip', v.grip_material);
    setVal('plrt-build-guides', v.guide_material);
    setVal('plrt-build-reel-seat', v.reel_seat_type);
    setVal('plrt-build-customization', ownRod ? 'Memorial treatment on customer-owned rod' : (isMemorial ? 'Full Custom Art (Memorial)' : v.customization_level));
    setVal('plrt-build-priorities', Array.isArray(v.priorities) ? v.priorities.join(', ') : '');
    setVal('plrt-build-fly-class', v.fly_rod_class);
    setVal('plrt-build-line-weight', v.line_weight);
    setVal('plrt-build-grip-shape', v.grip_shape);
    setVal('plrt-build-fighting-butt', v.fighting_butt);
    setVal('plrt-build-est-low', (r && !ownRod) ? r.low : '');
    setVal('plrt-build-est-high', (r && !ownRod) ? r.high : '');
    var notesEl = document.getElementById('plrt-est-build-notes');
    setVal('plrt-build-notes-hidden', notesEl ? notesEl.value.trim() : '');

    if (isMemorial) {
      setVal('plrt-build-memorial-honoree', v.memorial_honoree);
      setVal('plrt-build-memorial-water', v.memorial_water);
      setVal('plrt-build-memorial-features', Array.isArray(v.memorial_features) ? v.memorial_features.join(', ') : '');
      setVal('plrt-build-memorial-rod-source', v.memorial_rod_source || 'new_build');
      setVal('plrt-build-memorial-own-rod-details', v.memorial_own_rod_details || '');
    }

    var desc = [];
    if (isMemorial) {
      desc.push(isOwnRodPath() ? '--- MEMORIAL ON CUSTOMER-OWNED ROD ---' : '--- MEMORIAL ROD BUILD ---');
      if (v.memorial_honoree) desc.push('Honoring: ' + v.memorial_honoree);
      if (v.memorial_water) desc.push('Their Water: ' + v.memorial_water);
      if (Array.isArray(v.memorial_features) && v.memorial_features.length) desc.push('Features: ' + v.memorial_features.join(', '));
      if (isOwnRodPath()) desc.push('Customer-owned rod: ' + (v.memorial_own_rod_details || '(to confirm with builder)'));
    }
    if (isFlyV2) {
      desc.push('--- FLY ROD BUILD ---');
      if (v.fly_rod_class) desc.push('Rod Class: ' + v.fly_rod_class);
      if (v.line_weight)   desc.push('Line Weight: ' + v.line_weight);
    }
    if (v.target_species) desc.push('Species: ' + v.target_species);
    if (v.technique) desc.push('Technique: ' + v.technique);
    if (!isMemorial && v.water_location) desc.push('Water: ' + v.water_location);
    if (v.rod_length) desc.push('Length: ' + v.rod_length);
    if (v.power) desc.push('Power: ' + v.power);
    if (v.action_feel) desc.push('Action: ' + v.action_feel);
    if (v.rod_format) desc.push('Format: ' + v.rod_format);
    if (v.grip_material) desc.push('Grip: ' + v.grip_material);
    if (v.grip_shape) desc.push('Grip Shape: ' + v.grip_shape);
    if (v.guide_material) desc.push('Guides: ' + v.guide_material);
    if (v.reel_seat_type) desc.push('Reel Seat: ' + v.reel_seat_type);
    if (v.fighting_butt && v.fighting_butt !== 'No') desc.push('Fighting Butt: ' + v.fighting_butt);
    if (isOwnRodPath()) {
      desc.push('Customization: Memorial treatment on customer-owned rod (builder to confirm)');
    } else if (isMemorial) {
      desc.push('Customization: Full Custom Art (Memorial)');
    } else if (v.customization_level) {
      desc.push('Customization: ' + v.customization_level);
    }
    if (Array.isArray(v.priorities) && v.priorities.length) desc.push('Priorities: ' + v.priorities.join(', '));
    if (r && !isOwnRodPath()) desc.push('Estimated Range: ' + r.rangeText);
    if (notesEl && notesEl.value.trim()) desc.push('Notes: ' + notesEl.value.trim());
    if (isFlyV2) {
      var supplierLines = [];
      var actionSku = flySupplierLabel('action', v.action_feel);
      var gripSku   = flySupplierLabel('grip_material', v.grip_material);
      var guideSku  = flySupplierLabel('guide_material', v.guide_material);
      if (actionSku) supplierLines.push('Action (supplier): ' + actionSku);
      if (gripSku)   supplierLines.push('Grip material (supplier): ' + gripSku);
      if (guideSku)  supplierLines.push('Guide package (supplier): ' + guideSku);
      if (supplierLines.length) {
        desc.push('--- SUPPLIER MAPPING ---');
        supplierLines.forEach(function(line) { desc.push(line); });
      }
    }
    setVal('plrt-build-description-hidden', desc.join('\n'));
  }

  function renderBuildSummary() {
    var v = state.values;
    var r = state.estimateResult;
    var el = document.getElementById('plrt-build-summary');
    if (!el) return;

    var items = [];
    if (isMemorial) {
      if (v.memorial_honoree) items.push(['Honoring', v.memorial_honoree]);
      if (v.memorial_water) items.push(['Their Water', v.memorial_water]);
      if (Array.isArray(v.memorial_features) && v.memorial_features.length) items.push(['Features', v.memorial_features.join(', ')]);
      if (isOwnRodPath()) items.push(['Your Rod', v.memorial_own_rod_details || 'To confirm with builder']);
    }
    if (v.fly_rod_class) items.push(['Rod Class', v.fly_rod_class]);
    if (v.line_weight) items.push(['Line Weight', v.line_weight]);
    if (v.target_species) items.push(['Species', v.target_species]);
    if (v.technique) items.push(['Technique', v.technique]);
    if (!isMemorial && v.water_location) items.push(['Water', v.water_location]);
    if (v.rod_length) items.push(['Length', v.rod_length]);
    if (v.power) items.push(['Power', v.power]);
    if (v.action_feel) items.push(['Action', v.action_feel]);
    if (v.rod_format) items.push(['Format', v.rod_format]);
    if (v.grip_material) items.push(['Grip', v.grip_material]);
    if (v.grip_shape) items.push(['Grip Shape', v.grip_shape]);
    if (v.guide_material) items.push(['Guides', v.guide_material]);
    if (v.reel_seat_type) items.push(['Reel Seat', v.reel_seat_type]);
    if (v.fighting_butt && v.fighting_butt !== 'No') items.push(['Fighting Butt', v.fighting_butt]);
    if (isOwnRodPath()) {
      items.push(['Approach', 'Memorial on your own rod']);
    } else if (isMemorial) {
      items.push(['Customization', 'Full Custom Art (Memorial)']);
    } else if (v.customization_level) {
      items.push(['Customization', v.customization_level]);
    }
    if (Array.isArray(v.priorities) && v.priorities.length) items.push(['Priorities', v.priorities.join(', ')]);

    var html = '<dl>';
    for (var i = 0; i < items.length; i++) {
      html += '<dt>' + escHtml(items[i][0]) + ': </dt><dd>' + escHtml(items[i][1]) + '</dd>';
    }
    html += '</dl>';
    if (r && !isOwnRodPath()) {
      html += '<div class="plrt-build-summary-price">' + escHtml(r.rangeText) + '</div>';
    }
    el.innerHTML = html;
  }

  var currentPanelMode = 'save';

  var PANEL_COPY = {
    builder: {
      eyebrow: 'Send to Builder',
      headline: 'Send your estimate to a builder',
      sub: "We'll review your estimate, dial in the final parts and details, and follow up with a formal quote.",
      submit: 'Send to Builder',
      passive:
        "This is a starting point. We'll finalize parts and details with you, then send a formal quote for your approval.",
      formName: 'prolite_estimate_builder_review',
      pageType: 'estimate_review_request',
      commitmentLevel: 'guided_finalize',
      successHeadline: 'Estimate sent to your builder.',
      successBody:
        'Your estimate is saved with Prolite. A builder will review the details and follow up shortly with the next step.',
      conversionEvent: 'estimate_sent_to_builder',
      requiresName: true,
      requiresPhone: true,
      requiresEmail: false,
      phoneLabelSuffix: '',
      emailLabelSuffix: ' (optional — for receipts)'
    },
    save: {
      eyebrow: 'Save Estimate',
      headline: 'Save your estimate',
      sub: "Save your estimate with Prolite. We'll email you a copy and a link to come back when you're ready.",
      submit: 'Save My Estimate',
      passive: "Reply to the email anytime if you want a builder to take a look.",
      formName: 'prolite_estimate_save',
      pageType: 'estimate_save',
      commitmentLevel: 'low',
      successHeadline: 'Your estimate is saved.',
      successBody:
        "We've emailed you a copy. You can come back anytime — or reply to the email when you want a builder to take a look.",
      conversionEvent: 'estimate_saved',
      requiresName: false,
      requiresPhone: false,
      requiresEmail: true,
      phoneLabelSuffix: ' (optional)',
      emailLabelSuffix: ''
    }
  };

  function applyPanelMode(mode) {
    var copy = PANEL_COPY[mode] || PANEL_COPY.builder;
    currentPanelMode = mode;
    var phase5 = document.getElementById('plrt-build-phase-5');
    if (!phase5) return;
    var eyebrowEl = phase5.querySelector('.plrt-est-eyebrow');
    var headlineEl = phase5.querySelector('h2');
    var subEl = phase5.querySelector('h2 + p');
    var submitEl = document.getElementById('plrt-build-submit-btn');
    var passiveEl = phase5.querySelector('.plrt-build-passive-note');
    var formNameField = document.querySelector('input[name="contact[form_name]"]');
    var pageTypeField = document.querySelector('input[name="contact[page_type]"]');
    if (eyebrowEl) eyebrowEl.textContent = copy.eyebrow;
    if (headlineEl) headlineEl.textContent = copy.headline;
    if (subEl) subEl.textContent = copy.sub;
    if (submitEl) submitEl.textContent = copy.submit;
    if (passiveEl) passiveEl.textContent = copy.passive;
    if (formNameField) formNameField.value = copy.formName;
    if (pageTypeField) pageTypeField.value = copy.pageType;

    var emailInput = phase5.querySelector('[data-notify-pref="email-field"]');
    var phoneInput = phase5.querySelector('[data-notify-pref="phone-field"]');
    var emailLabel = phase5.querySelector('label[for="' + (emailInput ? emailInput.id : '') + '"]');
    var phoneLabel = phase5.querySelector('label[for="' + (phoneInput ? phoneInput.id : '') + '"]');

    if (emailInput) {
      if (copy.requiresEmail) {
        emailInput.setAttribute('required', '');
        emailInput.setAttribute('aria-required', 'true');
      } else {
        emailInput.removeAttribute('required');
        emailInput.removeAttribute('aria-required');
      }
    }
    if (phoneInput) {
      if (copy.requiresPhone) {
        phoneInput.setAttribute('required', '');
        phoneInput.setAttribute('aria-required', 'true');
      } else {
        phoneInput.removeAttribute('required');
        phoneInput.removeAttribute('aria-required');
      }
    }

    function setLabelSuffix(labelEl, suffix) {
      if (!labelEl) return;
      var span = labelEl.querySelector('[data-mode-suffix]');
      if (!span) {
        span = document.createElement('span');
        span.setAttribute('data-mode-suffix', '1');
        span.style.color = '#9ca3af';
        span.style.fontWeight = '400';
        span.style.marginLeft = '4px';
        labelEl.appendChild(span);
      }
      span.textContent = suffix || '';
      span.style.display = suffix ? '' : 'none';
    }
    setLabelSuffix(emailLabel, copy.emailLabelSuffix);
    setLabelSuffix(phoneLabel, copy.phoneLabelSuffix);
  }

  function showHandoffPanel(mode) {
    applyPanelMode(mode || 'builder');
    showModalPanel('plrt-est-handoff-panel');
    document.getElementById('plrt-build-phase-5').style.display = 'block';
    populateBuildHiddenFields();
    renderBuildSummary();
    pushEvent('estimator_handoff_open', { mode: currentPanelMode });

    var nameField = document.getElementById('plrt-build-name');
    if (nameField && !nameField.value) setTimeout(function() { nameField.focus(); }, 100);
  }

  // Returns the first required-but-missing/invalid contact field for `mode`, or
  // null when the prefilled values already satisfy the form. Mirrors the build-
  // form submit validation (see the buildForm submit handler in initBuildForm)
  // so a "ready" result here guarantees the subsequent submit clears validation.
  function firstInvalidHandoffField(mode, buildForm) {
    var modeCopy = PANEL_COPY[mode] || PANEL_COPY.builder;
    function phoneOk(v) {
      var d = (v || '').replace(/\D/g, '');
      if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
      return d.length === 10;
    }
    function emailOk(v) { return v.indexOf('@') !== -1 && v.indexOf('.') !== -1; }
    var nameField = document.getElementById('plrt-build-name');
    var emailField = buildForm.querySelector('[name="contact[email]"]');
    var phoneField = buildForm.querySelector('[name="contact[phone]"]');
    var emailVal = emailField ? emailField.value.trim() : '';
    var phoneVal = phoneField ? phoneField.value.trim() : '';
    if (modeCopy.requiresName && (!nameField || !nameField.value.trim())) return nameField || null;
    if (modeCopy.requiresEmail) {
      if (!emailVal || !emailOk(emailVal)) return emailField || null;
    } else if (emailVal && !emailOk(emailVal)) {
      return emailField;
    }
    if (modeCopy.requiresPhone) {
      if (!phoneVal || !phoneOk(phoneVal)) return phoneField || null;
    } else if (phoneVal && !phoneOk(phoneVal)) {
      return phoneField;
    }
    return null;
  }

  function submitHandoffDirect(mode, buildForm) {
    applyPanelMode(mode);
    populateBuildHiddenFields();
    // Never fire a submit while the handoff panel is hidden: its only failure
    // surface (#plrt-build-phase5-error) and the OTP box both live INSIDE that
    // panel, so a missing required field (e.g. a logged-in customer with no
    // phone on file) wrote an invisible error and the button looked dead. When
    // the prefill is incomplete, reveal the prefilled panel and focus the field
    // to fix; only keep the one-click direct submit when everything's ready.
    var needsField = firstInvalidHandoffField(mode, buildForm);
    if (needsField) {
      showHandoffPanel(mode);
      setTimeout(function() { try { needsField.focus(); } catch (e) {} }, 120);
      return;
    }
    if (typeof buildForm.requestSubmit === 'function') {
      buildForm.requestSubmit();
    } else {
      buildForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
  }

  function initBuildForm() {
    var sendBtn = document.getElementById('plrt-est-send-to-builder-btn');
    var saveBtn = document.getElementById('plrt-est-save-estimate-btn');
    var backToEstimate = document.getElementById('plrt-build-back-to-estimate');
    var buildForm = document.getElementById('plrt-est-build-form');

    if (sendBtn) {
      sendBtn.addEventListener('click', function() {
        pushEvent('estimator_send_to_builder', getRodSpecParams());
        var isKnown = sendBtn.getAttribute('data-customer-known') === 'true';
        if (isKnown && buildForm) {
          submitHandoffDirect('builder', buildForm);
        } else {
          openMessengerForAnonBuilder();
        }
      });
    }

    if (saveBtn) {
      saveBtn.addEventListener('click', function() {
        pushEvent('estimator_save_estimate', getRodSpecParams());
        var isKnown = saveBtn.getAttribute('data-customer-known') === 'true';
        if (isKnown && buildForm) {
          submitHandoffDirect('save', buildForm);
        } else {
          showHandoffPanel('save');
        }
      });
    }

    if (backToEstimate) {
      backToEstimate.addEventListener('click', function() {
        showModalPanel('plrt-est-results-panel');
      });
    }

    var verifyState = {
      token: null,
      phone: null,
      resendTimer: null,
      resendSecondsLeft: 0,
      sending: false,
      bypassed: false
    };

    function setOtpResendCountdown(seconds) {
      verifyState.resendSecondsLeft = seconds;
      var resendEl = document.getElementById('plrt-otp-resend');
      if (!resendEl) return;
      if (seconds > 0) {
        resendEl.classList.remove('is-ready');
        resendEl.textContent = 'Resend in ' + seconds + 's';
      } else {
        resendEl.classList.add('is-ready');
        resendEl.textContent = 'Resend code';
      }
    }
    function startOtpResendTimer() {
      if (verifyState.resendTimer) clearInterval(verifyState.resendTimer);
      setOtpResendCountdown(30);
      verifyState.resendTimer = setInterval(function() {
        if (verifyState.resendSecondsLeft <= 1) {
          setOtpResendCountdown(0);
          if (verifyState.resendTimer) clearInterval(verifyState.resendTimer);
          verifyState.resendTimer = null;
        } else {
          setOtpResendCountdown(verifyState.resendSecondsLeft - 1);
        }
      }, 1000);
    }

    function showOtpPanel(phoneE164Display) {
      var panel = document.getElementById('plrt-otp-panel');
      if (!panel) return;
      // The OTP box lives INSIDE the handoff panel. When we reach here via the
      // direct known-customer submit (submitHandoffDirect with all fields already
      // prefilled — e.g. a logged-in customer who has a phone on file), that
      // panel was never opened, so the OTP box would render inside a
      // display:none ancestor: invisible code box, dead-looking button. Reveal
      // the handoff panel (+ its phase-5 contact section) before showing the box.
      // No-op when the panel is already open (normal flow). Customers who are
      // already verified skip OTP entirely, so this never runs for them.
      showModalPanel('plrt-est-handoff-panel');
      var phase5El = document.getElementById('plrt-build-phase-5');
      if (phase5El) phase5El.style.display = 'block';
      panel.style.display = 'block';
      var display = document.getElementById('plrt-otp-phone-display');
      if (display) display.textContent = phoneE164Display;
      var input = document.getElementById('plrt-otp-code');
      if (input) {
        input.value = '';
        setTimeout(function() { try { input.focus(); } catch (e) {} }, 30);
      }
      var err = document.getElementById('plrt-otp-error');
      if (err) err.style.display = 'none';
      startOtpResendTimer();
    }
    function hideOtpPanel() {
      var panel = document.getElementById('plrt-otp-panel');
      if (panel) panel.style.display = 'none';
      if (verifyState.resendTimer) {
        clearInterval(verifyState.resendTimer);
        verifyState.resendTimer = null;
      }
    }

    function setOtpError(message) {
      var err = document.getElementById('plrt-otp-error');
      if (!err) return;
      if (message) {
        err.textContent = message;
        err.style.display = 'block';
      } else {
        err.style.display = 'none';
      }
    }

    // postVerifyStart / postVerifyCheck / postVerifySkipCheck moved to module
    // scope (shared with the anon Send-to-Builder messenger flow). They are
    // pure fetches and resolve here via the scope chain.

    function startOtpFlow(phoneRaw) {
      verifyState.phone = phoneRaw;
      setOtpError('');
      postVerifyStart(phoneRaw).then(function(r) {
        if (r.body && r.body.ok) {
          showOtpPanel(phoneRaw);
        } else if (r.body && r.body.reason === 'NOT_CONFIGURED') {
          verifyState.bypassed = true;
          if (buildForm && typeof buildForm.requestSubmit === 'function') {
            buildForm.requestSubmit();
          } else if (buildForm) {
            buildForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
          }
        } else {
          var reason = r.body && r.body.reason;
          var msg = reason === 'INVALID_PHONE' ? 'Please enter a valid US mobile number.' :
                    "We couldn't send the code right now. Try again in a moment.";
          setOtpError(msg);
          showOtpPanel(phoneRaw);
        }
      }).catch(function() {
        setOtpError("We couldn't send the code right now. Try again in a moment.");
        showOtpPanel(phoneRaw);
      });
    }

    function submitOtpCode() {
      if (verifyState.sending) return;
      var input = document.getElementById('plrt-otp-code');
      var btn = document.getElementById('plrt-otp-submit-btn');
      if (!input || !btn) return;
      var code = input.value.replace(/\D/g, '').slice(0, 6);
      if (code.length !== 6) {
        setOtpError('Enter the 6-digit code we sent you.');
        try { input.focus(); } catch (e) {}
        return;
      }
      setOtpError('');
      verifyState.sending = true;
      btn.disabled = true;
      var origLabel = btn.textContent;
      btn.textContent = 'Verifying…';
      postVerifyCheck(verifyState.phone, code).then(function(r) {
        verifyState.sending = false;
        btn.disabled = false;
        btn.textContent = origLabel;
        if (r.body && r.body.ok && r.body.verified && r.body.ephemeralToken) {
          verifyState.token = r.body.ephemeralToken;
          hideOtpPanel();
          if (buildForm && typeof buildForm.requestSubmit === 'function') {
            buildForm.requestSubmit();
          } else if (buildForm) {
            buildForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
          }
        } else {
          var reason = r.body && r.body.reason;
          var msg = reason === 'INVALID_CODE' ? "That code doesn't match. Try again." :
                    reason === 'EXPIRED' ? 'Your code expired — send a new one.' :
                    reason === 'TOO_MANY_ATTEMPTS' ? 'Too many tries. Send a new code.' :
                    "We couldn't verify that code. Try again.";
          setOtpError(msg);
        }
      }).catch(function() {
        verifyState.sending = false;
        btn.disabled = false;
        btn.textContent = origLabel;
        setOtpError("Couldn't reach the server. Try again.");
      });
    }

    function resendOtpCode() {
      if (verifyState.resendSecondsLeft > 0) return;
      if (!verifyState.phone) return;
      setOtpError('');
      postVerifyStart(verifyState.phone).then(function(r) {
        if (r.body && r.body.ok) {
          startOtpResendTimer();
        } else {
          setOtpError("Couldn't resend right now. Try again.");
        }
      }).catch(function() {
        setOtpError("Couldn't resend right now. Try again.");
      });
    }

    function wrongNumberOtp() {
      hideOtpPanel();
      verifyState.token = null;
      verifyState.phone = null;
      var phoneField = buildForm.querySelector('[name="contact[phone]"]');
      if (phoneField) { try { phoneField.focus(); } catch (e) {} }
    }

    (function bindOtpHandlers() {
      var input = document.getElementById('plrt-otp-code');
      var btn = document.getElementById('plrt-otp-submit-btn');
      var wrongBtn = document.getElementById('plrt-otp-wrong-btn');
      var resendEl = document.getElementById('plrt-otp-resend');
      if (input && !input.dataset.bound) {
        input.dataset.bound = '1';
        input.addEventListener('input', function() {
          var digits = input.value.replace(/\D/g, '').slice(0, 6);
          input.value = digits;
          if (btn) btn.disabled = digits.length !== 6;
          if (digits.length === 6) submitOtpCode();
        });
        input.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') { e.preventDefault(); submitOtpCode(); }
        });
      }
      if (btn && !btn.dataset.bound) {
        btn.dataset.bound = '1';
        btn.addEventListener('click', function(e) { e.preventDefault(); submitOtpCode(); });
      }
      if (wrongBtn && !wrongBtn.dataset.bound) {
        wrongBtn.dataset.bound = '1';
        wrongBtn.addEventListener('click', function(e) { e.preventDefault(); wrongNumberOtp(); });
      }
      if (resendEl && !resendEl.dataset.bound) {
        resendEl.dataset.bound = '1';
        resendEl.addEventListener('click', function() {
          if (resendEl.classList.contains('is-ready')) resendOtpCode();
        });
      }
    })();

    (function bindDecisionHandlers() {
      var updateBtn = document.getElementById('plrt-est-decision-update');
      var newBtn = document.getElementById('plrt-est-decision-new');
      if (updateBtn && !updateBtn.dataset.bound) {
        updateBtn.dataset.bound = '1';
        updateBtn.addEventListener('click', function(e) {
          e.preventDefault();
          if (pendingLeadResubmit) pendingLeadResubmit('update');
        });
      }
      if (newBtn && !newBtn.dataset.bound) {
        newBtn.dataset.bound = '1';
        newBtn.addEventListener('click', function(e) {
          e.preventDefault();
          if (pendingLeadResubmit) pendingLeadResubmit('new');
        });
      }
    })();

    if (buildForm) {
      buildForm.addEventListener('submit', function(e) {
        e.preventDefault();

        var modeCopy = PANEL_COPY[currentPanelMode] || PANEL_COPY.builder;
        var errEl = document.getElementById('plrt-build-phase5-error');
        var nameField = document.getElementById('plrt-build-name');
        var emailField = buildForm.querySelector('[name="contact[email]"]');
        var phoneField = buildForm.querySelector('[name="contact[phone]"]');

        if (modeCopy.requiresName && (!nameField || !nameField.value.trim())) {
          if (errEl) { errEl.textContent = 'Please enter your name.'; errEl.style.display = 'block'; }
          if (nameField) nameField.focus();
          return;
        }

        function isValidEmail(v) { return v.indexOf('@') !== -1 && v.indexOf('.') !== -1; }
        function isValidPhone(v) {
          var digits = (v || '').replace(/\D/g, '');
          if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
          return digits.length === 10;
        }
        var emailVal = emailField ? emailField.value.trim() : '';
        var phoneVal = phoneField ? phoneField.value.trim() : '';

        if (modeCopy.requiresEmail) {
          if (!emailVal || !isValidEmail(emailVal)) {
            if (errEl) { errEl.textContent = 'Please enter a valid email address.'; errEl.style.display = 'block'; }
            if (emailField) emailField.focus();
            return;
          }
        } else if (emailVal && !isValidEmail(emailVal)) {
          if (errEl) { errEl.textContent = 'Email doesn\'t look right — leave blank or fix it to continue.'; errEl.style.display = 'block'; }
          if (emailField) emailField.focus();
          return;
        }

        if (modeCopy.requiresPhone) {
          if (!phoneVal || !isValidPhone(phoneVal)) {
            if (errEl) { errEl.textContent = 'Please enter a valid US mobile number so your builder can text you.'; errEl.style.display = 'block'; }
            if (phoneField) phoneField.focus();
            return;
          }
        } else if (phoneVal && !isValidPhone(phoneVal)) {
          if (errEl) { errEl.textContent = 'Phone number doesn\'t look right — leave blank or fix it to continue.'; errEl.style.display = 'block'; }
          if (phoneField) phoneField.focus();
          return;
        }

        if (errEl) errEl.style.display = 'none';

        if (
          currentPanelMode === 'builder' &&
          phoneVal &&
          isValidPhone(phoneVal) &&
          !verifyState.token &&
          !verifyState.bypassed
        ) {
          // Always ask the server whether this phone can skip OTP. It grants the
          // skip on EITHER a matching typed email OR the logged-in Shopify
          // customer's own verified phone (phone-first — no typed email needed).
          // On any "no" (incl. no email + not logged in), fall through to OTP.
          postVerifySkipCheck(phoneVal, emailVal || '').then(function(r) {
            if (r.body && r.body.alreadyVerified && r.body.ephemeralToken) {
              verifyState.phone = phoneVal;
              verifyState.token = r.body.ephemeralToken;
              if (buildForm && typeof buildForm.requestSubmit === 'function') {
                buildForm.requestSubmit();
              } else if (buildForm) {
                buildForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
              }
            } else {
              startOtpFlow(phoneVal);
            }
          }).catch(function() {
            startOtpFlow(phoneVal);
          });
          return;
        }

        populateBuildHiddenFields();

        var submitBtn = document.getElementById('plrt-build-submit-btn');
        var originalSubmitLabel = null;
        if (submitBtn && !submitBtn.disabled) {
          originalSubmitLabel = submitBtn.textContent;
          submitBtn.textContent = 'Sending…';
          submitBtn.disabled = true;
        }

        (function() {
          var r = state.estimateResult || { low: 0, high: 0 };
          var midpoint = Math.round(((r.low + r.high) / 2) * 100) / 100;
          var specs = getRodSpecParams();
          specs.value = midpoint;
          specs.currency = 'USD';
          specs.mode = currentPanelMode;
          pushEvent('estimator_handoff_submit', specs);

          var nameEl = document.getElementById('plrt-build-name');
          var emailEl = buildForm.querySelector('[name="contact[email]"]');
          var phoneEl = buildForm.querySelector('[name="contact[phone]"]');
          var fullName = nameEl ? nameEl.value.trim() : '';
          var nameParts = fullName.split(/\s+/);
          var userData = {
            email: emailEl ? emailEl.value.trim() : '',
            phone: phoneEl ? phoneEl.value.trim() : '',
            first_name: nameParts[0] || '',
            last_name: nameParts.length > 1 ? nameParts[nameParts.length - 1] : ''
          };

          pushConversion(modeCopy.conversionEvent, specs, midpoint, userData);
        })();

        var successHeadlineEl = document.getElementById('plrt-build-success-headline');
        var successBodyEl = document.getElementById('plrt-build-success-body');
        if (successHeadlineEl) {
          successHeadlineEl.textContent =
            isMemorial && currentPanelMode === 'builder'
              ? 'Memorial estimate sent to your builder.'
              : modeCopy.successHeadline;
        }
        if (successBodyEl) {
          successBodyEl.textContent =
            isMemorial && currentPanelMode === 'builder'
              ? 'Your builder will reach out to discuss the story, finalize the design, and send you an itemized quote for approval. Thank you for trusting us with this build.'
              : modeCopy.successBody;
        }

        // Order Builder continuity seed (1B): prefill the "start another for
        // this order" CTA with the just-entered email so a second build
        // clusters to the same order. Falls back to the bare funnel if no
        // email (e.g. phone-only lead). Set before the panel shows.
        var startAnotherEl = document.getElementById('plrt-est-start-another');
        if (startAnotherEl) {
          var seedEmailField = buildForm.querySelector('[name="contact[email]"]');
          var seedEmail = seedEmailField && seedEmailField.value ? seedEmailField.value.trim() : '';
          startAnotherEl.href =
            '/apps/proxy/design/curated' + (seedEmail ? '?email=' + encodeURIComponent(seedEmail) : '');
        }

        if (currentPanelMode === 'save') {
          showModalPanel('plrt-est-success-panel');
        }

        var emailVal = buildForm.querySelector('[name="contact[email]"]');
        var nameVal = document.getElementById('plrt-build-name');
        var phoneVal = buildForm.querySelector('[name="contact[phone]"]');
        createShopifyCustomer(
          nameVal ? nameVal.value.trim() : '',
          emailVal ? emailVal.value.trim() : '',
          phoneVal ? phoneVal.value.trim() : ''
        );

        fetch(buildForm.action || '/contact', {
          method: 'POST',
          body: new FormData(buildForm),
          redirect: 'manual'
        }).catch(function() { /* silent */ });

        try {
          var v = state.values || {};
          var r = state.estimateResult || { low: 0, high: 0 };
          var leadData = {
            source: 'estimator',
            customer: {
              name: nameVal ? nameVal.value.trim() : '',
              email: emailVal ? emailVal.value.trim() : '',
              phone: phoneVal ? phoneVal.value.trim() : ''
            },
            specs: {
              species: v.target_species || '',
              technique: v.technique || '',
              rodLength: v.rod_length || '',
              power: v.power || '',
              action: v.action_feel || '',
              format: v.rod_format || '',
              grip: v.grip_material || '',
              guideMaterial: v.guide_material || '',
              guideTier: v.guide_material || '',
              reelSeat: v.reel_seat_type || '',
              level: v.customization_level || '',
              wrapLevel: numericWrapLevel(v.wrap_level),
              waterLocation: v.water_location || '',
              priorities: v.priorities || '',
              notes: v.build_notes || '',
              budgetRange: r.low && r.high ? ('$' + r.low + '-$' + r.high) : '',
              flyRodClass: v.fly_rod_class || '',
              lineWeight: v.line_weight || '',
              gripShape: v.grip_shape || '',
              fightingButt: v.fighting_butt || ''
            },
            metadata: { commitmentLevel: modeCopy.commitmentLevel, isFly: !!isFlyV2, flyRodClass: v.fly_rod_class || null, intents: state.intents || {}, rodLengthCustom: v._rod_length_custom || null }
          };
          var attribution = (window.PLAttribution && window.PLAttribution.collect) ? window.PLAttribution.collect() : {};
          if (Object.keys(attribution).length > 0) leadData.attribution = attribution;

          if (leadData.customer.email) leadData.emailNotificationConsent = true;
          if (leadData.customer.phone) leadData.smsNotificationConsent = true;
          var prefsEl = buildForm.querySelector('[data-notify-pref="container"]');
          if (prefsEl) {
            var versionEl = buildForm.querySelector('[data-notify-pref="version"]');
            var sourceEl = buildForm.querySelector('[data-notify-pref="source"]');
            if (versionEl) leadData.notificationConsentVersion = versionEl.value;
            if (sourceEl) leadData.notificationConsentSource = sourceEl.value;
            var marketingEl = buildForm.querySelector('[data-notify-pref="marketing-sms"]');
            if (marketingEl) {
              leadData.smsMarketingConsent = !!marketingEl.checked;
              if (marketingEl.checked) {
                if (versionEl) leadData.smsMarketingConsentVersion = versionEl.value;
                if (sourceEl) leadData.smsMarketingConsentSource = sourceEl.value;
              }
            }
          }

          if (verifyState.token) {
            leadData.verifyToken = verifyState.token;
          }

          if (leadData.customer.email || leadData.customer.phone) {
            // Multi-build: submit the lead. The server may answer
            // decisionRequired (this rod differs from a recent build) — then we
            // ask the customer to update-vs-start-another and resubmit with
            // their decisionIntent. Defined as a function so the prompt buttons
            // can replay it with the chosen intent.
            var doLeadSubmit = function(decisionIntent) {
              var payload = decisionIntent
                ? Object.assign({}, leadData, { decisionIntent: decisionIntent })
                : leadData;
              fetch('/apps/proxy/api/leads/submit', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(payload)
              })
                .then(function(res) { return res.ok ? res.json() : null; })
                .then(function(j) {
                  if (j && j.decisionRequired) {
                    pendingLeadResubmit = doLeadSubmit;
                    showDecisionPrompt(!!j.existingLocked);
                    if (submitBtn && originalSubmitLabel) {
                      submitBtn.textContent = originalSubmitLabel;
                      submitBtn.disabled = false;
                    }
                    return;
                  }
                  if (currentPanelMode === 'builder') {
                    if (j && j.conversationToken) {
                      openMessenger(j.conversationToken, leadData.customer.email, leadData.customer.phone);
                    } else {
                      showModalPanel('plrt-est-success-panel');
                    }
                    if (submitBtn && originalSubmitLabel) {
                      submitBtn.textContent = originalSubmitLabel;
                      submitBtn.disabled = false;
                    }
                  } else if (j && j.conversationToken) {
                    var threadLink = document.getElementById('plrt-est-success-thread-link');
                    var doneBtn = document.getElementById('plrt-est-done-btn');
                    if (threadLink) {
                      threadLink.href = '/apps/proxy/chat/' + encodeURIComponent(j.conversationToken);
                      threadLink.style.display = 'inline-flex';
                    }
                    if (doneBtn) doneBtn.style.display = 'none';
                  }
                })
                .catch(function() {
                  if (currentPanelMode === 'builder') {
                    showModalPanel('plrt-est-success-panel');
                    if (submitBtn && originalSubmitLabel) {
                      submitBtn.textContent = originalSubmitLabel;
                      submitBtn.disabled = false;
                    }
                  }
                });
            };
            doLeadSubmit();
          }
        } catch(ex) {}
      });
    }
  }


  var messengerState = {
    accessToken: null,
    lastMessageAt: 0,
    pollTimer: null,
    sending: false,
    composer: 'ready',
    smsPrompt: 'hidden',
    smsSending: false,
    marketingPrompt: 'hidden',
    marketingSending: false,
    marketingPromptVersion: null
  };

  function setMessengerComposerState(state) {
    messengerState.composer = state;
    // Anon Send-to-Builder collects across three steps before the chat opens:
    // needs-email (phone) → needs-otp (SMS code) → needs-name (skippable) →
    // ready (normal chat). Logged-in/handoff paths jump straight to 'ready'.
    var emailEl = document.getElementById('plrt-messenger-composer-email');
    var otpEl = document.getElementById('plrt-messenger-otp-composer');
    var nameEl = document.getElementById('plrt-messenger-name-composer');
    var chatEl = document.getElementById('plrt-messenger-composer-chat');
    var collecting = state === 'needs-email' || state === 'needs-otp' || state === 'needs-name';
    if (emailEl) emailEl.style.display = state === 'needs-email' ? 'flex' : 'none';
    if (otpEl) otpEl.style.display = state === 'needs-otp' ? 'flex' : 'none';
    if (nameEl) nameEl.style.display = state === 'needs-name' ? 'flex' : 'none';
    if (chatEl) chatEl.style.display = collecting ? 'none' : 'flex';
  }

  function escMessengerHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMessageTime(iso) {
    if (!iso) return '';
    try {
      var d = new Date(iso);
      return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    } catch (e) { return ''; }
  }

  function renderMessengerThread(messages) {
    var thread = document.getElementById('plrt-messenger-thread');
    if (!thread) return;
    if (!messages || messages.length === 0) {
      thread.innerHTML =
        '<div class="plrt-messenger-row plrt-messenger-row--system">' +
        '<div class="plrt-messenger-bubble">No messages yet.</div></div>';
      return;
    }
    var html = '';
    for (var i = 0; i < messages.length; i++) {
      var m = messages[i];
      var rowClass = 'plrt-messenger-row--' + (m.from === 'you' ? 'you' : m.from === 'system' ? 'system' : 'team');
      var bubble = '<div class="plrt-messenger-bubble">' + escMessengerHtml(m.content || '') + '</div>';
      var meta = m.from === 'system'
        ? ''
        : '<div class="plrt-messenger-meta">' +
            (m.from === 'you' ? 'You' : escMessengerHtml(m.name || 'Prolite')) +
            (m.at ? ' · ' + escMessengerHtml(formatMessageTime(m.at)) : '') +
            '</div>';
      html += '<div class="plrt-messenger-row ' + rowClass + '">' + bubble + meta + '</div>';
    }
    thread.innerHTML = html;
    maybeAppendSmsPrompt();
    maybeAppendMarketingPrompt();
    thread.scrollTop = thread.scrollHeight;
    var last = messages[messages.length - 1];
    if (last && last.at) {
      var ts = Date.parse(last.at);
      if (!isNaN(ts) && ts > messengerState.lastMessageAt) messengerState.lastMessageAt = ts;
    }
  }

  function maybeAppendSmsPrompt() {
    if (messengerState.smsPrompt !== 'pending') return;
    var thread = document.getElementById('plrt-messenger-thread');
    if (!thread) return;
    if (document.getElementById('plrt-messenger-sms-prompt')) return; // already attached
    var html =
      '<div class="plrt-messenger-row plrt-messenger-row--system" id="plrt-messenger-sms-prompt">' +
        '<div class="plrt-messenger-bubble plrt-messenger-prompt">' +
          '<div class="plrt-messenger-prompt-text">Want a text when there\'s a reply? Prolite Rods will text you about this build conversation only — up to ~5 msgs/month. Msg &amp; data rates may apply. Reply STOP to opt out, HELP for help. Privacy: proliterods.com/policies/privacy-policy</div>' +
          '<div class="plrt-messenger-prompt-row">' +
            '<input type="tel" id="plrt-messenger-sms-phone" class="plrt-messenger-prompt-input" placeholder="(555) 555-1234" autocomplete="tel" inputmode="tel" maxlength="40" />' +
            '<button type="button" id="plrt-messenger-sms-yes" class="plrt-messenger-prompt-yes">Yes, text me</button>' +
          '</div>' +
          '<button type="button" id="plrt-messenger-sms-skip" class="plrt-messenger-prompt-skip">Email is fine</button>' +
        '</div>' +
      '</div>';
    thread.insertAdjacentHTML('beforeend', html);
    var phoneInput = document.getElementById('plrt-messenger-sms-phone');
    var yesBtn = document.getElementById('plrt-messenger-sms-yes');
    var skipBtn = document.getElementById('plrt-messenger-sms-skip');
    if (yesBtn) yesBtn.addEventListener('click', submitSmsOptIn);
    if (skipBtn) skipBtn.addEventListener('click', dismissSmsPrompt);
    if (phoneInput) {
      phoneInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          submitSmsOptIn();
        }
      });
    }
  }

  function dismissSmsPrompt() {
    messengerState.smsPrompt = 'skipped';
    var p = document.getElementById('plrt-messenger-sms-prompt');
    if (p && p.parentNode) p.parentNode.removeChild(p);
  }

  function submitSmsOptIn() {
    if (messengerState.smsSending || !messengerState.accessToken) return;
    var phoneInput = document.getElementById('plrt-messenger-sms-phone');
    var yesBtn = document.getElementById('plrt-messenger-sms-yes');
    if (!phoneInput || !yesBtn) return;
    var phone = phoneInput.value.trim();
    var digits = phone.replace(/\D/g, '');
    if (digits.length < 10) {
      phoneInput.focus();
      try { phoneInput.setCustomValidity('Please enter a valid phone number.'); phoneInput.reportValidity(); } catch (e) {}
      setTimeout(function() {
        try { phoneInput.setCustomValidity(''); } catch (e) {}
      }, 100);
      return;
    }
    messengerState.smsSending = true;
    yesBtn.disabled = true;
    var origLabel = yesBtn.textContent;
    yesBtn.textContent = 'Saving…';
    fetch('/apps/proxy/api/messaging/public', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        action: 'preferences',
        accessToken: messengerState.accessToken,
        phone: phone,
        smsConsent: true,
        consentVersion: 'v5-2026-06-sms-first-inthread',
        consentSource: window.location.pathname
      })
    })
      .then(function(res) { return res.ok ? res.json() : res.json().then(function(j) { throw j; }); })
      .then(function() {
        messengerState.smsSending = false;
        messengerState.smsPrompt = 'consented';
        var p = document.getElementById('plrt-messenger-sms-prompt');
        if (p && p.parentNode) p.parentNode.removeChild(p);
        var thread = document.getElementById('plrt-messenger-thread');
        if (thread) {
          var confirmHtml =
            '<div class="plrt-messenger-row plrt-messenger-row--system">' +
              '<div class="plrt-messenger-bubble">Got it — we\'ll text you at ' + escMessengerHtml(phone) + ' when there\'s an update.</div>' +
            '</div>';
          thread.insertAdjacentHTML('beforeend', confirmHtml);
          thread.scrollTop = thread.scrollHeight;
        }
        var replyPath = document.getElementById('plrt-messenger-replypath');
        if (replyPath) {
          replyPath.textContent = "We'll email and text you when your builder replies.";
        }
        pushEvent('estimator_sms_opt_in', {});
      })
      .catch(function(err) {
        messengerState.smsSending = false;
        yesBtn.disabled = false;
        yesBtn.textContent = origLabel;
        var msg = (err && err.fields && err.fields.phone) ||
                  (err && err.error === 'INVALID_PHONE' ? 'Please enter a valid phone number.' : null) ||
                  "Couldn't save. Try again.";
        try { phoneInput.setCustomValidity(msg); phoneInput.reportValidity(); } catch (e) {}
        setTimeout(function() {
          try { phoneInput.setCustomValidity(''); } catch (e) {}
        }, 100);
      });
  }

  function showMessengerError(text) {
    var el = document.getElementById('plrt-messenger-error');
    if (el) el.textContent = text || '';
  }

  function showMessengerSuccess(text) {
    var el = document.getElementById('plrt-messenger-error');
    if (!el) return;
    el.textContent = text || '';
    el.style.color = '#15803d';
    el.style.fontWeight = '600';
    setTimeout(function() {
      if (el.textContent === text) {
        el.textContent = '';
        el.style.color = '';
        el.style.fontWeight = '';
      }
    }, 4000);
  }

  function loadMessengerThread() {
    if (!messengerState.accessToken) return Promise.resolve();
    return fetch('/apps/proxy/api/messaging/public', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ action: 'load', accessToken: messengerState.accessToken })
    })
      .then(function(res) { return res.ok ? res.json() : null; })
      .then(function(j) {
        if (j && j.ok && Array.isArray(j.messages)) {
          renderMessengerThread(j.messages);
        }
        if (j && j.marketingPrompt && j.marketingPrompt.shouldAsk) {
          var dismissedKey = 'pl_mktg_dismissed_' + (messengerState.accessToken || 'na');
          var alreadyDismissed = false;
          try { alreadyDismissed = sessionStorage.getItem(dismissedKey) === '1'; } catch (e) {}
          if (!alreadyDismissed && messengerState.marketingPrompt !== 'consented' && messengerState.marketingPrompt !== 'declined') {
            messengerState.marketingPrompt = 'pending';
            messengerState.marketingPromptVersion = j.marketingPrompt.version || null;
            maybeAppendMarketingPrompt();
          }
        }
      })
      .catch(function() { /* silent; rely on initial messages */ });
  }

  function maybeAppendMarketingPrompt() {
    if (messengerState.marketingPrompt !== 'pending') return;
    var thread = document.getElementById('plrt-messenger-thread');
    if (!thread) return;
    if (document.getElementById('plrt-messenger-mktg-prompt')) return; // already attached
    var html =
      '<div class="plrt-messenger-row plrt-messenger-row--system" id="plrt-messenger-mktg-prompt">' +
        '<div class="plrt-messenger-bubble plrt-messenger-prompt">' +
          '<div class="plrt-messenger-prompt-text">Want updates on rod drops, events, and Prolite news? Optional — up to ~4 msgs/month. Msg &amp; data rates may apply. Reply STOP anytime. <a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy</a></div>' +
          '<div class="plrt-messenger-prompt-row" style="justify-content:flex-end;">' +
            '<button type="button" id="plrt-messenger-mktg-no" class="plrt-messenger-prompt-skip">No thanks</button>' +
            '<button type="button" id="plrt-messenger-mktg-yes" class="plrt-messenger-prompt-yes">Yes, sign me up</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    thread.insertAdjacentHTML('beforeend', html);
    thread.scrollTop = thread.scrollHeight;
    var yesBtn = document.getElementById('plrt-messenger-mktg-yes');
    var noBtn = document.getElementById('plrt-messenger-mktg-no');
    if (yesBtn) yesBtn.addEventListener('click', function() { submitMarketingOptIn(true); });
    if (noBtn) noBtn.addEventListener('click', function() { submitMarketingOptIn(false); });
  }

  function submitMarketingOptIn(optIn) {
    if (messengerState.marketingSending || !messengerState.accessToken) return;
    messengerState.marketingSending = true;
    var yesBtn = document.getElementById('plrt-messenger-mktg-yes');
    var noBtn = document.getElementById('plrt-messenger-mktg-no');
    if (yesBtn) yesBtn.disabled = true;
    if (noBtn) noBtn.disabled = true;
    var origYes = yesBtn ? yesBtn.textContent : '';
    if (yesBtn && optIn) yesBtn.textContent = 'Saving…';
    fetch('/apps/proxy/api/messaging/public', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        action: 'marketing-consent',
        accessToken: messengerState.accessToken,
        optIn: !!optIn,
        consentVersion: messengerState.marketingPromptVersion || 'v1c-2026-05',
        consentSource: window.location.pathname + ' (messenger)'
      })
    })
      .then(function(res) { return res.ok ? res.json() : res.json().then(function(j) { throw j; }); })
      .then(function() {
        messengerState.marketingSending = false;
        messengerState.marketingPrompt = optIn ? 'consented' : 'declined';
        try { sessionStorage.setItem('pl_mktg_dismissed_' + messengerState.accessToken, '1'); } catch (e) {}
        var card = document.getElementById('plrt-messenger-mktg-prompt');
        if (card && card.parentNode) card.parentNode.removeChild(card);
        if (optIn) {
          var thread = document.getElementById('plrt-messenger-thread');
          if (thread) {
            thread.insertAdjacentHTML('beforeend',
              '<div class="plrt-messenger-row plrt-messenger-row--system">' +
                '<div class="plrt-messenger-bubble">You\'re in — we\'ll text you about rod drops, events, and Prolite news. Reply STOP anytime.</div>' +
              '</div>'
            );
            thread.scrollTop = thread.scrollHeight;
          }
        }
        pushEvent(optIn ? 'estimator_marketing_opt_in' : 'estimator_marketing_decline', {});
      })
      .catch(function() {
        messengerState.marketingSending = false;
        if (yesBtn) { yesBtn.disabled = false; yesBtn.textContent = origYes; }
        if (noBtn) noBtn.disabled = false;
        showMessengerError("Couldn't save. Try again.");
      });
  }

  function pollMessengerThread() {
    if (!messengerState.accessToken || messengerState.lastMessageAt === 0) return;
    fetch('/apps/proxy/api/messaging/public', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        action: 'poll',
        accessToken: messengerState.accessToken,
        since: new Date(messengerState.lastMessageAt).toISOString()
      })
    })
      .then(function(res) { return res.ok ? res.json() : null; })
      .then(function(j) {
        if (j && j.ok && Array.isArray(j.messages) && j.messages.length > 0) {
          loadMessengerThread();
        }
      })
      .catch(function() {});
  }

  function sendMessengerFollowup() {
    var input = document.getElementById('plrt-messenger-input');
    var btn = document.getElementById('plrt-messenger-send-btn');
    if (!input || !btn || messengerState.sending || !messengerState.accessToken) return;
    var text = input.value.trim();
    if (!text) return;
    messengerState.sending = true;
    btn.disabled = true;
    var origLabel = btn.textContent;
    btn.textContent = 'Sending…';
    showMessengerError('');
    fetch('/apps/proxy/api/messaging/public', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        action: 'send',
        accessToken: messengerState.accessToken,
        message: text
      })
    })
      .then(function(res) { return res.ok ? res.json() : null; })
      .then(function(j) {
        messengerState.sending = false;
        btn.textContent = origLabel;
        if (j && j.ok) {
          input.value = '';
          btn.disabled = true;
          loadMessengerThread();
        } else {
          btn.disabled = false;
          showMessengerError("Couldn't send. Try again.");
        }
      })
      .catch(function() {
        messengerState.sending = false;
        btn.textContent = origLabel;
        btn.disabled = false;
        showMessengerError("Couldn't send. Try again.");
      });
  }

  function closeMessenger() {
    if (messengerState.pollTimer) {
      clearInterval(messengerState.pollTimer);
      messengerState.pollTimer = null;
    }
    messengerState.accessToken = null;
    messengerState.lastMessageAt = 0;
    var thread = document.getElementById('plrt-messenger-thread');
    if (thread) thread.innerHTML = '';
    var input = document.getElementById('plrt-messenger-input');
    if (input) input.value = '';
    var emailInput = document.getElementById('plrt-messenger-email-input');
    if (emailInput) emailInput.value = '';
    var emailBtn = document.getElementById('plrt-messenger-email-send-btn');
    if (emailBtn) { emailBtn.disabled = true; emailBtn.textContent = 'Send'; }
    setMessengerComposerState('ready');
    messengerState.smsPrompt = 'hidden';
    messengerState.smsSending = false;
    showMessengerError('');
    showModalPanel('plrt-est-results-panel');
  }

  function openMessenger(accessToken, customerEmail, customerPhone) {
    messengerState.accessToken = accessToken;
    messengerState.lastMessageAt = 0;
    var replyPath = document.getElementById('plrt-messenger-replypath');
    if (replyPath) {
      var parts = [];
      if (customerEmail) parts.push("We'll email you at " + customerEmail);
      if (customerPhone) parts.push('and text you when there\'s an update');
      replyPath.textContent = parts.length > 0 ? parts.join(' ') + '.' : "We'll email you when your builder replies.";
    }
    setMessengerComposerState('ready');
    messengerState.smsPrompt = customerPhone ? 'hidden' : 'pending';
    showModalPanel('plrt-est-messenger-panel');
    pushEvent('estimator_messenger_opened', { source: 'logged_in' });
    loadMessengerThread();
    if (messengerState.pollTimer) clearInterval(messengerState.pollTimer);
    messengerState.pollTimer = setInterval(pollMessengerThread, 30000);
    setTimeout(function() {
      var input = document.getElementById('plrt-messenger-input');
      if (input) try { input.focus(); } catch (e) {}
    }, 50);
  }

  // ── Phone-verification network helpers (module scope) ──────────────
  // Shared by the handoff form (initBuildForm) and the anon Send-to-Builder
  // messenger flow. Pure fetches against the public messaging proxy.
  function postVerifyStart(phoneRaw) {
    return fetch('/apps/proxy/api/messaging/public', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ action: 'verify-phone-start', phone: phoneRaw })
    }).then(function(res) { return res.json().then(function(j) { return { status: res.status, body: j }; }); });
  }
  function postVerifyCheck(phoneRaw, code) {
    return fetch('/apps/proxy/api/messaging/public', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ action: 'verify-phone-check', phone: phoneRaw, code: code })
    }).then(function(res) { return res.json().then(function(j) { return { status: res.status, body: j }; }); });
  }
  function postVerifySkipCheck(phoneRaw, emailRaw) {
    return fetch('/apps/proxy/api/messaging/public', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ action: 'verify-phone-skip-check', phone: phoneRaw, email: emailRaw })
    }).then(function(res) { return res.json().then(function(j) { return { status: res.status, body: j }; }); });
  }

  function openMessengerForAnonBuilder() {
    messengerState.accessToken = null;
    messengerState.lastMessageAt = 0;
    messengerState.verifyToken = null;
    messengerState.pendingPhone = '';
    messengerState.name = '';
    var replyPath = document.getElementById('plrt-messenger-replypath');
    if (replyPath) replyPath.textContent = "Build conversation only — not marketing.";
    var thread = document.getElementById('plrt-messenger-thread');
    if (thread) {
      thread.innerHTML =
        '<div class="plrt-messenger-row plrt-messenger-row--system">' +
        '<div class="plrt-messenger-bubble">Your estimate is ready. First — what should we call you? Then we\'ll grab a mobile number so a Prolite builder can text you to continue. Quick and simple, no old-school email thread.</div>' +
        '</div>';
    }
    var nameInput = document.getElementById('plrt-messenger-name-input');
    var nameContinueBtn = document.getElementById('plrt-messenger-name-continue-btn');
    if (nameInput) nameInput.value = '';
    if (nameContinueBtn) nameContinueBtn.disabled = true;
    setMessengerComposerState('needs-name');
    showMessengerError('');
    setMessengerNameError('');
    showModalPanel('plrt-est-messenger-panel');
    pushEvent('estimator_messenger_opened', { source: 'anon' });
    setTimeout(function() {
      if (nameInput) try { nameInput.focus(); } catch (e) {}
    }, 50);
  }

  function isValidMessengerPhone(v) {
    var digits = (v || '').replace(/\D/g, '');
    if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
    return digits.length === 10;
  }

  function setMessengerOtpError(message) {
    var err = document.getElementById('plrt-messenger-otp-error');
    if (!err) return;
    if (message) { err.textContent = message; err.style.display = 'block'; }
    else { err.style.display = 'none'; }
  }
  function setMessengerNameError(message) {
    var err = document.getElementById('plrt-messenger-name-error');
    if (!err) return;
    if (message) { err.textContent = message; err.style.display = 'block'; }
    else { err.style.display = 'none'; }
  }

  function setMessengerOtpResendCountdown(seconds) {
    messengerState.resendSecondsLeft = seconds;
    var resendEl = document.getElementById('plrt-messenger-otp-resend');
    if (!resendEl) return;
    if (seconds > 0) {
      resendEl.classList.remove('is-ready');
      resendEl.textContent = 'Resend in ' + seconds + 's';
    } else {
      resendEl.classList.add('is-ready');
      resendEl.textContent = 'Resend code';
    }
  }
  function startMessengerOtpResendTimer() {
    if (messengerState.resendTimer) clearInterval(messengerState.resendTimer);
    setMessengerOtpResendCountdown(30);
    messengerState.resendTimer = setInterval(function() {
      if (messengerState.resendSecondsLeft <= 1) {
        setMessengerOtpResendCountdown(0);
        if (messengerState.resendTimer) clearInterval(messengerState.resendTimer);
        messengerState.resendTimer = null;
      } else {
        setMessengerOtpResendCountdown(messengerState.resendSecondsLeft - 1);
      }
    }, 1000);
  }
  function clearMessengerOtpResendTimer() {
    if (messengerState.resendTimer) {
      clearInterval(messengerState.resendTimer);
      messengerState.resendTimer = null;
    }
  }

  // Step 1 (phone): validate the mobile, then fire Twilio Verify. On success
  // advance to the OTP step; if Verify isn't configured server-side
  // (NOT_CONFIGURED), skip OTP and go straight to the name step so we still
  // capture name + number. The lead is NOT created here anymore — creation
  // happens in submitMessengerLead after the name step.
  function submitMessengerEmail() {
    if (messengerState.sending) return;
    var phoneEl = document.getElementById('plrt-messenger-email-input');
    var btn = document.getElementById('plrt-messenger-email-send-btn');
    if (!phoneEl || !btn) return;
    var phoneRaw = phoneEl.value.trim();
    if (!phoneRaw || !isValidMessengerPhone(phoneRaw)) {
      showMessengerError('Please enter a valid US mobile number so your builder can text you.');
      try { phoneEl.focus(); } catch (e) {}
      return;
    }
    showMessengerError('');
    messengerState.pendingPhone = phoneRaw;
    messengerState.sending = true;
    btn.disabled = true;
    var origLabel = btn.textContent;
    btn.textContent = 'Sending…';

    postVerifyStart(phoneRaw).then(function(r) {
      messengerState.sending = false;
      btn.disabled = false;
      btn.textContent = origLabel;
      if (r.body && r.body.ok) {
        var disp = document.getElementById('plrt-messenger-otp-phone');
        if (disp) disp.textContent = phoneRaw;
        var codeEl = document.getElementById('plrt-messenger-otp-code');
        if (codeEl) codeEl.value = '';
        var verifyBtn = document.getElementById('plrt-messenger-otp-verify-btn');
        if (verifyBtn) verifyBtn.disabled = true;
        setMessengerOtpError('');
        setMessengerComposerState('needs-otp');
        startMessengerOtpResendTimer();
        setTimeout(function() { if (codeEl) try { codeEl.focus(); } catch (e) {} }, 50);
      } else if (r.body && r.body.reason === 'NOT_CONFIGURED') {
        // Twilio Verify not wired up yet — graceful fall-through: submit the
        // lead with the already-captured name and no verifyToken (matches the
        // handoff bypass behavior).
        messengerState.verifyToken = null;
        submitMessengerLead(messengerState.name);
      } else {
        var reason = r.body && r.body.reason;
        showMessengerError(reason === 'INVALID_PHONE'
          ? 'Please enter a valid US mobile number.'
          : "We couldn't send the code right now. Try again in a moment.");
      }
    }).catch(function() {
      messengerState.sending = false;
      btn.disabled = false;
      btn.textContent = origLabel;
      showMessengerError("We couldn't send the code right now. Try again in a moment.");
    });
  }

  // Step 2 (OTP): check the 6-digit code; on success store the ephemeral
  // verify token and advance to the name step.
  function submitMessengerOtp() {
    if (messengerState.sending) return;
    var input = document.getElementById('plrt-messenger-otp-code');
    var btn = document.getElementById('plrt-messenger-otp-verify-btn');
    if (!input || !btn) return;
    var code = input.value.replace(/\D/g, '').slice(0, 6);
    if (code.length !== 6) {
      setMessengerOtpError('Enter the 6-digit code we sent you.');
      try { input.focus(); } catch (e) {}
      return;
    }
    setMessengerOtpError('');
    messengerState.sending = true;
    btn.disabled = true;
    var origLabel = btn.textContent;
    btn.textContent = 'Verifying…';
    postVerifyCheck(messengerState.pendingPhone, code).then(function(r) {
      messengerState.sending = false;
      btn.disabled = false;
      btn.textContent = origLabel;
      if (r.body && r.body.ok && r.body.verified && r.body.ephemeralToken) {
        messengerState.verifyToken = r.body.ephemeralToken;
        clearMessengerOtpResendTimer();
        submitMessengerLead(messengerState.name);
      } else {
        var reason = r.body && r.body.reason;
        setMessengerOtpError(
          reason === 'INVALID_CODE' ? "That code doesn't match. Try again." :
          reason === 'EXPIRED' ? 'Your code expired — send a new one.' :
          reason === 'TOO_MANY_ATTEMPTS' ? 'Too many tries. Send a new code.' :
          "We couldn't verify that code. Try again."
        );
      }
    }).catch(function() {
      messengerState.sending = false;
      btn.disabled = false;
      btn.textContent = origLabel;
      setMessengerOtpError("Couldn't reach the server. Try again.");
    });
  }

  function resendMessengerOtp() {
    if (messengerState.sending || !messengerState.pendingPhone) return;
    if (messengerState.resendSecondsLeft > 0) return; // not ready yet
    setMessengerOtpError('');
    postVerifyStart(messengerState.pendingPhone).then(function(r) {
      if (r.body && r.body.ok) {
        var codeEl = document.getElementById('plrt-messenger-otp-code');
        if (codeEl) { codeEl.value = ''; try { codeEl.focus(); } catch (e) {} }
        var verifyBtn = document.getElementById('plrt-messenger-otp-verify-btn');
        if (verifyBtn) verifyBtn.disabled = true;
        startMessengerOtpResendTimer();
      } else {
        setMessengerOtpError("We couldn't resend the code. Try again in a moment.");
        startMessengerOtpResendTimer();
      }
    }).catch(function() {
      setMessengerOtpError("We couldn't resend the code. Try again in a moment.");
      startMessengerOtpResendTimer();
    });
  }

  // "Wrong number?" — drop back to the phone step to re-enter the mobile.
  function messengerWrongNumber() {
    clearMessengerOtpResendTimer();
    messengerState.verifyToken = null;
    setMessengerOtpError('');
    setMessengerComposerState('needs-email');
    setTimeout(function() {
      var input = document.getElementById('plrt-messenger-email-input');
      if (input) try { input.focus(); } catch (e) {}
    }, 50);
  }

  // Step 1 (name): required, asked FIRST. Captures the name, then advances to
  // the phone step (phone → OTP → submit happens after).
  function submitMessengerName() {
    if (messengerState.sending) return;
    var nameEl = document.getElementById('plrt-messenger-name-input');
    var nameVal = nameEl ? nameEl.value.trim() : '';
    if (!nameVal) {
      setMessengerNameError('Please enter your name so we know who to reach.');
      if (nameEl) try { nameEl.focus(); } catch (e) {}
      return;
    }
    setMessengerNameError('');
    messengerState.name = nameVal;
    var thread = document.getElementById('plrt-messenger-thread');
    if (thread) {
      thread.insertAdjacentHTML('beforeend',
        '<div class="plrt-messenger-row plrt-messenger-row--system">' +
        '<div class="plrt-messenger-bubble">Thanks, ' + escMessengerHtml(nameVal) + '! What\'s the best mobile number for your builder to text you at?</div>' +
        '</div>');
    }
    setMessengerComposerState('needs-email');
    setTimeout(function() {
      var input = document.getElementById('plrt-messenger-email-input');
      if (input) try { input.focus(); } catch (e) {}
    }, 50);
  }

  // Shared lead creation for the anon Send-to-Builder flow. Builds the same
  // payload the phone-only flow used, plus customer.name (when provided) and
  // the verifyToken (when the phone was OTP-verified). Keeps
  // intakeChannel:'messenger' so name stays optional server-side, and omits
  // startBuild so the lead is NOT auto-converted to BUILD_CUSTOM.
  function submitMessengerLead(name) {
    var phoneRaw = messengerState.pendingPhone;
    if (!phoneRaw) { setMessengerComposerState('needs-email'); return; }
    messengerState.sending = true;
    var continueBtn = document.getElementById('plrt-messenger-name-continue-btn');
    var origContinue = continueBtn ? continueBtn.textContent : '';
    if (continueBtn) { continueBtn.disabled = true; continueBtn.textContent = 'Sending…'; }
    setMessengerNameError('');

    var v = state.values || {};
    var r = state.estimateResult || { low: 0, high: 0 };
    var leadData = {
      source: 'estimator',
      customer: { phone: phoneRaw },
      specs: {
        species: v.target_species || '',
        technique: v.technique || '',
        rodLength: v.rod_length || '',
        power: v.power || '',
        action: v.action_feel || '',
        format: v.rod_format || '',
        grip: v.grip_material || '',
        guideMaterial: v.guide_material || '',
        guideTier: v.guide_material || '',
        reelSeat: v.reel_seat_type || '',
        level: v.customization_level || '',
        wrapLevel: numericWrapLevel(v.wrap_level),
        waterLocation: v.water_location || '',
        priorities: v.priorities || '',
        notes: v.build_notes || '',
        budgetRange: r.low && r.high ? ('$' + r.low + '-$' + r.high) : '',
        flyRodClass: v.fly_rod_class || '',
        lineWeight: v.line_weight || '',
        gripShape: v.grip_shape || '',
        fightingButt: v.fighting_butt || ''
      },
      metadata: {
        commitmentLevel: 'guided_finalize',
        intakeChannel: 'messenger',
        isFly: !!isFlyV2,
        flyRodClass: v.fly_rod_class || null,
        intents: state.intents || {},
        rodLengthCustom: v._rod_length_custom || null
      },
      smsNotificationConsent: true,
      notificationConsentVersion: 'v5-2026-06-sms-first-messenger',
      notificationConsentSource: window.location.href
    };
    if (name) leadData.customer.name = name;
    if (messengerState.verifyToken) leadData.verifyToken = messengerState.verifyToken;
    var marketingEl = document.getElementById('plrt-messenger-marketing-checkbox');
    if (marketingEl) {
      leadData.smsMarketingConsent = !!marketingEl.checked;
      if (marketingEl.checked) {
        leadData.smsMarketingConsentVersion = 'v5-2026-06-sms-first-messenger';
        leadData.smsMarketingConsentSource = window.location.href;
      }
    }
    var attribution = (window.PLAttribution && window.PLAttribution.collect) ? window.PLAttribution.collect() : {};
    if (Object.keys(attribution).length > 0) leadData.attribution = attribution;

    fetch('/apps/proxy/api/leads/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(leadData)
    })
      .then(function(res) { return res.ok ? res.json() : res.json().then(function(j) { throw j; }); })
      .then(function(j) {
        messengerState.sending = false;
        // Any ok:true response means the lead was created. conversationToken
        // is OPTIONAL (returning customers can submit without a fresh chat
        // token) — so a successful submit must NEVER show an error. Only a
        // genuine non-ok response falls through to the error branch.
        if (j && (j.ok || j.conversationToken || j.deduplicated)) {
          messengerState.smsPrompt = 'consented';
          var replyPath = document.getElementById('plrt-messenger-replypath');
          if (replyPath) replyPath.textContent = "We'll text you at " + phoneRaw + " when your builder replies.";
          if (!j.deduplicated) {
            var specs = getRodSpecParams();
            var midpoint = Math.round((((r.low || 0) + (r.high || 0)) / 2) * 100) / 100;
            specs.value = midpoint;
            specs.currency = 'USD';
            specs.mode = 'builder';
            pushConversion('estimate_sent_to_builder', specs, midpoint, { phone: phoneRaw, first_name: name || '' });
          }
          if (j.conversationToken) {
            // Live chat available — drop the customer into the thread.
            messengerState.accessToken = j.conversationToken;
            messengerState.lastMessageAt = 0;
            setMessengerComposerState('ready');
            showMessengerSuccess('Estimate sent — a builder will reach out.');
            loadMessengerThread();
            if (messengerState.pollTimer) clearInterval(messengerState.pollTimer);
            messengerState.pollTimer = setInterval(pollMessengerThread, 30000);
            setTimeout(function() {
              var input = document.getElementById('plrt-messenger-input');
              if (input) try { input.focus(); } catch (e) {}
            }, 50);
          } else {
            // No live-chat token (e.g. returning customer) — clean confirmation
            // instead of a chat box that can't send. Hide all composers.
            ['plrt-messenger-composer-email', 'plrt-messenger-otp-composer', 'plrt-messenger-name-composer', 'plrt-messenger-composer-chat'].forEach(function(id) {
              var el = document.getElementById(id);
              if (el) el.style.display = 'none';
            });
            var leadMsg = j.deduplicated
              ? 'We already have your estimate on file. '
              : 'Estimate sent! ';
            var thread = document.getElementById('plrt-messenger-thread');
            if (thread) {
              thread.innerHTML =
                '<div class="plrt-messenger-row plrt-messenger-row--system">' +
                '<div class="plrt-messenger-bubble">' + leadMsg + 'A Prolite builder will text you at ' + escMessengerHtml(phoneRaw) + ' shortly to finalize your build.</div>' +
                '</div>';
            }
            showMessengerSuccess('Estimate sent — a builder will text you.');
          }
        } else {
          // Failure lands here after the OTP/phone step (the name composer is
          // already behind us), so show it on the panel-level error surface.
          if (continueBtn) { continueBtn.disabled = false; continueBtn.textContent = origContinue; }
          showMessengerError("Couldn't send. Try again.");
        }
      })
      .catch(function(err) {
        messengerState.sending = false;
        if (continueBtn) { continueBtn.disabled = false; continueBtn.textContent = origContinue; }
        if (err && err.error === 'VERIFY_TOKEN_INVALID') {
          // Token expired/invalid — send them back to re-verify the phone.
          messengerState.verifyToken = null;
          showMessengerError('Please verify your phone number again.');
          setMessengerComposerState('needs-email');
          return;
        }
        var msg = (err && err.fields && err.fields.phone) ||
                  (err && err.error === 'VALIDATION_FAILED' ? 'Please try again.' : null) ||
                  "Couldn't send. Try again.";
        showMessengerError(msg);
      });
  }

  function initMessenger() {
    var sendBtn = document.getElementById('plrt-messenger-send-btn');
    var closeBtn = document.getElementById('plrt-messenger-close');
    var input = document.getElementById('plrt-messenger-input');
    if (sendBtn) {
      sendBtn.addEventListener('click', function(e) {
        e.preventDefault();
        sendMessengerFollowup();
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', closeMessenger);
    if (input) {
      input.addEventListener('input', function() {
        var btn = document.getElementById('plrt-messenger-send-btn');
        if (btn) btn.disabled = !input.value.trim();
      });
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          sendMessengerFollowup();
        }
      });
    }

    var emailInput = document.getElementById('plrt-messenger-email-input');
    var emailBtn = document.getElementById('plrt-messenger-email-send-btn');
    if (emailBtn) {
      emailBtn.addEventListener('click', function(e) {
        e.preventDefault();
        submitMessengerEmail();
      });
    }
    if (emailInput) {
      emailInput.addEventListener('input', function() {
        if (emailBtn) emailBtn.disabled = !emailInput.value.trim();
      });
      emailInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          submitMessengerEmail();
        }
      });
    }

    // OTP step (anon Send-to-Builder phone verification).
    var otpInput = document.getElementById('plrt-messenger-otp-code');
    var otpVerifyBtn = document.getElementById('plrt-messenger-otp-verify-btn');
    var otpWrongBtn = document.getElementById('plrt-messenger-otp-wrong-btn');
    var otpResendEl = document.getElementById('plrt-messenger-otp-resend');
    if (otpVerifyBtn) {
      otpVerifyBtn.addEventListener('click', function(e) { e.preventDefault(); submitMessengerOtp(); });
    }
    if (otpInput) {
      otpInput.addEventListener('input', function() {
        var digits = otpInput.value.replace(/\D/g, '').slice(0, 6);
        if (otpInput.value !== digits) otpInput.value = digits;
        if (otpVerifyBtn) otpVerifyBtn.disabled = digits.length !== 6;
      });
      otpInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); submitMessengerOtp(); }
      });
    }
    if (otpWrongBtn) {
      otpWrongBtn.addEventListener('click', function(e) { e.preventDefault(); messengerWrongNumber(); });
    }
    if (otpResendEl) {
      otpResendEl.addEventListener('click', function() {
        if (otpResendEl.classList.contains('is-ready')) resendMessengerOtp();
      });
    }

    // Name step (asked FIRST, required).
    var nameInput = document.getElementById('plrt-messenger-name-input');
    var nameContinueBtn = document.getElementById('plrt-messenger-name-continue-btn');
    if (nameContinueBtn) {
      nameContinueBtn.addEventListener('click', function(e) { e.preventDefault(); submitMessengerName(); });
    }
    if (nameInput) {
      nameInput.addEventListener('input', function() {
        if (nameContinueBtn) nameContinueBtn.disabled = !nameInput.value.trim();
      });
      nameInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (nameInput.value.trim()) submitMessengerName();
        }
      });
    }
  }

  var urlPreselectionsApplied = false;
  function applyUrlPreselections() {
    if (urlPreselectionsApplied) return;
    urlPreselectionsApplied = true;
    var params = new URLSearchParams(window.location.search);
    var preSpecies = params.get('est_species');
    var preTechnique = params.get('est_technique');
    if (!preSpecies && !preTechnique) return;

    var active = getActiveSteps();
    var skipTo = 0;

    if (preSpecies) {
      var speciesStep = active.find(function(s) { return s.id === 'target_species'; });
      if (speciesStep) {
        var matched = speciesStep.options.find(function(o) {
          var val = typeof o === 'string' ? o : o.value;
          return val.toLowerCase() === preSpecies.toLowerCase();
        });
        if (matched) {
          state.values.target_species = typeof matched === 'string' ? matched : matched.value;
          skipTo = 1;
        }
      }
    }

    if (preTechnique) {
      var techStep = active.find(function(s) { return s.id === 'technique'; });
      if (techStep) {
        var matched = techStep.options.find(function(o) {
          var val = typeof o === 'string' ? o : o.value;
          return val.toLowerCase() === preTechnique.toLowerCase();
        });
        if (matched) {
          state.values.technique = typeof matched === 'string' ? matched : matched.value;
          if (skipTo >= 1) skipTo = 2;
        }
      }
    }

    if (skipTo > 0) {
      state.currentStep = Math.min(skipTo, active.length - 1);
    }
  }

  function init() {
    pushEvent('estimator_page_view', {});


    if (openBtn) openBtn.addEventListener('click', function() {
      var fisheryField = document.getElementById('plrt-build-fishery-id');
      var regionField = document.getElementById('plrt-build-region');
      if (fisheryField) fisheryField.value = fisheryAttribution.fishery_id;
      if (regionField) regionField.value = fisheryAttribution.region;
      applyUrlPreselections();
      openModal();
    });
    document.addEventListener('prolite:open-estimator', function(e) {
      if (e.detail) {
        if (e.detail.fishery_id && SECTION_DEFAULT_FISHERY === 'inherit') {
          fisheryAttribution.fishery_id = e.detail.fishery_id;
        }
        if (e.detail.region) fisheryAttribution.region = e.detail.region;
        if (e.detail.target_species) state.values.target_species = e.detail.target_species;
        if (e.detail.fishery_name)   state.values._fishery_name  = e.detail.fishery_name;
      }
      var fisheryField = document.getElementById('plrt-build-fishery-id');
      var regionField = document.getElementById('plrt-build-region');
      if (fisheryField) fisheryField.value = fisheryAttribution.fishery_id;
      if (regionField) regionField.value = fisheryAttribution.region;
      applyUrlPreselections();
      openModal();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeModal();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        closeModal();
      }
      if (e.key === 'Tab' && overlay.classList.contains('is-open')) {
        trapFocus(e);
      }
    });

    if (redoBtn) {
      redoBtn.addEventListener('click', function() {
        state.currentStep = 0;
        state.values = {};
        state.selectedRange = null;
        state.estimateResult = null;
        state.activePanel = null; // full restart — don't resume a stale panel
        state.estimateCompleted = false; // restart → back to normal first-pass auto-advance
        sessionStorage.removeItem('prolite_quote_estimate_id_v2');
        openModal();
      });
    }

    var changeBtn = document.getElementById('plrt-est-change-btn');
    if (changeBtn) {
      changeBtn.addEventListener('click', function() {
        var active = getActiveSteps();
        if (active.length === 0) return;
        state.currentStep = active.length - 1;
        state.selectedRange = null;
        showModalPanel('');
        rightPanel.style.display = '';
        renderStep();
        pushEvent('estimator_change_answers', { from_step: active.length });
      });
    }

    initFormHandlers();
    initBuildForm();
    initMessenger();

    var doneBtn = document.getElementById('plrt-est-done-btn');
    if (doneBtn) {
      doneBtn.addEventListener('click', function() {
        closeModal();
        showModalPanel(''); // hide all panels
        rightPanel.style.display = '';
      });
    }

    var notesToggle = document.getElementById('plrt-est-notes-toggle');
    var notesField = document.getElementById('plrt-est-notes-field');
    if (notesToggle && notesField) {
      notesToggle.addEventListener('click', function() {
        var visible = notesField.style.display !== 'none';
        notesField.style.display = visible ? 'none' : 'block';
        notesToggle.textContent = visible ? '+ Add a note about your build' : '\u2212 Hide note';
        if (!visible) {
          var ta = document.getElementById('plrt-est-build-notes');
          if (ta) ta.focus();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
